/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppAuthedRouteImport } from './routes/_app/_authed'
import { Route as GrowerAreasIdRouteImport } from './routes/grower-areas.$id'
import { Route as TraceCodeRouteImport } from './routes/trace.$code'
import { Route as AppAuthedSidebarRouteImport } from './routes/_app/_authed/_sidebar'
import { Route as AppAuthedCustomerDisplayRouteImport } from './routes/_app/_authed/customer-display'
import { Route as AppAuthedSaleRouteImport } from './routes/_app/_authed/sale'
import { Route as AppAuthedStationRouteImport } from './routes/_app/_authed/station'
import { Route as AppAuthedSidebarIndexRouteImport } from './routes/_app/_authed/_sidebar/index'
import { Route as AppAuthedSidebarAgricultureRouteRouteImport } from './routes/_app/_authed/_sidebar/agriculture/route'
import { Route as AppAuthedSidebarDevPlaygroundRouteImport } from './routes/_app/_authed/_sidebar/dev-playground'
import { Route as AppAuthedSidebarKiotvietOrdersRouteImport } from './routes/_app/_authed/_sidebar/kiotviet-orders'
import { Route as AppAuthedSidebarRetailRouteRouteImport } from './routes/_app/_authed/_sidebar/retail/route'
import { Route as AppAuthedSidebarTeaMachinesRouteImport } from './routes/_app/_authed/_sidebar/tea-machines'
import { Route as AppAuthedSidebarTrackingRouteImport } from './routes/_app/_authed/_sidebar/tracking'
import { Route as AppAuthedSidebarWarehouseStatsRouteImport } from './routes/_app/_authed/_sidebar/warehouse-stats'
import { Route as AppAuthedSidebarWhatsNewRouteImport } from './routes/_app/_authed/_sidebar/whats-new'
import { Route as AppAuthedSaleIndexRouteImport } from './routes/_app/_authed/sale.index'
import { Route as AppAuthedSaleDisplayRouteImport } from './routes/_app/_authed/sale.display'
import { Route as AppAuthedStationProductionRouteImport } from './routes/_app/_authed/station_.production'
import { Route as AppAuthedStationWarehouseRouteImport } from './routes/_app/_authed/station_.warehouse'
import { Route as AppSettingsZaloCallbackRouteImport } from './routes/_app/settings.zalo.callback'
import { Route as AppAuthedSidebarAccountingIndexRouteImport } from './routes/_app/_authed/_sidebar/accounting/index'
import { Route as AppAuthedSidebarAccountingCashFlowRouteImport } from './routes/_app/_authed/_sidebar/accounting/cash-flow'
import { Route as AppAuthedSidebarAccountingExpenseCategoriesRouteImport } from './routes/_app/_authed/_sidebar/accounting/expense-categories'
import { Route as AppAuthedSidebarAccountingExpenseRulesRouteImport } from './routes/_app/_authed/_sidebar/accounting/expense-rules'
import { Route as AppAuthedSidebarAccountingExpenseSyncRouteImport } from './routes/_app/_authed/_sidebar/accounting/expense-sync'
import { Route as AppAuthedSidebarAccountingExpensesRouteImport } from './routes/_app/_authed/_sidebar/accounting/expenses'
import { Route as AppAuthedSidebarAccountingGrowerPaymentsRouteImport } from './routes/_app/_authed/_sidebar/accounting/grower-payments'
import { Route as AppAuthedSidebarAccountingReconciliationRouteImport } from './routes/_app/_authed/_sidebar/accounting/reconciliation'
import { Route as AppAuthedSidebarAccountingRemittancesRouteImport } from './routes/_app/_authed/_sidebar/accounting/remittances'
import { Route as AppAuthedSidebarAgriculturalMaterialsIndexRouteImport } from './routes/_app/_authed/_sidebar/agricultural-materials/index'
import { Route as AppAuthedSidebarAgriculturalMaterialsStatsRouteImport } from './routes/_app/_authed/_sidebar/agricultural-materials/stats'
import { Route as AppAuthedSidebarAgricultureAreaMapRouteImport } from './routes/_app/_authed/_sidebar/agriculture/area-map'
import { Route as AppAuthedSidebarAgricultureCamerasRouteImport } from './routes/_app/_authed/_sidebar/agriculture/cameras'
import { Route as AppAuthedSidebarAgricultureCareLogsRouteImport } from './routes/_app/_authed/_sidebar/agriculture/care-logs'
import { Route as AppAuthedSidebarAgricultureCareRemindersRouteImport } from './routes/_app/_authed/_sidebar/agriculture/care-reminders'
import { Route as AppAuthedSidebarAgricultureGrowersRouteImport } from './routes/_app/_authed/_sidebar/agriculture/growers'
import { Route as AppAuthedSidebarAgricultureIrrigationDevicesRouteImport } from './routes/_app/_authed/_sidebar/agriculture/irrigation-devices'
import { Route as AppAuthedSidebarAgricultureMyReportsRouteImport } from './routes/_app/_authed/_sidebar/agriculture/my-reports'
import { Route as AppAuthedSidebarAgricultureMyWeighingsRouteImport } from './routes/_app/_authed/_sidebar/agriculture/my-weighings'
import { Route as AppAuthedSidebarAgricultureTeaTypesRouteImport } from './routes/_app/_authed/_sidebar/agriculture/tea-types'
import { Route as AppAuthedSidebarApiKeysIndexRouteImport } from './routes/_app/_authed/_sidebar/api-keys/index'
import { Route as AppAuthedSidebarContractDeliveriesIndexRouteImport } from './routes/_app/_authed/_sidebar/contract-deliveries/index'
import { Route as AppAuthedSidebarContractDeliveriesIdRouteImport } from './routes/_app/_authed/_sidebar/contract-deliveries/$id'
import { Route as AppAuthedSidebarContractDeliveriesNewRouteImport } from './routes/_app/_authed/_sidebar/contract-deliveries/new'
import { Route as AppAuthedSidebarCustomersIndexRouteImport } from './routes/_app/_authed/_sidebar/customers/index'
import { Route as AppAuthedSidebarCustomersCustomerIdRouteImport } from './routes/_app/_authed/_sidebar/customers/$customerId'
import { Route as AppAuthedSidebarCustomersNewRouteImport } from './routes/_app/_authed/_sidebar/customers/new'
import { Route as AppAuthedSidebarDeliveryTripsIndexRouteImport } from './routes/_app/_authed/_sidebar/delivery-trips.index'
import { Route as AppAuthedSidebarDeliveryTripsIdRouteImport } from './routes/_app/_authed/_sidebar/delivery-trips.$id'
import { Route as AppAuthedSidebarDriedTeaPurchasesIndexRouteImport } from './routes/_app/_authed/_sidebar/dried-tea-purchases/index'
import { Route as AppAuthedSidebarDriedTeaPurchasesIdRouteImport } from './routes/_app/_authed/_sidebar/dried-tea-purchases/$id'
import { Route as AppAuthedSidebarDriverAvailableOrdersRouteImport } from './routes/_app/_authed/_sidebar/driver/available-orders'
import { Route as AppAuthedSidebarDriverCashRouteImport } from './routes/_app/_authed/_sidebar/driver/cash'
import { Route as AppAuthedSidebarLogisticsShippingCarriersRouteImport } from './routes/_app/_authed/_sidebar/logistics/shipping-carriers'
import { Route as AppAuthedSidebarLogisticsVtpOverdueRouteImport } from './routes/_app/_authed/_sidebar/logistics/vtp-overdue'
import { Route as AppAuthedSidebarOrdersIndexRouteImport } from './routes/_app/_authed/_sidebar/orders/index'
import { Route as AppAuthedSidebarOrdersOrderIdRouteImport } from './routes/_app/_authed/_sidebar/orders/$orderId'
import { Route as AppAuthedSidebarOrdersNewRouteImport } from './routes/_app/_authed/_sidebar/orders/new'
import { Route as AppAuthedSidebarOrdersQuickRouteImport } from './routes/_app/_authed/_sidebar/orders/quick'
import { Route as AppAuthedSidebarPackagingWarehouseStatsRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/stats'
import { Route as AppAuthedSidebarPackagingIndexRouteImport } from './routes/_app/_authed/_sidebar/packaging/index'
import { Route as AppAuthedSidebarProductsIndexRouteImport } from './routes/_app/_authed/_sidebar/products/index'
import { Route as AppAuthedSidebarProductsProductIdRouteImport } from './routes/_app/_authed/_sidebar/products/$productId'
import { Route as AppAuthedSidebarProductsCategoriesRouteImport } from './routes/_app/_authed/_sidebar/products/categories'
import { Route as AppAuthedSidebarProductsCertificationBadgesRouteImport } from './routes/_app/_authed/_sidebar/products/certification-badges'
import { Route as AppAuthedSidebarProductsKiotvietMappingRouteImport } from './routes/_app/_authed/_sidebar/products/kiotviet-mapping'
import { Route as AppAuthedSidebarProductsNewRouteImport } from './routes/_app/_authed/_sidebar/products/new'
import { Route as AppAuthedSidebarProductsOnlinePricesRouteImport } from './routes/_app/_authed/_sidebar/products/online-prices'
import { Route as AppAuthedSidebarReportsIndexRouteImport } from './routes/_app/_authed/_sidebar/reports/index'
import { Route as AppAuthedSidebarReportsCareLogsRouteImport } from './routes/_app/_authed/_sidebar/reports/care-logs'
import { Route as AppAuthedSidebarReportsCashbookRouteImport } from './routes/_app/_authed/_sidebar/reports/cashbook'
import { Route as AppAuthedSidebarReportsDebtsRouteImport } from './routes/_app/_authed/_sidebar/reports/debts'
import { Route as AppAuthedSidebarReportsDeliveryRouteImport } from './routes/_app/_authed/_sidebar/reports/delivery'
import { Route as AppAuthedSidebarReportsExpensesRouteImport } from './routes/_app/_authed/_sidebar/reports/expenses'
import { Route as AppAuthedSidebarReportsGeographyRouteImport } from './routes/_app/_authed/_sidebar/reports/geography'
import { Route as AppAuthedSidebarReportsGrowersRouteImport } from './routes/_app/_authed/_sidebar/reports/growers'
import { Route as AppAuthedSidebarReportsInventoryRouteImport } from './routes/_app/_authed/_sidebar/reports/inventory'
import { Route as AppAuthedSidebarReportsPositionsRouteImport } from './routes/_app/_authed/_sidebar/reports/positions'
import { Route as AppAuthedSidebarReportsRevenueRouteImport } from './routes/_app/_authed/_sidebar/reports/revenue'
import { Route as AppAuthedSidebarReportsSalesRouteImport } from './routes/_app/_authed/_sidebar/reports/sales'
import { Route as AppAuthedSidebarReportsScentingStockRouteImport } from './routes/_app/_authed/_sidebar/reports/scenting-stock'
import { Route as AppAuthedSidebarReportsSortingStockRouteImport } from './routes/_app/_authed/_sidebar/reports/sorting-stock'
import { Route as AppAuthedSidebarReportsStaffRouteImport } from './routes/_app/_authed/_sidebar/reports/staff'
import { Route as AppAuthedSidebarReportsStockOutRouteImport } from './routes/_app/_authed/_sidebar/reports/stock-out'
import { Route as AppAuthedSidebarReportsWebsiteRouteImport } from './routes/_app/_authed/_sidebar/reports/website'
import { Route as AppAuthedSidebarReportsYieldLossRouteImport } from './routes/_app/_authed/_sidebar/reports/yield-loss'
import { Route as AppAuthedSidebarReportsZaloMiniAppRouteImport } from './routes/_app/_authed/_sidebar/reports/zalo-mini-app'
import { Route as AppAuthedSidebarRetailCategoriesRouteImport } from './routes/_app/_authed/_sidebar/retail/categories'
import { Route as AppAuthedSidebarRetailContactRouteImport } from './routes/_app/_authed/_sidebar/retail/contact'
import { Route as AppAuthedSidebarRetailGuideVideosRouteImport } from './routes/_app/_authed/_sidebar/retail/guide-videos'
import { Route as AppAuthedSidebarRetailHomeRouteImport } from './routes/_app/_authed/_sidebar/retail/home'
import { Route as AppAuthedSidebarRetailMediaRouteImport } from './routes/_app/_authed/_sidebar/retail/media'
import { Route as AppAuthedSidebarRetailMemberTiersRouteImport } from './routes/_app/_authed/_sidebar/retail/member-tiers'
import { Route as AppAuthedSidebarRetailOnlinePricesRouteImport } from './routes/_app/_authed/_sidebar/retail/online-prices'
import { Route as AppAuthedSidebarRetailPostCategoriesRouteImport } from './routes/_app/_authed/_sidebar/retail/post-categories'
import { Route as AppAuthedSidebarRetailSiteSettingsRouteImport } from './routes/_app/_authed/_sidebar/retail/site-settings'
import { Route as AppAuthedSidebarScentingWarehouseGradesRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/grades'
import { Route as AppAuthedSidebarScentingWarehouseStatsRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/stats'
import { Route as AppAuthedSidebarSettingsFaceRecognitionRouteImport } from './routes/_app/_authed/_sidebar/settings/face-recognition'
import { Route as AppAuthedSidebarSettingsInvoiceRouteImport } from './routes/_app/_authed/_sidebar/settings/invoice'
import { Route as AppAuthedSidebarSettingsLotSizesRouteImport } from './routes/_app/_authed/_sidebar/settings/lot-sizes'
import { Route as AppAuthedSidebarSettingsNotificationsRouteImport } from './routes/_app/_authed/_sidebar/settings/notifications'
import { Route as AppAuthedSidebarSettingsPrintingRouteImport } from './routes/_app/_authed/_sidebar/settings/printing'
import { Route as AppAuthedSidebarSettingsProductionStationVoiceRouteImport } from './routes/_app/_authed/_sidebar/settings/production-station-voice'
import { Route as AppAuthedSidebarSettingsSidebarLayoutRouteImport } from './routes/_app/_authed/_sidebar/settings/sidebar-layout'
import { Route as AppAuthedSidebarSettingsSlaRouteImport } from './routes/_app/_authed/_sidebar/settings/sla'
import { Route as AppAuthedSidebarSettingsStationVoiceRouteImport } from './routes/_app/_authed/_sidebar/settings/station-voice'
import { Route as AppAuthedSidebarSettingsWarehouseStationVoiceRouteImport } from './routes/_app/_authed/_sidebar/settings/warehouse-station-voice'
import { Route as AppAuthedSidebarSettingsZaloRouteImport } from './routes/_app/_authed/_sidebar/settings/zalo'
import { Route as AppAuthedSidebarSmartlabIndexRouteImport } from './routes/_app/_authed/_sidebar/smartlab/index'
import { Route as AppAuthedSidebarSortingWarehouseStatsRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/stats'
import { Route as AppAuthedSidebarSortingWarehouseTeaGradesRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/tea-grades'
import { Route as AppAuthedSidebarStocktakeIndexRouteImport } from './routes/_app/_authed/_sidebar/stocktake/index'
import { Route as AppAuthedSidebarStocktakeIdRouteImport } from './routes/_app/_authed/_sidebar/stocktake/$id'
import { Route as AppAuthedSidebarStocktakeNewRouteImport } from './routes/_app/_authed/_sidebar/stocktake/new'
import { Route as AppAuthedSidebarTeaPurchasesIndexRouteImport } from './routes/_app/_authed/_sidebar/tea-purchases/index'
import { Route as AppAuthedSidebarTeaPurchasesIdRouteImport } from './routes/_app/_authed/_sidebar/tea-purchases/$id'
import { Route as AppAuthedSidebarTeaPurchasesProcessingRouteImport } from './routes/_app/_authed/_sidebar/tea-purchases/processing'
import { Route as AppAuthedSidebarUsersIndexRouteImport } from './routes/_app/_authed/_sidebar/users/index'
import { Route as AppAuthedSidebarVehiclesIndexRouteImport } from './routes/_app/_authed/_sidebar/vehicles/index'
import { Route as AppAuthedSidebarVehiclesVehicleIdRouteImport } from './routes/_app/_authed/_sidebar/vehicles/$vehicleId'
import { Route as AppAuthedSidebarWarehousePositionsIndexRouteImport } from './routes/_app/_authed/_sidebar/warehouse-positions/index'
import { Route as AppAuthedSidebarWarehousePositionsIdRouteImport } from './routes/_app/_authed/_sidebar/warehouse-positions/$id'
import { Route as AppAuthedSidebarWarehousePositionsNewRouteImport } from './routes/_app/_authed/_sidebar/warehouse-positions/new'
import { Route as AppAuthedSidebarWarehouseSalesDashboardRouteImport } from './routes/_app/_authed/_sidebar/warehouse-sales/dashboard'
import { Route as AppAuthedSidebarWarehouseSalesDefectsRouteImport } from './routes/_app/_authed/_sidebar/warehouse-sales/defects'
import { Route as AppAuthedSidebarWarehouseSalesStatsRouteImport } from './routes/_app/_authed/_sidebar/warehouse-sales/stats'
import { Route as AppAuthedSidebarWorkActivitiesBoardRouteImport } from './routes/_app/_authed/_sidebar/work-activities/board'
import { Route as AppAuthedSidebarWorkActivitiesCalendarRouteImport } from './routes/_app/_authed/_sidebar/work-activities/calendar'
import { Route as AppAuthedSidebarWorkActivitiesGuestsRouteImport } from './routes/_app/_authed/_sidebar/work-activities/guests'
import { Route as AppAuthedSupportTRefRouteImport } from './routes/_app/_authed/support.t.$ref'
import { Route as AppAuthedSidebarAccountingReportsDailyRouteImport } from './routes/_app/_authed/_sidebar/accounting/reports/daily'
import { Route as AppAuthedSidebarAgriculturalMaterialsLotsIndexRouteImport } from './routes/_app/_authed/_sidebar/agricultural-materials/lots/index'
import { Route as AppAuthedSidebarAgriculturalMaterialsLotsIdRouteImport } from './routes/_app/_authed/_sidebar/agricultural-materials/lots/$id'
import { Route as AppAuthedSidebarAgriculturalMaterialsStockInNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/agricultural-materials/stock-in-notes/index'
import { Route as AppAuthedSidebarAgriculturalMaterialsStockInNotesIdRouteImport } from './routes/_app/_authed/_sidebar/agricultural-materials/stock-in-notes/$id'
import { Route as AppAuthedSidebarAgriculturalMaterialsStockInNotesNewRouteImport } from './routes/_app/_authed/_sidebar/agricultural-materials/stock-in-notes/new'
import { Route as AppAuthedSidebarAgriculturalMaterialsStockOutNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/agricultural-materials/stock-out-notes/index'
import { Route as AppAuthedSidebarAgriculturalMaterialsStockOutNotesIdRouteImport } from './routes/_app/_authed/_sidebar/agricultural-materials/stock-out-notes/$id'
import { Route as AppAuthedSidebarAgriculturalMaterialsStockOutNotesNewRouteImport } from './routes/_app/_authed/_sidebar/agricultural-materials/stock-out-notes/new'
import { Route as AppAuthedSidebarAgricultureCareLogsIndexRouteImport } from './routes/_app/_authed/_sidebar/agriculture/care-logs.index'
import { Route as AppAuthedSidebarAgricultureCareLogsNewRouteImport } from './routes/_app/_authed/_sidebar/agriculture/care-logs.new'
import { Route as AppAuthedSidebarAgricultureGrowersIndexRouteImport } from './routes/_app/_authed/_sidebar/agriculture/growers.index'
import { Route as AppAuthedSidebarAgricultureGrowersIdRouteImport } from './routes/_app/_authed/_sidebar/agriculture/growers.$id'
import { Route as AppAuthedSidebarAgricultureGrowersNewRouteImport } from './routes/_app/_authed/_sidebar/agriculture/growers.new'
import { Route as AppAuthedSidebarAgricultureMyGrowerIndexRouteImport } from './routes/_app/_authed/_sidebar/agriculture/my-grower.index'
import { Route as AppAuthedSidebarAgricultureMyGrowerGrowerIdRouteImport } from './routes/_app/_authed/_sidebar/agriculture/my-grower.$growerId'
import { Route as AppAuthedSidebarCustomersGroupsIndexRouteImport } from './routes/_app/_authed/_sidebar/customers/groups/index'
import { Route as AppAuthedSidebarCustomersGroupsGroupIdRouteImport } from './routes/_app/_authed/_sidebar/customers/groups/$groupId'
import { Route as AppAuthedSidebarOrganizationDepartmentsIndexRouteImport } from './routes/_app/_authed/_sidebar/organization/departments/index'
import { Route as AppAuthedSidebarOrganizationEmployeesIndexRouteImport } from './routes/_app/_authed/_sidebar/organization/employees/index'
import { Route as AppAuthedSidebarPackagingWarehouseCountLogIndexRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/count-log/index'
import { Route as AppAuthedSidebarPackagingWarehouseLotsIndexRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/lots/index'
import { Route as AppAuthedSidebarPackagingWarehouseLotsIdRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/lots/$id'
import { Route as AppAuthedSidebarPackagingWarehouseStockInNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/index'
import { Route as AppAuthedSidebarPackagingWarehouseStockInNotesIdRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/$id'
import { Route as AppAuthedSidebarPackagingWarehouseStockInNotesNewRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/new'
import { Route as AppAuthedSidebarPackagingWarehouseStockOutNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/index'
import { Route as AppAuthedSidebarPackagingWarehouseStockOutNotesIdRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/$id'
import { Route as AppAuthedSidebarPackagingWarehouseStockOutNotesNewRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/new'
import { Route as AppAuthedSidebarPackagingWarehouseWithdrawalNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/index'
import { Route as AppAuthedSidebarPackagingWarehouseWithdrawalNotesIdRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/$id'
import { Route as AppAuthedSidebarPackagingWarehouseWithdrawalNotesNewRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/new'
import { Route as AppAuthedSidebarRetailAccountsIndexRouteImport } from './routes/_app/_authed/_sidebar/retail/accounts/index'
import { Route as AppAuthedSidebarRetailAccountsAccountIdRouteImport } from './routes/_app/_authed/_sidebar/retail/accounts/$accountId'
import { Route as AppAuthedSidebarRetailGroupsIndexRouteImport } from './routes/_app/_authed/_sidebar/retail/groups/index'
import { Route as AppAuthedSidebarRetailGroupsGroupIdRouteImport } from './routes/_app/_authed/_sidebar/retail/groups/$groupId'
import { Route as AppAuthedSidebarRetailGroupsNewRouteImport } from './routes/_app/_authed/_sidebar/retail/groups/new'
import { Route as AppAuthedSidebarRetailPagesIndexRouteImport } from './routes/_app/_authed/_sidebar/retail/pages/index'
import { Route as AppAuthedSidebarRetailPagesPageIdRouteImport } from './routes/_app/_authed/_sidebar/retail/pages/$pageId'
import { Route as AppAuthedSidebarRetailPagesNewRouteImport } from './routes/_app/_authed/_sidebar/retail/pages/new'
import { Route as AppAuthedSidebarRetailPostsIndexRouteImport } from './routes/_app/_authed/_sidebar/retail/posts/index'
import { Route as AppAuthedSidebarRetailPostsPostIdRouteImport } from './routes/_app/_authed/_sidebar/retail/posts/$postId'
import { Route as AppAuthedSidebarRetailPostsNewRouteImport } from './routes/_app/_authed/_sidebar/retail/posts/new'
import { Route as AppAuthedSidebarSalesWarehouseBoxLogIndexRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/box-log/index'
import { Route as AppAuthedSidebarSalesWarehouseLotsIndexRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/lots/index'
import { Route as AppAuthedSidebarSalesWarehouseLotsIdRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/lots/$id'
import { Route as AppAuthedSidebarSalesWarehouseOtherLogIndexRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/other-log/index'
import { Route as AppAuthedSidebarSalesWarehousePackagingLogIndexRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/packaging-log/index'
import { Route as AppAuthedSidebarSalesWarehouseStockInNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/index'
import { Route as AppAuthedSidebarSalesWarehouseStockInNotesIdRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/$id'
import { Route as AppAuthedSidebarSalesWarehouseStockInNotesNewRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/new'
import { Route as AppAuthedSidebarSalesWarehouseStockInNotesQuickRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/quick'
import { Route as AppAuthedSidebarSalesWarehouseStockOutNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/index'
import { Route as AppAuthedSidebarSalesWarehouseStockOutNotesIdRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/$id'
import { Route as AppAuthedSidebarSalesWarehouseStockOutNotesNewRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/new'
import { Route as AppAuthedSidebarSalesWarehouseTransferNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/transfer-notes/index'
import { Route as AppAuthedSidebarSalesWarehouseTransferNotesIdRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/transfer-notes/$id'
import { Route as AppAuthedSidebarSalesWarehouseTransferNotesNewRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/transfer-notes/new'
import { Route as AppAuthedSidebarScentingWarehouseLogIndexRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/log/index'
import { Route as AppAuthedSidebarScentingWarehouseLotsIndexRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/lots/index'
import { Route as AppAuthedSidebarScentingWarehouseLotsIdRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/lots/$id'
import { Route as AppAuthedSidebarScentingWarehouseStockInNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/index'
import { Route as AppAuthedSidebarScentingWarehouseStockInNotesIdRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/$id'
import { Route as AppAuthedSidebarScentingWarehouseStockInNotesNewRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/new'
import { Route as AppAuthedSidebarScentingWarehouseStockOutNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/index'
import { Route as AppAuthedSidebarScentingWarehouseStockOutNotesIdRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/$id'
import { Route as AppAuthedSidebarScentingWarehouseStockOutNotesNewRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/new'
import { Route as AppAuthedSidebarScentingWarehouseWithdrawalNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/index'
import { Route as AppAuthedSidebarScentingWarehouseWithdrawalNotesIdRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/$id'
import { Route as AppAuthedSidebarScentingWarehouseWithdrawalNotesNewRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/new'
import { Route as AppAuthedSidebarSettingsRolesIndexRouteImport } from './routes/_app/_authed/_sidebar/settings/roles.index'
import { Route as AppAuthedSidebarSettingsRolesIdRouteImport } from './routes/_app/_authed/_sidebar/settings/roles.$id'
import { Route as AppAuthedSidebarSettingsZaloIndexRouteImport } from './routes/_app/_authed/_sidebar/settings/zalo.index'
import { Route as AppAuthedSidebarSettingsZaloMessagesRouteImport } from './routes/_app/_authed/_sidebar/settings/zalo.messages'
import { Route as AppAuthedSidebarSettingsZaloPurposesRouteImport } from './routes/_app/_authed/_sidebar/settings/zalo.purposes'
import { Route as AppAuthedSidebarSortingWarehouseLotsIndexRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/lots/index'
import { Route as AppAuthedSidebarSortingWarehouseLotsIdRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/lots/$id'
import { Route as AppAuthedSidebarSortingWarehouseStockInNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/index'
import { Route as AppAuthedSidebarSortingWarehouseStockInNotesIdRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/$id'
import { Route as AppAuthedSidebarSortingWarehouseStockInNotesNewRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/new'
import { Route as AppAuthedSidebarSortingWarehouseStockOutNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/index'
import { Route as AppAuthedSidebarSortingWarehouseStockOutNotesIdRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/$id'
import { Route as AppAuthedSidebarSortingWarehouseStockOutNotesNewRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/new'
import { Route as AppAuthedSidebarSortingWarehouseWithdrawalNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/index'
import { Route as AppAuthedSidebarSortingWarehouseWithdrawalNotesIdRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/$id'
import { Route as AppAuthedSidebarSortingWarehouseWithdrawalNotesNewRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/new'
import { Route as AppAuthedSidebarAgriculturalMaterialsStockInNotesIdEditRouteImport } from './routes/_app/_authed/_sidebar/agricultural-materials/stock-in-notes/$id_.edit'
import { Route as AppAuthedSidebarAgriculturalMaterialsStockOutNotesIdEditRouteImport } from './routes/_app/_authed/_sidebar/agricultural-materials/stock-out-notes/$id_.edit'
import { Route as AppAuthedSidebarAgricultureCareLogsIdEditRouteImport } from './routes/_app/_authed/_sidebar/agriculture/care-logs.$id.edit'
import { Route as AppAuthedSidebarAgricultureGrowersIdEditRouteImport } from './routes/_app/_authed/_sidebar/agriculture/growers.$id_.edit'
import { Route as AppAuthedSidebarPackagingWarehouseStockInNotesIdEditRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/$id_.edit'
import { Route as AppAuthedSidebarPackagingWarehouseStockOutNotesIdEditRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/$id_.edit'
import { Route as AppAuthedSidebarSalesWarehouseStockInNotesIdEditRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/$id_.edit'
import { Route as AppAuthedSidebarSalesWarehouseStockOutNotesIdEditRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/$id_.edit'
import { Route as AppAuthedSidebarSalesWarehouseTransferNotesIdEditRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/transfer-notes/$id_.edit'
import { Route as AppAuthedSidebarScentingWarehouseStockInNotesIdEditRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/$id_.edit'
import { Route as AppAuthedSidebarScentingWarehouseStockOutNotesIdEditRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/$id_.edit'
import { Route as AppAuthedSidebarSettingsZaloTemplatesIndexRouteImport } from './routes/_app/_authed/_sidebar/settings/zalo.templates.index'
import { Route as AppAuthedSidebarSettingsZaloTemplatesIdRouteImport } from './routes/_app/_authed/_sidebar/settings/zalo.templates.$id'
import { Route as AppAuthedSidebarSortingWarehouseStockInNotesIdEditRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/$id_.edit'
import { Route as AppAuthedSidebarSortingWarehouseStockOutNotesIdEditRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/$id_.edit'
import { Route as AppAuthedSidebarAgricultureGrowersIdFacesIndexRouteImport } from './routes/_app/_authed/_sidebar/agriculture/growers.$id_.faces.index'
import { Route as AppAuthedSidebarAgricultureGrowersIdFacesFaceIdRouteImport } from './routes/_app/_authed/_sidebar/agriculture/growers.$id_.faces.$faceId'
import { Route as AppAuthedSidebarAgricultureMyGrowerGrowerIdFacesIndexRouteImport } from './routes/_app/_authed/_sidebar/agriculture/my-grower.$growerId_.faces.index'
import { Route as AppAuthedSidebarAgricultureMyGrowerGrowerIdFacesFaceIdRouteImport } from './routes/_app/_authed/_sidebar/agriculture/my-grower.$growerId_.faces.$faceId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAuthedRoute = AppAuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => AppRoute,
} as any)
const GrowerAreasIdRoute = GrowerAreasIdRouteImport.update({
  id: '/grower-areas/$id',
  path: '/grower-areas/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const TraceCodeRoute = TraceCodeRouteImport.update({
  id: '/trace/$code',
  path: '/trace/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAuthedSidebarRoute = AppAuthedSidebarRouteImport.update({
  id: '/_sidebar',
  getParentRoute: () => AppAuthedRoute,
} as any)
const AppAuthedCustomerDisplayRoute =
  AppAuthedCustomerDisplayRouteImport.update({
    id: '/customer-display',
    path: '/customer-display',
    getParentRoute: () => AppAuthedRoute,
  } as any)
const AppAuthedSaleRoute = AppAuthedSaleRouteImport.update({
  id: '/sale',
  path: '/sale',
  getParentRoute: () => AppAuthedRoute,
} as any)
const AppAuthedStationRoute = AppAuthedStationRouteImport.update({
  id: '/station',
  path: '/station',
  getParentRoute: () => AppAuthedRoute,
} as any)
const AppAuthedSidebarIndexRoute = AppAuthedSidebarIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAuthedSidebarRoute,
} as any)
const AppAuthedSidebarAgricultureRouteRoute =
  AppAuthedSidebarAgricultureRouteRouteImport.update({
    id: '/agriculture',
    path: '/agriculture',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarDevPlaygroundRoute =
  AppAuthedSidebarDevPlaygroundRouteImport.update({
    id: '/dev-playground',
    path: '/dev-playground',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarKiotvietOrdersRoute =
  AppAuthedSidebarKiotvietOrdersRouteImport.update({
    id: '/kiotviet-orders',
    path: '/kiotviet-orders',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarRetailRouteRoute =
  AppAuthedSidebarRetailRouteRouteImport.update({
    id: '/retail',
    path: '/retail',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarTeaMachinesRoute =
  AppAuthedSidebarTeaMachinesRouteImport.update({
    id: '/tea-machines',
    path: '/tea-machines',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarTrackingRoute =
  AppAuthedSidebarTrackingRouteImport.update({
    id: '/tracking',
    path: '/tracking',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarWarehouseStatsRoute =
  AppAuthedSidebarWarehouseStatsRouteImport.update({
    id: '/warehouse-stats',
    path: '/warehouse-stats',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarWhatsNewRoute =
  AppAuthedSidebarWhatsNewRouteImport.update({
    id: '/whats-new',
    path: '/whats-new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSaleIndexRoute = AppAuthedSaleIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAuthedSaleRoute,
} as any)
const AppAuthedSaleDisplayRoute = AppAuthedSaleDisplayRouteImport.update({
  id: '/display',
  path: '/display',
  getParentRoute: () => AppAuthedSaleRoute,
} as any)
const AppAuthedStationProductionRoute =
  AppAuthedStationProductionRouteImport.update({
    id: '/station_/production',
    path: '/station/production',
    getParentRoute: () => AppAuthedRoute,
  } as any)
const AppAuthedStationWarehouseRoute =
  AppAuthedStationWarehouseRouteImport.update({
    id: '/station_/warehouse',
    path: '/station/warehouse',
    getParentRoute: () => AppAuthedRoute,
  } as any)
const AppSettingsZaloCallbackRoute = AppSettingsZaloCallbackRouteImport.update({
  id: '/settings/zalo/callback',
  path: '/settings/zalo/callback',
  getParentRoute: () => AppRoute,
} as any)
const AppAuthedSidebarAccountingIndexRoute =
  AppAuthedSidebarAccountingIndexRouteImport.update({
    id: '/accounting/',
    path: '/accounting/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAccountingCashFlowRoute =
  AppAuthedSidebarAccountingCashFlowRouteImport.update({
    id: '/accounting/cash-flow',
    path: '/accounting/cash-flow',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAccountingExpenseCategoriesRoute =
  AppAuthedSidebarAccountingExpenseCategoriesRouteImport.update({
    id: '/accounting/expense-categories',
    path: '/accounting/expense-categories',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAccountingExpenseRulesRoute =
  AppAuthedSidebarAccountingExpenseRulesRouteImport.update({
    id: '/accounting/expense-rules',
    path: '/accounting/expense-rules',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAccountingExpenseSyncRoute =
  AppAuthedSidebarAccountingExpenseSyncRouteImport.update({
    id: '/accounting/expense-sync',
    path: '/accounting/expense-sync',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAccountingExpensesRoute =
  AppAuthedSidebarAccountingExpensesRouteImport.update({
    id: '/accounting/expenses',
    path: '/accounting/expenses',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAccountingGrowerPaymentsRoute =
  AppAuthedSidebarAccountingGrowerPaymentsRouteImport.update({
    id: '/accounting/grower-payments',
    path: '/accounting/grower-payments',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAccountingReconciliationRoute =
  AppAuthedSidebarAccountingReconciliationRouteImport.update({
    id: '/accounting/reconciliation',
    path: '/accounting/reconciliation',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAccountingRemittancesRoute =
  AppAuthedSidebarAccountingRemittancesRouteImport.update({
    id: '/accounting/remittances',
    path: '/accounting/remittances',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAgriculturalMaterialsIndexRoute =
  AppAuthedSidebarAgriculturalMaterialsIndexRouteImport.update({
    id: '/agricultural-materials/',
    path: '/agricultural-materials/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAgriculturalMaterialsStatsRoute =
  AppAuthedSidebarAgriculturalMaterialsStatsRouteImport.update({
    id: '/agricultural-materials/stats',
    path: '/agricultural-materials/stats',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAgricultureAreaMapRoute =
  AppAuthedSidebarAgricultureAreaMapRouteImport.update({
    id: '/area-map',
    path: '/area-map',
    getParentRoute: () => AppAuthedSidebarAgricultureRouteRoute,
  } as any)
const AppAuthedSidebarAgricultureCamerasRoute =
  AppAuthedSidebarAgricultureCamerasRouteImport.update({
    id: '/cameras',
    path: '/cameras',
    getParentRoute: () => AppAuthedSidebarAgricultureRouteRoute,
  } as any)
const AppAuthedSidebarAgricultureCareLogsRoute =
  AppAuthedSidebarAgricultureCareLogsRouteImport.update({
    id: '/care-logs',
    path: '/care-logs',
    getParentRoute: () => AppAuthedSidebarAgricultureRouteRoute,
  } as any)
const AppAuthedSidebarAgricultureCareRemindersRoute =
  AppAuthedSidebarAgricultureCareRemindersRouteImport.update({
    id: '/care-reminders',
    path: '/care-reminders',
    getParentRoute: () => AppAuthedSidebarAgricultureRouteRoute,
  } as any)
const AppAuthedSidebarAgricultureGrowersRoute =
  AppAuthedSidebarAgricultureGrowersRouteImport.update({
    id: '/growers',
    path: '/growers',
    getParentRoute: () => AppAuthedSidebarAgricultureRouteRoute,
  } as any)
const AppAuthedSidebarAgricultureIrrigationDevicesRoute =
  AppAuthedSidebarAgricultureIrrigationDevicesRouteImport.update({
    id: '/irrigation-devices',
    path: '/irrigation-devices',
    getParentRoute: () => AppAuthedSidebarAgricultureRouteRoute,
  } as any)
const AppAuthedSidebarAgricultureMyReportsRoute =
  AppAuthedSidebarAgricultureMyReportsRouteImport.update({
    id: '/my-reports',
    path: '/my-reports',
    getParentRoute: () => AppAuthedSidebarAgricultureRouteRoute,
  } as any)
const AppAuthedSidebarAgricultureMyWeighingsRoute =
  AppAuthedSidebarAgricultureMyWeighingsRouteImport.update({
    id: '/my-weighings',
    path: '/my-weighings',
    getParentRoute: () => AppAuthedSidebarAgricultureRouteRoute,
  } as any)
const AppAuthedSidebarAgricultureTeaTypesRoute =
  AppAuthedSidebarAgricultureTeaTypesRouteImport.update({
    id: '/tea-types',
    path: '/tea-types',
    getParentRoute: () => AppAuthedSidebarAgricultureRouteRoute,
  } as any)
const AppAuthedSidebarApiKeysIndexRoute =
  AppAuthedSidebarApiKeysIndexRouteImport.update({
    id: '/api-keys/',
    path: '/api-keys/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarContractDeliveriesIndexRoute =
  AppAuthedSidebarContractDeliveriesIndexRouteImport.update({
    id: '/contract-deliveries/',
    path: '/contract-deliveries/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarContractDeliveriesIdRoute =
  AppAuthedSidebarContractDeliveriesIdRouteImport.update({
    id: '/contract-deliveries/$id',
    path: '/contract-deliveries/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarContractDeliveriesNewRoute =
  AppAuthedSidebarContractDeliveriesNewRouteImport.update({
    id: '/contract-deliveries/new',
    path: '/contract-deliveries/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarCustomersIndexRoute =
  AppAuthedSidebarCustomersIndexRouteImport.update({
    id: '/customers/',
    path: '/customers/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarCustomersCustomerIdRoute =
  AppAuthedSidebarCustomersCustomerIdRouteImport.update({
    id: '/customers/$customerId',
    path: '/customers/$customerId',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarCustomersNewRoute =
  AppAuthedSidebarCustomersNewRouteImport.update({
    id: '/customers/new',
    path: '/customers/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarDeliveryTripsIndexRoute =
  AppAuthedSidebarDeliveryTripsIndexRouteImport.update({
    id: '/delivery-trips/',
    path: '/delivery-trips/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarDeliveryTripsIdRoute =
  AppAuthedSidebarDeliveryTripsIdRouteImport.update({
    id: '/delivery-trips/$id',
    path: '/delivery-trips/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarDriedTeaPurchasesIndexRoute =
  AppAuthedSidebarDriedTeaPurchasesIndexRouteImport.update({
    id: '/dried-tea-purchases/',
    path: '/dried-tea-purchases/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarDriedTeaPurchasesIdRoute =
  AppAuthedSidebarDriedTeaPurchasesIdRouteImport.update({
    id: '/dried-tea-purchases/$id',
    path: '/dried-tea-purchases/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarDriverAvailableOrdersRoute =
  AppAuthedSidebarDriverAvailableOrdersRouteImport.update({
    id: '/driver/available-orders',
    path: '/driver/available-orders',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarDriverCashRoute =
  AppAuthedSidebarDriverCashRouteImport.update({
    id: '/driver/cash',
    path: '/driver/cash',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarLogisticsShippingCarriersRoute =
  AppAuthedSidebarLogisticsShippingCarriersRouteImport.update({
    id: '/logistics/shipping-carriers',
    path: '/logistics/shipping-carriers',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarLogisticsVtpOverdueRoute =
  AppAuthedSidebarLogisticsVtpOverdueRouteImport.update({
    id: '/logistics/vtp-overdue',
    path: '/logistics/vtp-overdue',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarOrdersIndexRoute =
  AppAuthedSidebarOrdersIndexRouteImport.update({
    id: '/orders/',
    path: '/orders/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarOrdersOrderIdRoute =
  AppAuthedSidebarOrdersOrderIdRouteImport.update({
    id: '/orders/$orderId',
    path: '/orders/$orderId',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarOrdersNewRoute =
  AppAuthedSidebarOrdersNewRouteImport.update({
    id: '/orders/new',
    path: '/orders/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarOrdersQuickRoute =
  AppAuthedSidebarOrdersQuickRouteImport.update({
    id: '/orders/quick',
    path: '/orders/quick',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseStatsRoute =
  AppAuthedSidebarPackagingWarehouseStatsRouteImport.update({
    id: '/packaging-warehouse/stats',
    path: '/packaging-warehouse/stats',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingIndexRoute =
  AppAuthedSidebarPackagingIndexRouteImport.update({
    id: '/packaging/',
    path: '/packaging/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarProductsIndexRoute =
  AppAuthedSidebarProductsIndexRouteImport.update({
    id: '/products/',
    path: '/products/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarProductsProductIdRoute =
  AppAuthedSidebarProductsProductIdRouteImport.update({
    id: '/products/$productId',
    path: '/products/$productId',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarProductsCategoriesRoute =
  AppAuthedSidebarProductsCategoriesRouteImport.update({
    id: '/products/categories',
    path: '/products/categories',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarProductsCertificationBadgesRoute =
  AppAuthedSidebarProductsCertificationBadgesRouteImport.update({
    id: '/products/certification-badges',
    path: '/products/certification-badges',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarProductsKiotvietMappingRoute =
  AppAuthedSidebarProductsKiotvietMappingRouteImport.update({
    id: '/products/kiotviet-mapping',
    path: '/products/kiotviet-mapping',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarProductsNewRoute =
  AppAuthedSidebarProductsNewRouteImport.update({
    id: '/products/new',
    path: '/products/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarProductsOnlinePricesRoute =
  AppAuthedSidebarProductsOnlinePricesRouteImport.update({
    id: '/products/online-prices',
    path: '/products/online-prices',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarReportsIndexRoute =
  AppAuthedSidebarReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarReportsCareLogsRoute =
  AppAuthedSidebarReportsCareLogsRouteImport.update({
    id: '/reports/care-logs',
    path: '/reports/care-logs',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarReportsCashbookRoute =
  AppAuthedSidebarReportsCashbookRouteImport.update({
    id: '/reports/cashbook',
    path: '/reports/cashbook',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarReportsDebtsRoute =
  AppAuthedSidebarReportsDebtsRouteImport.update({
    id: '/reports/debts',
    path: '/reports/debts',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarReportsDeliveryRoute =
  AppAuthedSidebarReportsDeliveryRouteImport.update({
    id: '/reports/delivery',
    path: '/reports/delivery',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarReportsExpensesRoute =
  AppAuthedSidebarReportsExpensesRouteImport.update({
    id: '/reports/expenses',
    path: '/reports/expenses',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarReportsGeographyRoute =
  AppAuthedSidebarReportsGeographyRouteImport.update({
    id: '/reports/geography',
    path: '/reports/geography',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarReportsGrowersRoute =
  AppAuthedSidebarReportsGrowersRouteImport.update({
    id: '/reports/growers',
    path: '/reports/growers',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarReportsInventoryRoute =
  AppAuthedSidebarReportsInventoryRouteImport.update({
    id: '/reports/inventory',
    path: '/reports/inventory',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarReportsPositionsRoute =
  AppAuthedSidebarReportsPositionsRouteImport.update({
    id: '/reports/positions',
    path: '/reports/positions',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarReportsRevenueRoute =
  AppAuthedSidebarReportsRevenueRouteImport.update({
    id: '/reports/revenue',
    path: '/reports/revenue',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarReportsSalesRoute =
  AppAuthedSidebarReportsSalesRouteImport.update({
    id: '/reports/sales',
    path: '/reports/sales',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarReportsScentingStockRoute =
  AppAuthedSidebarReportsScentingStockRouteImport.update({
    id: '/reports/scenting-stock',
    path: '/reports/scenting-stock',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarReportsSortingStockRoute =
  AppAuthedSidebarReportsSortingStockRouteImport.update({
    id: '/reports/sorting-stock',
    path: '/reports/sorting-stock',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarReportsStaffRoute =
  AppAuthedSidebarReportsStaffRouteImport.update({
    id: '/reports/staff',
    path: '/reports/staff',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarReportsStockOutRoute =
  AppAuthedSidebarReportsStockOutRouteImport.update({
    id: '/reports/stock-out',
    path: '/reports/stock-out',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarReportsWebsiteRoute =
  AppAuthedSidebarReportsWebsiteRouteImport.update({
    id: '/reports/website',
    path: '/reports/website',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarReportsYieldLossRoute =
  AppAuthedSidebarReportsYieldLossRouteImport.update({
    id: '/reports/yield-loss',
    path: '/reports/yield-loss',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarReportsZaloMiniAppRoute =
  AppAuthedSidebarReportsZaloMiniAppRouteImport.update({
    id: '/reports/zalo-mini-app',
    path: '/reports/zalo-mini-app',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarRetailCategoriesRoute =
  AppAuthedSidebarRetailCategoriesRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => AppAuthedSidebarRetailRouteRoute,
  } as any)
const AppAuthedSidebarRetailContactRoute =
  AppAuthedSidebarRetailContactRouteImport.update({
    id: '/contact',
    path: '/contact',
    getParentRoute: () => AppAuthedSidebarRetailRouteRoute,
  } as any)
const AppAuthedSidebarRetailGuideVideosRoute =
  AppAuthedSidebarRetailGuideVideosRouteImport.update({
    id: '/guide-videos',
    path: '/guide-videos',
    getParentRoute: () => AppAuthedSidebarRetailRouteRoute,
  } as any)
const AppAuthedSidebarRetailHomeRoute =
  AppAuthedSidebarRetailHomeRouteImport.update({
    id: '/home',
    path: '/home',
    getParentRoute: () => AppAuthedSidebarRetailRouteRoute,
  } as any)
const AppAuthedSidebarRetailMediaRoute =
  AppAuthedSidebarRetailMediaRouteImport.update({
    id: '/media',
    path: '/media',
    getParentRoute: () => AppAuthedSidebarRetailRouteRoute,
  } as any)
const AppAuthedSidebarRetailMemberTiersRoute =
  AppAuthedSidebarRetailMemberTiersRouteImport.update({
    id: '/member-tiers',
    path: '/member-tiers',
    getParentRoute: () => AppAuthedSidebarRetailRouteRoute,
  } as any)
const AppAuthedSidebarRetailOnlinePricesRoute =
  AppAuthedSidebarRetailOnlinePricesRouteImport.update({
    id: '/online-prices',
    path: '/online-prices',
    getParentRoute: () => AppAuthedSidebarRetailRouteRoute,
  } as any)
const AppAuthedSidebarRetailPostCategoriesRoute =
  AppAuthedSidebarRetailPostCategoriesRouteImport.update({
    id: '/post-categories',
    path: '/post-categories',
    getParentRoute: () => AppAuthedSidebarRetailRouteRoute,
  } as any)
const AppAuthedSidebarRetailSiteSettingsRoute =
  AppAuthedSidebarRetailSiteSettingsRouteImport.update({
    id: '/site-settings',
    path: '/site-settings',
    getParentRoute: () => AppAuthedSidebarRetailRouteRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseGradesRoute =
  AppAuthedSidebarScentingWarehouseGradesRouteImport.update({
    id: '/scenting-warehouse/grades',
    path: '/scenting-warehouse/grades',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseStatsRoute =
  AppAuthedSidebarScentingWarehouseStatsRouteImport.update({
    id: '/scenting-warehouse/stats',
    path: '/scenting-warehouse/stats',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSettingsFaceRecognitionRoute =
  AppAuthedSidebarSettingsFaceRecognitionRouteImport.update({
    id: '/settings/face-recognition',
    path: '/settings/face-recognition',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSettingsInvoiceRoute =
  AppAuthedSidebarSettingsInvoiceRouteImport.update({
    id: '/settings/invoice',
    path: '/settings/invoice',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSettingsLotSizesRoute =
  AppAuthedSidebarSettingsLotSizesRouteImport.update({
    id: '/settings/lot-sizes',
    path: '/settings/lot-sizes',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSettingsNotificationsRoute =
  AppAuthedSidebarSettingsNotificationsRouteImport.update({
    id: '/settings/notifications',
    path: '/settings/notifications',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSettingsPrintingRoute =
  AppAuthedSidebarSettingsPrintingRouteImport.update({
    id: '/settings/printing',
    path: '/settings/printing',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSettingsProductionStationVoiceRoute =
  AppAuthedSidebarSettingsProductionStationVoiceRouteImport.update({
    id: '/settings/production-station-voice',
    path: '/settings/production-station-voice',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSettingsSidebarLayoutRoute =
  AppAuthedSidebarSettingsSidebarLayoutRouteImport.update({
    id: '/settings/sidebar-layout',
    path: '/settings/sidebar-layout',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSettingsSlaRoute =
  AppAuthedSidebarSettingsSlaRouteImport.update({
    id: '/settings/sla',
    path: '/settings/sla',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSettingsStationVoiceRoute =
  AppAuthedSidebarSettingsStationVoiceRouteImport.update({
    id: '/settings/station-voice',
    path: '/settings/station-voice',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSettingsWarehouseStationVoiceRoute =
  AppAuthedSidebarSettingsWarehouseStationVoiceRouteImport.update({
    id: '/settings/warehouse-station-voice',
    path: '/settings/warehouse-station-voice',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSettingsZaloRoute =
  AppAuthedSidebarSettingsZaloRouteImport.update({
    id: '/settings/zalo',
    path: '/settings/zalo',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSmartlabIndexRoute =
  AppAuthedSidebarSmartlabIndexRouteImport.update({
    id: '/smartlab/',
    path: '/smartlab/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseStatsRoute =
  AppAuthedSidebarSortingWarehouseStatsRouteImport.update({
    id: '/sorting-warehouse/stats',
    path: '/sorting-warehouse/stats',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseTeaGradesRoute =
  AppAuthedSidebarSortingWarehouseTeaGradesRouteImport.update({
    id: '/sorting-warehouse/tea-grades',
    path: '/sorting-warehouse/tea-grades',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarStocktakeIndexRoute =
  AppAuthedSidebarStocktakeIndexRouteImport.update({
    id: '/stocktake/',
    path: '/stocktake/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarStocktakeIdRoute =
  AppAuthedSidebarStocktakeIdRouteImport.update({
    id: '/stocktake/$id',
    path: '/stocktake/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarStocktakeNewRoute =
  AppAuthedSidebarStocktakeNewRouteImport.update({
    id: '/stocktake/new',
    path: '/stocktake/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarTeaPurchasesIndexRoute =
  AppAuthedSidebarTeaPurchasesIndexRouteImport.update({
    id: '/tea-purchases/',
    path: '/tea-purchases/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarTeaPurchasesIdRoute =
  AppAuthedSidebarTeaPurchasesIdRouteImport.update({
    id: '/tea-purchases/$id',
    path: '/tea-purchases/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarTeaPurchasesProcessingRoute =
  AppAuthedSidebarTeaPurchasesProcessingRouteImport.update({
    id: '/tea-purchases/processing',
    path: '/tea-purchases/processing',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarUsersIndexRoute =
  AppAuthedSidebarUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarVehiclesIndexRoute =
  AppAuthedSidebarVehiclesIndexRouteImport.update({
    id: '/vehicles/',
    path: '/vehicles/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarVehiclesVehicleIdRoute =
  AppAuthedSidebarVehiclesVehicleIdRouteImport.update({
    id: '/vehicles/$vehicleId',
    path: '/vehicles/$vehicleId',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarWarehousePositionsIndexRoute =
  AppAuthedSidebarWarehousePositionsIndexRouteImport.update({
    id: '/warehouse-positions/',
    path: '/warehouse-positions/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarWarehousePositionsIdRoute =
  AppAuthedSidebarWarehousePositionsIdRouteImport.update({
    id: '/warehouse-positions/$id',
    path: '/warehouse-positions/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarWarehousePositionsNewRoute =
  AppAuthedSidebarWarehousePositionsNewRouteImport.update({
    id: '/warehouse-positions/new',
    path: '/warehouse-positions/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarWarehouseSalesDashboardRoute =
  AppAuthedSidebarWarehouseSalesDashboardRouteImport.update({
    id: '/warehouse-sales/dashboard',
    path: '/warehouse-sales/dashboard',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarWarehouseSalesDefectsRoute =
  AppAuthedSidebarWarehouseSalesDefectsRouteImport.update({
    id: '/warehouse-sales/defects',
    path: '/warehouse-sales/defects',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarWarehouseSalesStatsRoute =
  AppAuthedSidebarWarehouseSalesStatsRouteImport.update({
    id: '/warehouse-sales/stats',
    path: '/warehouse-sales/stats',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarWorkActivitiesBoardRoute =
  AppAuthedSidebarWorkActivitiesBoardRouteImport.update({
    id: '/work-activities/board',
    path: '/work-activities/board',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarWorkActivitiesCalendarRoute =
  AppAuthedSidebarWorkActivitiesCalendarRouteImport.update({
    id: '/work-activities/calendar',
    path: '/work-activities/calendar',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarWorkActivitiesGuestsRoute =
  AppAuthedSidebarWorkActivitiesGuestsRouteImport.update({
    id: '/work-activities/guests',
    path: '/work-activities/guests',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSupportTRefRoute = AppAuthedSupportTRefRouteImport.update({
  id: '/support/t/$ref',
  path: '/support/t/$ref',
  getParentRoute: () => AppAuthedRoute,
} as any)
const AppAuthedSidebarAccountingReportsDailyRoute =
  AppAuthedSidebarAccountingReportsDailyRouteImport.update({
    id: '/accounting/reports/daily',
    path: '/accounting/reports/daily',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAgriculturalMaterialsLotsIndexRoute =
  AppAuthedSidebarAgriculturalMaterialsLotsIndexRouteImport.update({
    id: '/agricultural-materials/lots/',
    path: '/agricultural-materials/lots/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAgriculturalMaterialsLotsIdRoute =
  AppAuthedSidebarAgriculturalMaterialsLotsIdRouteImport.update({
    id: '/agricultural-materials/lots/$id',
    path: '/agricultural-materials/lots/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAgriculturalMaterialsStockInNotesIndexRoute =
  AppAuthedSidebarAgriculturalMaterialsStockInNotesIndexRouteImport.update({
    id: '/agricultural-materials/stock-in-notes/',
    path: '/agricultural-materials/stock-in-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAgriculturalMaterialsStockInNotesIdRoute =
  AppAuthedSidebarAgriculturalMaterialsStockInNotesIdRouteImport.update({
    id: '/agricultural-materials/stock-in-notes/$id',
    path: '/agricultural-materials/stock-in-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAgriculturalMaterialsStockInNotesNewRoute =
  AppAuthedSidebarAgriculturalMaterialsStockInNotesNewRouteImport.update({
    id: '/agricultural-materials/stock-in-notes/new',
    path: '/agricultural-materials/stock-in-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAgriculturalMaterialsStockOutNotesIndexRoute =
  AppAuthedSidebarAgriculturalMaterialsStockOutNotesIndexRouteImport.update({
    id: '/agricultural-materials/stock-out-notes/',
    path: '/agricultural-materials/stock-out-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAgriculturalMaterialsStockOutNotesIdRoute =
  AppAuthedSidebarAgriculturalMaterialsStockOutNotesIdRouteImport.update({
    id: '/agricultural-materials/stock-out-notes/$id',
    path: '/agricultural-materials/stock-out-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAgriculturalMaterialsStockOutNotesNewRoute =
  AppAuthedSidebarAgriculturalMaterialsStockOutNotesNewRouteImport.update({
    id: '/agricultural-materials/stock-out-notes/new',
    path: '/agricultural-materials/stock-out-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAgricultureCareLogsIndexRoute =
  AppAuthedSidebarAgricultureCareLogsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAuthedSidebarAgricultureCareLogsRoute,
  } as any)
const AppAuthedSidebarAgricultureCareLogsNewRoute =
  AppAuthedSidebarAgricultureCareLogsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppAuthedSidebarAgricultureCareLogsRoute,
  } as any)
const AppAuthedSidebarAgricultureGrowersIndexRoute =
  AppAuthedSidebarAgricultureGrowersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAuthedSidebarAgricultureGrowersRoute,
  } as any)
const AppAuthedSidebarAgricultureGrowersIdRoute =
  AppAuthedSidebarAgricultureGrowersIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AppAuthedSidebarAgricultureGrowersRoute,
  } as any)
const AppAuthedSidebarAgricultureGrowersNewRoute =
  AppAuthedSidebarAgricultureGrowersNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppAuthedSidebarAgricultureGrowersRoute,
  } as any)
const AppAuthedSidebarAgricultureMyGrowerIndexRoute =
  AppAuthedSidebarAgricultureMyGrowerIndexRouteImport.update({
    id: '/my-grower/',
    path: '/my-grower/',
    getParentRoute: () => AppAuthedSidebarAgricultureRouteRoute,
  } as any)
const AppAuthedSidebarAgricultureMyGrowerGrowerIdRoute =
  AppAuthedSidebarAgricultureMyGrowerGrowerIdRouteImport.update({
    id: '/my-grower/$growerId',
    path: '/my-grower/$growerId',
    getParentRoute: () => AppAuthedSidebarAgricultureRouteRoute,
  } as any)
const AppAuthedSidebarCustomersGroupsIndexRoute =
  AppAuthedSidebarCustomersGroupsIndexRouteImport.update({
    id: '/customers/groups/',
    path: '/customers/groups/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarCustomersGroupsGroupIdRoute =
  AppAuthedSidebarCustomersGroupsGroupIdRouteImport.update({
    id: '/customers/groups/$groupId',
    path: '/customers/groups/$groupId',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarOrganizationDepartmentsIndexRoute =
  AppAuthedSidebarOrganizationDepartmentsIndexRouteImport.update({
    id: '/organization/departments/',
    path: '/organization/departments/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarOrganizationEmployeesIndexRoute =
  AppAuthedSidebarOrganizationEmployeesIndexRouteImport.update({
    id: '/organization/employees/',
    path: '/organization/employees/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseCountLogIndexRoute =
  AppAuthedSidebarPackagingWarehouseCountLogIndexRouteImport.update({
    id: '/packaging-warehouse/count-log/',
    path: '/packaging-warehouse/count-log/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseLotsIndexRoute =
  AppAuthedSidebarPackagingWarehouseLotsIndexRouteImport.update({
    id: '/packaging-warehouse/lots/',
    path: '/packaging-warehouse/lots/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseLotsIdRoute =
  AppAuthedSidebarPackagingWarehouseLotsIdRouteImport.update({
    id: '/packaging-warehouse/lots/$id',
    path: '/packaging-warehouse/lots/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseStockInNotesIndexRoute =
  AppAuthedSidebarPackagingWarehouseStockInNotesIndexRouteImport.update({
    id: '/packaging-warehouse/stock-in-notes/',
    path: '/packaging-warehouse/stock-in-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseStockInNotesIdRoute =
  AppAuthedSidebarPackagingWarehouseStockInNotesIdRouteImport.update({
    id: '/packaging-warehouse/stock-in-notes/$id',
    path: '/packaging-warehouse/stock-in-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseStockInNotesNewRoute =
  AppAuthedSidebarPackagingWarehouseStockInNotesNewRouteImport.update({
    id: '/packaging-warehouse/stock-in-notes/new',
    path: '/packaging-warehouse/stock-in-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseStockOutNotesIndexRoute =
  AppAuthedSidebarPackagingWarehouseStockOutNotesIndexRouteImport.update({
    id: '/packaging-warehouse/stock-out-notes/',
    path: '/packaging-warehouse/stock-out-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseStockOutNotesIdRoute =
  AppAuthedSidebarPackagingWarehouseStockOutNotesIdRouteImport.update({
    id: '/packaging-warehouse/stock-out-notes/$id',
    path: '/packaging-warehouse/stock-out-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseStockOutNotesNewRoute =
  AppAuthedSidebarPackagingWarehouseStockOutNotesNewRouteImport.update({
    id: '/packaging-warehouse/stock-out-notes/new',
    path: '/packaging-warehouse/stock-out-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseWithdrawalNotesIndexRoute =
  AppAuthedSidebarPackagingWarehouseWithdrawalNotesIndexRouteImport.update({
    id: '/packaging-warehouse/withdrawal-notes/',
    path: '/packaging-warehouse/withdrawal-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseWithdrawalNotesIdRoute =
  AppAuthedSidebarPackagingWarehouseWithdrawalNotesIdRouteImport.update({
    id: '/packaging-warehouse/withdrawal-notes/$id',
    path: '/packaging-warehouse/withdrawal-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseWithdrawalNotesNewRoute =
  AppAuthedSidebarPackagingWarehouseWithdrawalNotesNewRouteImport.update({
    id: '/packaging-warehouse/withdrawal-notes/new',
    path: '/packaging-warehouse/withdrawal-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarRetailAccountsIndexRoute =
  AppAuthedSidebarRetailAccountsIndexRouteImport.update({
    id: '/accounts/',
    path: '/accounts/',
    getParentRoute: () => AppAuthedSidebarRetailRouteRoute,
  } as any)
const AppAuthedSidebarRetailAccountsAccountIdRoute =
  AppAuthedSidebarRetailAccountsAccountIdRouteImport.update({
    id: '/accounts/$accountId',
    path: '/accounts/$accountId',
    getParentRoute: () => AppAuthedSidebarRetailRouteRoute,
  } as any)
const AppAuthedSidebarRetailGroupsIndexRoute =
  AppAuthedSidebarRetailGroupsIndexRouteImport.update({
    id: '/groups/',
    path: '/groups/',
    getParentRoute: () => AppAuthedSidebarRetailRouteRoute,
  } as any)
const AppAuthedSidebarRetailGroupsGroupIdRoute =
  AppAuthedSidebarRetailGroupsGroupIdRouteImport.update({
    id: '/groups/$groupId',
    path: '/groups/$groupId',
    getParentRoute: () => AppAuthedSidebarRetailRouteRoute,
  } as any)
const AppAuthedSidebarRetailGroupsNewRoute =
  AppAuthedSidebarRetailGroupsNewRouteImport.update({
    id: '/groups/new',
    path: '/groups/new',
    getParentRoute: () => AppAuthedSidebarRetailRouteRoute,
  } as any)
const AppAuthedSidebarRetailPagesIndexRoute =
  AppAuthedSidebarRetailPagesIndexRouteImport.update({
    id: '/pages/',
    path: '/pages/',
    getParentRoute: () => AppAuthedSidebarRetailRouteRoute,
  } as any)
const AppAuthedSidebarRetailPagesPageIdRoute =
  AppAuthedSidebarRetailPagesPageIdRouteImport.update({
    id: '/pages/$pageId',
    path: '/pages/$pageId',
    getParentRoute: () => AppAuthedSidebarRetailRouteRoute,
  } as any)
const AppAuthedSidebarRetailPagesNewRoute =
  AppAuthedSidebarRetailPagesNewRouteImport.update({
    id: '/pages/new',
    path: '/pages/new',
    getParentRoute: () => AppAuthedSidebarRetailRouteRoute,
  } as any)
const AppAuthedSidebarRetailPostsIndexRoute =
  AppAuthedSidebarRetailPostsIndexRouteImport.update({
    id: '/posts/',
    path: '/posts/',
    getParentRoute: () => AppAuthedSidebarRetailRouteRoute,
  } as any)
const AppAuthedSidebarRetailPostsPostIdRoute =
  AppAuthedSidebarRetailPostsPostIdRouteImport.update({
    id: '/posts/$postId',
    path: '/posts/$postId',
    getParentRoute: () => AppAuthedSidebarRetailRouteRoute,
  } as any)
const AppAuthedSidebarRetailPostsNewRoute =
  AppAuthedSidebarRetailPostsNewRouteImport.update({
    id: '/posts/new',
    path: '/posts/new',
    getParentRoute: () => AppAuthedSidebarRetailRouteRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseBoxLogIndexRoute =
  AppAuthedSidebarSalesWarehouseBoxLogIndexRouteImport.update({
    id: '/sales-warehouse/box-log/',
    path: '/sales-warehouse/box-log/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseLotsIndexRoute =
  AppAuthedSidebarSalesWarehouseLotsIndexRouteImport.update({
    id: '/sales-warehouse/lots/',
    path: '/sales-warehouse/lots/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseLotsIdRoute =
  AppAuthedSidebarSalesWarehouseLotsIdRouteImport.update({
    id: '/sales-warehouse/lots/$id',
    path: '/sales-warehouse/lots/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseOtherLogIndexRoute =
  AppAuthedSidebarSalesWarehouseOtherLogIndexRouteImport.update({
    id: '/sales-warehouse/other-log/',
    path: '/sales-warehouse/other-log/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehousePackagingLogIndexRoute =
  AppAuthedSidebarSalesWarehousePackagingLogIndexRouteImport.update({
    id: '/sales-warehouse/packaging-log/',
    path: '/sales-warehouse/packaging-log/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseStockInNotesIndexRoute =
  AppAuthedSidebarSalesWarehouseStockInNotesIndexRouteImport.update({
    id: '/sales-warehouse/stock-in-notes/',
    path: '/sales-warehouse/stock-in-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseStockInNotesIdRoute =
  AppAuthedSidebarSalesWarehouseStockInNotesIdRouteImport.update({
    id: '/sales-warehouse/stock-in-notes/$id',
    path: '/sales-warehouse/stock-in-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseStockInNotesNewRoute =
  AppAuthedSidebarSalesWarehouseStockInNotesNewRouteImport.update({
    id: '/sales-warehouse/stock-in-notes/new',
    path: '/sales-warehouse/stock-in-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseStockInNotesQuickRoute =
  AppAuthedSidebarSalesWarehouseStockInNotesQuickRouteImport.update({
    id: '/sales-warehouse/stock-in-notes/quick',
    path: '/sales-warehouse/stock-in-notes/quick',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseStockOutNotesIndexRoute =
  AppAuthedSidebarSalesWarehouseStockOutNotesIndexRouteImport.update({
    id: '/sales-warehouse/stock-out-notes/',
    path: '/sales-warehouse/stock-out-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseStockOutNotesIdRoute =
  AppAuthedSidebarSalesWarehouseStockOutNotesIdRouteImport.update({
    id: '/sales-warehouse/stock-out-notes/$id',
    path: '/sales-warehouse/stock-out-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseStockOutNotesNewRoute =
  AppAuthedSidebarSalesWarehouseStockOutNotesNewRouteImport.update({
    id: '/sales-warehouse/stock-out-notes/new',
    path: '/sales-warehouse/stock-out-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseTransferNotesIndexRoute =
  AppAuthedSidebarSalesWarehouseTransferNotesIndexRouteImport.update({
    id: '/sales-warehouse/transfer-notes/',
    path: '/sales-warehouse/transfer-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseTransferNotesIdRoute =
  AppAuthedSidebarSalesWarehouseTransferNotesIdRouteImport.update({
    id: '/sales-warehouse/transfer-notes/$id',
    path: '/sales-warehouse/transfer-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseTransferNotesNewRoute =
  AppAuthedSidebarSalesWarehouseTransferNotesNewRouteImport.update({
    id: '/sales-warehouse/transfer-notes/new',
    path: '/sales-warehouse/transfer-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseLogIndexRoute =
  AppAuthedSidebarScentingWarehouseLogIndexRouteImport.update({
    id: '/scenting-warehouse/log/',
    path: '/scenting-warehouse/log/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseLotsIndexRoute =
  AppAuthedSidebarScentingWarehouseLotsIndexRouteImport.update({
    id: '/scenting-warehouse/lots/',
    path: '/scenting-warehouse/lots/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseLotsIdRoute =
  AppAuthedSidebarScentingWarehouseLotsIdRouteImport.update({
    id: '/scenting-warehouse/lots/$id',
    path: '/scenting-warehouse/lots/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseStockInNotesIndexRoute =
  AppAuthedSidebarScentingWarehouseStockInNotesIndexRouteImport.update({
    id: '/scenting-warehouse/stock-in-notes/',
    path: '/scenting-warehouse/stock-in-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseStockInNotesIdRoute =
  AppAuthedSidebarScentingWarehouseStockInNotesIdRouteImport.update({
    id: '/scenting-warehouse/stock-in-notes/$id',
    path: '/scenting-warehouse/stock-in-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseStockInNotesNewRoute =
  AppAuthedSidebarScentingWarehouseStockInNotesNewRouteImport.update({
    id: '/scenting-warehouse/stock-in-notes/new',
    path: '/scenting-warehouse/stock-in-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseStockOutNotesIndexRoute =
  AppAuthedSidebarScentingWarehouseStockOutNotesIndexRouteImport.update({
    id: '/scenting-warehouse/stock-out-notes/',
    path: '/scenting-warehouse/stock-out-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseStockOutNotesIdRoute =
  AppAuthedSidebarScentingWarehouseStockOutNotesIdRouteImport.update({
    id: '/scenting-warehouse/stock-out-notes/$id',
    path: '/scenting-warehouse/stock-out-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseStockOutNotesNewRoute =
  AppAuthedSidebarScentingWarehouseStockOutNotesNewRouteImport.update({
    id: '/scenting-warehouse/stock-out-notes/new',
    path: '/scenting-warehouse/stock-out-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseWithdrawalNotesIndexRoute =
  AppAuthedSidebarScentingWarehouseWithdrawalNotesIndexRouteImport.update({
    id: '/scenting-warehouse/withdrawal-notes/',
    path: '/scenting-warehouse/withdrawal-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseWithdrawalNotesIdRoute =
  AppAuthedSidebarScentingWarehouseWithdrawalNotesIdRouteImport.update({
    id: '/scenting-warehouse/withdrawal-notes/$id',
    path: '/scenting-warehouse/withdrawal-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseWithdrawalNotesNewRoute =
  AppAuthedSidebarScentingWarehouseWithdrawalNotesNewRouteImport.update({
    id: '/scenting-warehouse/withdrawal-notes/new',
    path: '/scenting-warehouse/withdrawal-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSettingsRolesIndexRoute =
  AppAuthedSidebarSettingsRolesIndexRouteImport.update({
    id: '/settings/roles/',
    path: '/settings/roles/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSettingsRolesIdRoute =
  AppAuthedSidebarSettingsRolesIdRouteImport.update({
    id: '/settings/roles/$id',
    path: '/settings/roles/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSettingsZaloIndexRoute =
  AppAuthedSidebarSettingsZaloIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAuthedSidebarSettingsZaloRoute,
  } as any)
const AppAuthedSidebarSettingsZaloMessagesRoute =
  AppAuthedSidebarSettingsZaloMessagesRouteImport.update({
    id: '/messages',
    path: '/messages',
    getParentRoute: () => AppAuthedSidebarSettingsZaloRoute,
  } as any)
const AppAuthedSidebarSettingsZaloPurposesRoute =
  AppAuthedSidebarSettingsZaloPurposesRouteImport.update({
    id: '/purposes',
    path: '/purposes',
    getParentRoute: () => AppAuthedSidebarSettingsZaloRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseLotsIndexRoute =
  AppAuthedSidebarSortingWarehouseLotsIndexRouteImport.update({
    id: '/sorting-warehouse/lots/',
    path: '/sorting-warehouse/lots/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseLotsIdRoute =
  AppAuthedSidebarSortingWarehouseLotsIdRouteImport.update({
    id: '/sorting-warehouse/lots/$id',
    path: '/sorting-warehouse/lots/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseStockInNotesIndexRoute =
  AppAuthedSidebarSortingWarehouseStockInNotesIndexRouteImport.update({
    id: '/sorting-warehouse/stock-in-notes/',
    path: '/sorting-warehouse/stock-in-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseStockInNotesIdRoute =
  AppAuthedSidebarSortingWarehouseStockInNotesIdRouteImport.update({
    id: '/sorting-warehouse/stock-in-notes/$id',
    path: '/sorting-warehouse/stock-in-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseStockInNotesNewRoute =
  AppAuthedSidebarSortingWarehouseStockInNotesNewRouteImport.update({
    id: '/sorting-warehouse/stock-in-notes/new',
    path: '/sorting-warehouse/stock-in-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseStockOutNotesIndexRoute =
  AppAuthedSidebarSortingWarehouseStockOutNotesIndexRouteImport.update({
    id: '/sorting-warehouse/stock-out-notes/',
    path: '/sorting-warehouse/stock-out-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseStockOutNotesIdRoute =
  AppAuthedSidebarSortingWarehouseStockOutNotesIdRouteImport.update({
    id: '/sorting-warehouse/stock-out-notes/$id',
    path: '/sorting-warehouse/stock-out-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseStockOutNotesNewRoute =
  AppAuthedSidebarSortingWarehouseStockOutNotesNewRouteImport.update({
    id: '/sorting-warehouse/stock-out-notes/new',
    path: '/sorting-warehouse/stock-out-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseWithdrawalNotesIndexRoute =
  AppAuthedSidebarSortingWarehouseWithdrawalNotesIndexRouteImport.update({
    id: '/sorting-warehouse/withdrawal-notes/',
    path: '/sorting-warehouse/withdrawal-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseWithdrawalNotesIdRoute =
  AppAuthedSidebarSortingWarehouseWithdrawalNotesIdRouteImport.update({
    id: '/sorting-warehouse/withdrawal-notes/$id',
    path: '/sorting-warehouse/withdrawal-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseWithdrawalNotesNewRoute =
  AppAuthedSidebarSortingWarehouseWithdrawalNotesNewRouteImport.update({
    id: '/sorting-warehouse/withdrawal-notes/new',
    path: '/sorting-warehouse/withdrawal-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAgriculturalMaterialsStockInNotesIdEditRoute =
  AppAuthedSidebarAgriculturalMaterialsStockInNotesIdEditRouteImport.update({
    id: '/agricultural-materials/stock-in-notes/$id_/edit',
    path: '/agricultural-materials/stock-in-notes/$id/edit',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAgriculturalMaterialsStockOutNotesIdEditRoute =
  AppAuthedSidebarAgriculturalMaterialsStockOutNotesIdEditRouteImport.update({
    id: '/agricultural-materials/stock-out-notes/$id_/edit',
    path: '/agricultural-materials/stock-out-notes/$id/edit',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAgricultureCareLogsIdEditRoute =
  AppAuthedSidebarAgricultureCareLogsIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AppAuthedSidebarAgricultureCareLogsRoute,
  } as any)
const AppAuthedSidebarAgricultureGrowersIdEditRoute =
  AppAuthedSidebarAgricultureGrowersIdEditRouteImport.update({
    id: '/$id_/edit',
    path: '/$id/edit',
    getParentRoute: () => AppAuthedSidebarAgricultureGrowersRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseStockInNotesIdEditRoute =
  AppAuthedSidebarPackagingWarehouseStockInNotesIdEditRouteImport.update({
    id: '/packaging-warehouse/stock-in-notes/$id_/edit',
    path: '/packaging-warehouse/stock-in-notes/$id/edit',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseStockOutNotesIdEditRoute =
  AppAuthedSidebarPackagingWarehouseStockOutNotesIdEditRouteImport.update({
    id: '/packaging-warehouse/stock-out-notes/$id_/edit',
    path: '/packaging-warehouse/stock-out-notes/$id/edit',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseStockInNotesIdEditRoute =
  AppAuthedSidebarSalesWarehouseStockInNotesIdEditRouteImport.update({
    id: '/sales-warehouse/stock-in-notes/$id_/edit',
    path: '/sales-warehouse/stock-in-notes/$id/edit',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseStockOutNotesIdEditRoute =
  AppAuthedSidebarSalesWarehouseStockOutNotesIdEditRouteImport.update({
    id: '/sales-warehouse/stock-out-notes/$id_/edit',
    path: '/sales-warehouse/stock-out-notes/$id/edit',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseTransferNotesIdEditRoute =
  AppAuthedSidebarSalesWarehouseTransferNotesIdEditRouteImport.update({
    id: '/sales-warehouse/transfer-notes/$id_/edit',
    path: '/sales-warehouse/transfer-notes/$id/edit',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseStockInNotesIdEditRoute =
  AppAuthedSidebarScentingWarehouseStockInNotesIdEditRouteImport.update({
    id: '/scenting-warehouse/stock-in-notes/$id_/edit',
    path: '/scenting-warehouse/stock-in-notes/$id/edit',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseStockOutNotesIdEditRoute =
  AppAuthedSidebarScentingWarehouseStockOutNotesIdEditRouteImport.update({
    id: '/scenting-warehouse/stock-out-notes/$id_/edit',
    path: '/scenting-warehouse/stock-out-notes/$id/edit',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSettingsZaloTemplatesIndexRoute =
  AppAuthedSidebarSettingsZaloTemplatesIndexRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => AppAuthedSidebarSettingsZaloRoute,
  } as any)
const AppAuthedSidebarSettingsZaloTemplatesIdRoute =
  AppAuthedSidebarSettingsZaloTemplatesIdRouteImport.update({
    id: '/templates/$id',
    path: '/templates/$id',
    getParentRoute: () => AppAuthedSidebarSettingsZaloRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseStockInNotesIdEditRoute =
  AppAuthedSidebarSortingWarehouseStockInNotesIdEditRouteImport.update({
    id: '/sorting-warehouse/stock-in-notes/$id_/edit',
    path: '/sorting-warehouse/stock-in-notes/$id/edit',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseStockOutNotesIdEditRoute =
  AppAuthedSidebarSortingWarehouseStockOutNotesIdEditRouteImport.update({
    id: '/sorting-warehouse/stock-out-notes/$id_/edit',
    path: '/sorting-warehouse/stock-out-notes/$id/edit',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAgricultureGrowersIdFacesIndexRoute =
  AppAuthedSidebarAgricultureGrowersIdFacesIndexRouteImport.update({
    id: '/$id_/faces/',
    path: '/$id/faces/',
    getParentRoute: () => AppAuthedSidebarAgricultureGrowersRoute,
  } as any)
const AppAuthedSidebarAgricultureGrowersIdFacesFaceIdRoute =
  AppAuthedSidebarAgricultureGrowersIdFacesFaceIdRouteImport.update({
    id: '/$id_/faces/$faceId',
    path: '/$id/faces/$faceId',
    getParentRoute: () => AppAuthedSidebarAgricultureGrowersRoute,
  } as any)
const AppAuthedSidebarAgricultureMyGrowerGrowerIdFacesIndexRoute =
  AppAuthedSidebarAgricultureMyGrowerGrowerIdFacesIndexRouteImport.update({
    id: '/my-grower/$growerId_/faces/',
    path: '/my-grower/$growerId/faces/',
    getParentRoute: () => AppAuthedSidebarAgricultureRouteRoute,
  } as any)
const AppAuthedSidebarAgricultureMyGrowerGrowerIdFacesFaceIdRoute =
  AppAuthedSidebarAgricultureMyGrowerGrowerIdFacesFaceIdRouteImport.update({
    id: '/my-grower/$growerId_/faces/$faceId',
    path: '/my-grower/$growerId/faces/$faceId',
    getParentRoute: () => AppAuthedSidebarAgricultureRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppAuthedSidebarIndexRoute
  '/login': typeof LoginRoute
  '/grower-areas/$id': typeof GrowerAreasIdRoute
  '/trace/$code': typeof TraceCodeRoute
  '/customer-display': typeof AppAuthedCustomerDisplayRoute
  '/sale': typeof AppAuthedSaleRouteWithChildren
  '/station': typeof AppAuthedStationRoute
  '/agriculture': typeof AppAuthedSidebarAgricultureRouteRouteWithChildren
  '/retail': typeof AppAuthedSidebarRetailRouteRouteWithChildren
  '/dev-playground': typeof AppAuthedSidebarDevPlaygroundRoute
  '/kiotviet-orders': typeof AppAuthedSidebarKiotvietOrdersRoute
  '/tea-machines': typeof AppAuthedSidebarTeaMachinesRoute
  '/tracking': typeof AppAuthedSidebarTrackingRoute
  '/warehouse-stats': typeof AppAuthedSidebarWarehouseStatsRoute
  '/whats-new': typeof AppAuthedSidebarWhatsNewRoute
  '/sale/display': typeof AppAuthedSaleDisplayRoute
  '/station/production': typeof AppAuthedStationProductionRoute
  '/station/warehouse': typeof AppAuthedStationWarehouseRoute
  '/settings/zalo/callback': typeof AppSettingsZaloCallbackRoute
  '/sale/': typeof AppAuthedSaleIndexRoute
  '/accounting/cash-flow': typeof AppAuthedSidebarAccountingCashFlowRoute
  '/accounting/expense-categories': typeof AppAuthedSidebarAccountingExpenseCategoriesRoute
  '/accounting/expense-rules': typeof AppAuthedSidebarAccountingExpenseRulesRoute
  '/accounting/expense-sync': typeof AppAuthedSidebarAccountingExpenseSyncRoute
  '/accounting/expenses': typeof AppAuthedSidebarAccountingExpensesRoute
  '/accounting/grower-payments': typeof AppAuthedSidebarAccountingGrowerPaymentsRoute
  '/accounting/reconciliation': typeof AppAuthedSidebarAccountingReconciliationRoute
  '/accounting/remittances': typeof AppAuthedSidebarAccountingRemittancesRoute
  '/agricultural-materials/stats': typeof AppAuthedSidebarAgriculturalMaterialsStatsRoute
  '/agriculture/area-map': typeof AppAuthedSidebarAgricultureAreaMapRoute
  '/agriculture/cameras': typeof AppAuthedSidebarAgricultureCamerasRoute
  '/agriculture/care-logs': typeof AppAuthedSidebarAgricultureCareLogsRouteWithChildren
  '/agriculture/care-reminders': typeof AppAuthedSidebarAgricultureCareRemindersRoute
  '/agriculture/growers': typeof AppAuthedSidebarAgricultureGrowersRouteWithChildren
  '/agriculture/irrigation-devices': typeof AppAuthedSidebarAgricultureIrrigationDevicesRoute
  '/agriculture/my-reports': typeof AppAuthedSidebarAgricultureMyReportsRoute
  '/agriculture/my-weighings': typeof AppAuthedSidebarAgricultureMyWeighingsRoute
  '/agriculture/tea-types': typeof AppAuthedSidebarAgricultureTeaTypesRoute
  '/contract-deliveries/$id': typeof AppAuthedSidebarContractDeliveriesIdRoute
  '/contract-deliveries/new': typeof AppAuthedSidebarContractDeliveriesNewRoute
  '/customers/$customerId': typeof AppAuthedSidebarCustomersCustomerIdRoute
  '/customers/new': typeof AppAuthedSidebarCustomersNewRoute
  '/delivery-trips/$id': typeof AppAuthedSidebarDeliveryTripsIdRoute
  '/dried-tea-purchases/$id': typeof AppAuthedSidebarDriedTeaPurchasesIdRoute
  '/driver/available-orders': typeof AppAuthedSidebarDriverAvailableOrdersRoute
  '/driver/cash': typeof AppAuthedSidebarDriverCashRoute
  '/logistics/shipping-carriers': typeof AppAuthedSidebarLogisticsShippingCarriersRoute
  '/logistics/vtp-overdue': typeof AppAuthedSidebarLogisticsVtpOverdueRoute
  '/orders/$orderId': typeof AppAuthedSidebarOrdersOrderIdRoute
  '/orders/new': typeof AppAuthedSidebarOrdersNewRoute
  '/orders/quick': typeof AppAuthedSidebarOrdersQuickRoute
  '/packaging-warehouse/stats': typeof AppAuthedSidebarPackagingWarehouseStatsRoute
  '/products/$productId': typeof AppAuthedSidebarProductsProductIdRoute
  '/products/categories': typeof AppAuthedSidebarProductsCategoriesRoute
  '/products/certification-badges': typeof AppAuthedSidebarProductsCertificationBadgesRoute
  '/products/kiotviet-mapping': typeof AppAuthedSidebarProductsKiotvietMappingRoute
  '/products/new': typeof AppAuthedSidebarProductsNewRoute
  '/products/online-prices': typeof AppAuthedSidebarProductsOnlinePricesRoute
  '/reports/care-logs': typeof AppAuthedSidebarReportsCareLogsRoute
  '/reports/cashbook': typeof AppAuthedSidebarReportsCashbookRoute
  '/reports/debts': typeof AppAuthedSidebarReportsDebtsRoute
  '/reports/delivery': typeof AppAuthedSidebarReportsDeliveryRoute
  '/reports/expenses': typeof AppAuthedSidebarReportsExpensesRoute
  '/reports/geography': typeof AppAuthedSidebarReportsGeographyRoute
  '/reports/growers': typeof AppAuthedSidebarReportsGrowersRoute
  '/reports/inventory': typeof AppAuthedSidebarReportsInventoryRoute
  '/reports/positions': typeof AppAuthedSidebarReportsPositionsRoute
  '/reports/revenue': typeof AppAuthedSidebarReportsRevenueRoute
  '/reports/sales': typeof AppAuthedSidebarReportsSalesRoute
  '/reports/scenting-stock': typeof AppAuthedSidebarReportsScentingStockRoute
  '/reports/sorting-stock': typeof AppAuthedSidebarReportsSortingStockRoute
  '/reports/staff': typeof AppAuthedSidebarReportsStaffRoute
  '/reports/stock-out': typeof AppAuthedSidebarReportsStockOutRoute
  '/reports/website': typeof AppAuthedSidebarReportsWebsiteRoute
  '/reports/yield-loss': typeof AppAuthedSidebarReportsYieldLossRoute
  '/reports/zalo-mini-app': typeof AppAuthedSidebarReportsZaloMiniAppRoute
  '/retail/categories': typeof AppAuthedSidebarRetailCategoriesRoute
  '/retail/contact': typeof AppAuthedSidebarRetailContactRoute
  '/retail/guide-videos': typeof AppAuthedSidebarRetailGuideVideosRoute
  '/retail/home': typeof AppAuthedSidebarRetailHomeRoute
  '/retail/media': typeof AppAuthedSidebarRetailMediaRoute
  '/retail/member-tiers': typeof AppAuthedSidebarRetailMemberTiersRoute
  '/retail/online-prices': typeof AppAuthedSidebarRetailOnlinePricesRoute
  '/retail/post-categories': typeof AppAuthedSidebarRetailPostCategoriesRoute
  '/retail/site-settings': typeof AppAuthedSidebarRetailSiteSettingsRoute
  '/scenting-warehouse/grades': typeof AppAuthedSidebarScentingWarehouseGradesRoute
  '/scenting-warehouse/stats': typeof AppAuthedSidebarScentingWarehouseStatsRoute
  '/settings/face-recognition': typeof AppAuthedSidebarSettingsFaceRecognitionRoute
  '/settings/invoice': typeof AppAuthedSidebarSettingsInvoiceRoute
  '/settings/lot-sizes': typeof AppAuthedSidebarSettingsLotSizesRoute
  '/settings/notifications': typeof AppAuthedSidebarSettingsNotificationsRoute
  '/settings/printing': typeof AppAuthedSidebarSettingsPrintingRoute
  '/settings/production-station-voice': typeof AppAuthedSidebarSettingsProductionStationVoiceRoute
  '/settings/sidebar-layout': typeof AppAuthedSidebarSettingsSidebarLayoutRoute
  '/settings/sla': typeof AppAuthedSidebarSettingsSlaRoute
  '/settings/station-voice': typeof AppAuthedSidebarSettingsStationVoiceRoute
  '/settings/warehouse-station-voice': typeof AppAuthedSidebarSettingsWarehouseStationVoiceRoute
  '/settings/zalo': typeof AppAuthedSidebarSettingsZaloRouteWithChildren
  '/sorting-warehouse/stats': typeof AppAuthedSidebarSortingWarehouseStatsRoute
  '/sorting-warehouse/tea-grades': typeof AppAuthedSidebarSortingWarehouseTeaGradesRoute
  '/stocktake/$id': typeof AppAuthedSidebarStocktakeIdRoute
  '/stocktake/new': typeof AppAuthedSidebarStocktakeNewRoute
  '/tea-purchases/$id': typeof AppAuthedSidebarTeaPurchasesIdRoute
  '/tea-purchases/processing': typeof AppAuthedSidebarTeaPurchasesProcessingRoute
  '/vehicles/$vehicleId': typeof AppAuthedSidebarVehiclesVehicleIdRoute
  '/warehouse-positions/$id': typeof AppAuthedSidebarWarehousePositionsIdRoute
  '/warehouse-positions/new': typeof AppAuthedSidebarWarehousePositionsNewRoute
  '/warehouse-sales/dashboard': typeof AppAuthedSidebarWarehouseSalesDashboardRoute
  '/warehouse-sales/defects': typeof AppAuthedSidebarWarehouseSalesDefectsRoute
  '/warehouse-sales/stats': typeof AppAuthedSidebarWarehouseSalesStatsRoute
  '/work-activities/board': typeof AppAuthedSidebarWorkActivitiesBoardRoute
  '/work-activities/calendar': typeof AppAuthedSidebarWorkActivitiesCalendarRoute
  '/work-activities/guests': typeof AppAuthedSidebarWorkActivitiesGuestsRoute
  '/support/t/$ref': typeof AppAuthedSupportTRefRoute
  '/accounting/': typeof AppAuthedSidebarAccountingIndexRoute
  '/agricultural-materials/': typeof AppAuthedSidebarAgriculturalMaterialsIndexRoute
  '/api-keys/': typeof AppAuthedSidebarApiKeysIndexRoute
  '/contract-deliveries/': typeof AppAuthedSidebarContractDeliveriesIndexRoute
  '/customers/': typeof AppAuthedSidebarCustomersIndexRoute
  '/delivery-trips/': typeof AppAuthedSidebarDeliveryTripsIndexRoute
  '/dried-tea-purchases/': typeof AppAuthedSidebarDriedTeaPurchasesIndexRoute
  '/orders/': typeof AppAuthedSidebarOrdersIndexRoute
  '/packaging/': typeof AppAuthedSidebarPackagingIndexRoute
  '/products/': typeof AppAuthedSidebarProductsIndexRoute
  '/reports/': typeof AppAuthedSidebarReportsIndexRoute
  '/smartlab/': typeof AppAuthedSidebarSmartlabIndexRoute
  '/stocktake/': typeof AppAuthedSidebarStocktakeIndexRoute
  '/tea-purchases/': typeof AppAuthedSidebarTeaPurchasesIndexRoute
  '/users/': typeof AppAuthedSidebarUsersIndexRoute
  '/vehicles/': typeof AppAuthedSidebarVehiclesIndexRoute
  '/warehouse-positions/': typeof AppAuthedSidebarWarehousePositionsIndexRoute
  '/accounting/reports/daily': typeof AppAuthedSidebarAccountingReportsDailyRoute
  '/agricultural-materials/lots/$id': typeof AppAuthedSidebarAgriculturalMaterialsLotsIdRoute
  '/agricultural-materials/stock-in-notes/$id': typeof AppAuthedSidebarAgriculturalMaterialsStockInNotesIdRoute
  '/agricultural-materials/stock-in-notes/new': typeof AppAuthedSidebarAgriculturalMaterialsStockInNotesNewRoute
  '/agricultural-materials/stock-out-notes/$id': typeof AppAuthedSidebarAgriculturalMaterialsStockOutNotesIdRoute
  '/agricultural-materials/stock-out-notes/new': typeof AppAuthedSidebarAgriculturalMaterialsStockOutNotesNewRoute
  '/agriculture/care-logs/new': typeof AppAuthedSidebarAgricultureCareLogsNewRoute
  '/agriculture/growers/$id': typeof AppAuthedSidebarAgricultureGrowersIdRoute
  '/agriculture/growers/new': typeof AppAuthedSidebarAgricultureGrowersNewRoute
  '/agriculture/my-grower/$growerId': typeof AppAuthedSidebarAgricultureMyGrowerGrowerIdRoute
  '/customers/groups/$groupId': typeof AppAuthedSidebarCustomersGroupsGroupIdRoute
  '/packaging-warehouse/lots/$id': typeof AppAuthedSidebarPackagingWarehouseLotsIdRoute
  '/packaging-warehouse/stock-in-notes/$id': typeof AppAuthedSidebarPackagingWarehouseStockInNotesIdRoute
  '/packaging-warehouse/stock-in-notes/new': typeof AppAuthedSidebarPackagingWarehouseStockInNotesNewRoute
  '/packaging-warehouse/stock-out-notes/$id': typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIdRoute
  '/packaging-warehouse/stock-out-notes/new': typeof AppAuthedSidebarPackagingWarehouseStockOutNotesNewRoute
  '/packaging-warehouse/withdrawal-notes/$id': typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesIdRoute
  '/packaging-warehouse/withdrawal-notes/new': typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesNewRoute
  '/retail/accounts/$accountId': typeof AppAuthedSidebarRetailAccountsAccountIdRoute
  '/retail/groups/$groupId': typeof AppAuthedSidebarRetailGroupsGroupIdRoute
  '/retail/groups/new': typeof AppAuthedSidebarRetailGroupsNewRoute
  '/retail/pages/$pageId': typeof AppAuthedSidebarRetailPagesPageIdRoute
  '/retail/pages/new': typeof AppAuthedSidebarRetailPagesNewRoute
  '/retail/posts/$postId': typeof AppAuthedSidebarRetailPostsPostIdRoute
  '/retail/posts/new': typeof AppAuthedSidebarRetailPostsNewRoute
  '/sales-warehouse/lots/$id': typeof AppAuthedSidebarSalesWarehouseLotsIdRoute
  '/sales-warehouse/stock-in-notes/$id': typeof AppAuthedSidebarSalesWarehouseStockInNotesIdRoute
  '/sales-warehouse/stock-in-notes/new': typeof AppAuthedSidebarSalesWarehouseStockInNotesNewRoute
  '/sales-warehouse/stock-in-notes/quick': typeof AppAuthedSidebarSalesWarehouseStockInNotesQuickRoute
  '/sales-warehouse/stock-out-notes/$id': typeof AppAuthedSidebarSalesWarehouseStockOutNotesIdRoute
  '/sales-warehouse/stock-out-notes/new': typeof AppAuthedSidebarSalesWarehouseStockOutNotesNewRoute
  '/sales-warehouse/transfer-notes/$id': typeof AppAuthedSidebarSalesWarehouseTransferNotesIdRoute
  '/sales-warehouse/transfer-notes/new': typeof AppAuthedSidebarSalesWarehouseTransferNotesNewRoute
  '/scenting-warehouse/lots/$id': typeof AppAuthedSidebarScentingWarehouseLotsIdRoute
  '/scenting-warehouse/stock-in-notes/$id': typeof AppAuthedSidebarScentingWarehouseStockInNotesIdRoute
  '/scenting-warehouse/stock-in-notes/new': typeof AppAuthedSidebarScentingWarehouseStockInNotesNewRoute
  '/scenting-warehouse/stock-out-notes/$id': typeof AppAuthedSidebarScentingWarehouseStockOutNotesIdRoute
  '/scenting-warehouse/stock-out-notes/new': typeof AppAuthedSidebarScentingWarehouseStockOutNotesNewRoute
  '/scenting-warehouse/withdrawal-notes/$id': typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesIdRoute
  '/scenting-warehouse/withdrawal-notes/new': typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesNewRoute
  '/settings/roles/$id': typeof AppAuthedSidebarSettingsRolesIdRoute
  '/settings/zalo/messages': typeof AppAuthedSidebarSettingsZaloMessagesRoute
  '/settings/zalo/purposes': typeof AppAuthedSidebarSettingsZaloPurposesRoute
  '/sorting-warehouse/lots/$id': typeof AppAuthedSidebarSortingWarehouseLotsIdRoute
  '/sorting-warehouse/stock-in-notes/$id': typeof AppAuthedSidebarSortingWarehouseStockInNotesIdRoute
  '/sorting-warehouse/stock-in-notes/new': typeof AppAuthedSidebarSortingWarehouseStockInNotesNewRoute
  '/sorting-warehouse/stock-out-notes/$id': typeof AppAuthedSidebarSortingWarehouseStockOutNotesIdRoute
  '/sorting-warehouse/stock-out-notes/new': typeof AppAuthedSidebarSortingWarehouseStockOutNotesNewRoute
  '/sorting-warehouse/withdrawal-notes/$id': typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesIdRoute
  '/sorting-warehouse/withdrawal-notes/new': typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesNewRoute
  '/agricultural-materials/lots/': typeof AppAuthedSidebarAgriculturalMaterialsLotsIndexRoute
  '/agricultural-materials/stock-in-notes/': typeof AppAuthedSidebarAgriculturalMaterialsStockInNotesIndexRoute
  '/agricultural-materials/stock-out-notes/': typeof AppAuthedSidebarAgriculturalMaterialsStockOutNotesIndexRoute
  '/agriculture/care-logs/': typeof AppAuthedSidebarAgricultureCareLogsIndexRoute
  '/agriculture/growers/': typeof AppAuthedSidebarAgricultureGrowersIndexRoute
  '/agriculture/my-grower/': typeof AppAuthedSidebarAgricultureMyGrowerIndexRoute
  '/customers/groups/': typeof AppAuthedSidebarCustomersGroupsIndexRoute
  '/organization/departments/': typeof AppAuthedSidebarOrganizationDepartmentsIndexRoute
  '/organization/employees/': typeof AppAuthedSidebarOrganizationEmployeesIndexRoute
  '/packaging-warehouse/count-log/': typeof AppAuthedSidebarPackagingWarehouseCountLogIndexRoute
  '/packaging-warehouse/lots/': typeof AppAuthedSidebarPackagingWarehouseLotsIndexRoute
  '/packaging-warehouse/stock-in-notes/': typeof AppAuthedSidebarPackagingWarehouseStockInNotesIndexRoute
  '/packaging-warehouse/stock-out-notes/': typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIndexRoute
  '/packaging-warehouse/withdrawal-notes/': typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesIndexRoute
  '/retail/accounts/': typeof AppAuthedSidebarRetailAccountsIndexRoute
  '/retail/groups/': typeof AppAuthedSidebarRetailGroupsIndexRoute
  '/retail/pages/': typeof AppAuthedSidebarRetailPagesIndexRoute
  '/retail/posts/': typeof AppAuthedSidebarRetailPostsIndexRoute
  '/sales-warehouse/box-log/': typeof AppAuthedSidebarSalesWarehouseBoxLogIndexRoute
  '/sales-warehouse/lots/': typeof AppAuthedSidebarSalesWarehouseLotsIndexRoute
  '/sales-warehouse/other-log/': typeof AppAuthedSidebarSalesWarehouseOtherLogIndexRoute
  '/sales-warehouse/packaging-log/': typeof AppAuthedSidebarSalesWarehousePackagingLogIndexRoute
  '/sales-warehouse/stock-in-notes/': typeof AppAuthedSidebarSalesWarehouseStockInNotesIndexRoute
  '/sales-warehouse/stock-out-notes/': typeof AppAuthedSidebarSalesWarehouseStockOutNotesIndexRoute
  '/sales-warehouse/transfer-notes/': typeof AppAuthedSidebarSalesWarehouseTransferNotesIndexRoute
  '/scenting-warehouse/log/': typeof AppAuthedSidebarScentingWarehouseLogIndexRoute
  '/scenting-warehouse/lots/': typeof AppAuthedSidebarScentingWarehouseLotsIndexRoute
  '/scenting-warehouse/stock-in-notes/': typeof AppAuthedSidebarScentingWarehouseStockInNotesIndexRoute
  '/scenting-warehouse/stock-out-notes/': typeof AppAuthedSidebarScentingWarehouseStockOutNotesIndexRoute
  '/scenting-warehouse/withdrawal-notes/': typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesIndexRoute
  '/settings/roles/': typeof AppAuthedSidebarSettingsRolesIndexRoute
  '/settings/zalo/': typeof AppAuthedSidebarSettingsZaloIndexRoute
  '/sorting-warehouse/lots/': typeof AppAuthedSidebarSortingWarehouseLotsIndexRoute
  '/sorting-warehouse/stock-in-notes/': typeof AppAuthedSidebarSortingWarehouseStockInNotesIndexRoute
  '/sorting-warehouse/stock-out-notes/': typeof AppAuthedSidebarSortingWarehouseStockOutNotesIndexRoute
  '/sorting-warehouse/withdrawal-notes/': typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesIndexRoute
  '/agricultural-materials/stock-in-notes/$id/edit': typeof AppAuthedSidebarAgriculturalMaterialsStockInNotesIdEditRoute
  '/agricultural-materials/stock-out-notes/$id/edit': typeof AppAuthedSidebarAgriculturalMaterialsStockOutNotesIdEditRoute
  '/agriculture/care-logs/$id/edit': typeof AppAuthedSidebarAgricultureCareLogsIdEditRoute
  '/agriculture/growers/$id/edit': typeof AppAuthedSidebarAgricultureGrowersIdEditRoute
  '/packaging-warehouse/stock-in-notes/$id/edit': typeof AppAuthedSidebarPackagingWarehouseStockInNotesIdEditRoute
  '/packaging-warehouse/stock-out-notes/$id/edit': typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIdEditRoute
  '/sales-warehouse/stock-in-notes/$id/edit': typeof AppAuthedSidebarSalesWarehouseStockInNotesIdEditRoute
  '/sales-warehouse/stock-out-notes/$id/edit': typeof AppAuthedSidebarSalesWarehouseStockOutNotesIdEditRoute
  '/sales-warehouse/transfer-notes/$id/edit': typeof AppAuthedSidebarSalesWarehouseTransferNotesIdEditRoute
  '/scenting-warehouse/stock-in-notes/$id/edit': typeof AppAuthedSidebarScentingWarehouseStockInNotesIdEditRoute
  '/scenting-warehouse/stock-out-notes/$id/edit': typeof AppAuthedSidebarScentingWarehouseStockOutNotesIdEditRoute
  '/settings/zalo/templates/$id': typeof AppAuthedSidebarSettingsZaloTemplatesIdRoute
  '/sorting-warehouse/stock-in-notes/$id/edit': typeof AppAuthedSidebarSortingWarehouseStockInNotesIdEditRoute
  '/sorting-warehouse/stock-out-notes/$id/edit': typeof AppAuthedSidebarSortingWarehouseStockOutNotesIdEditRoute
  '/settings/zalo/templates/': typeof AppAuthedSidebarSettingsZaloTemplatesIndexRoute
  '/agriculture/growers/$id/faces/$faceId': typeof AppAuthedSidebarAgricultureGrowersIdFacesFaceIdRoute
  '/agriculture/my-grower/$growerId/faces/$faceId': typeof AppAuthedSidebarAgricultureMyGrowerGrowerIdFacesFaceIdRoute
  '/agriculture/growers/$id/faces/': typeof AppAuthedSidebarAgricultureGrowersIdFacesIndexRoute
  '/agriculture/my-grower/$growerId/faces/': typeof AppAuthedSidebarAgricultureMyGrowerGrowerIdFacesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppAuthedSidebarIndexRoute
  '/login': typeof LoginRoute
  '/grower-areas/$id': typeof GrowerAreasIdRoute
  '/trace/$code': typeof TraceCodeRoute
  '/customer-display': typeof AppAuthedCustomerDisplayRoute
  '/station': typeof AppAuthedStationRoute
  '/agriculture': typeof AppAuthedSidebarAgricultureRouteRouteWithChildren
  '/retail': typeof AppAuthedSidebarRetailRouteRouteWithChildren
  '/dev-playground': typeof AppAuthedSidebarDevPlaygroundRoute
  '/kiotviet-orders': typeof AppAuthedSidebarKiotvietOrdersRoute
  '/tea-machines': typeof AppAuthedSidebarTeaMachinesRoute
  '/tracking': typeof AppAuthedSidebarTrackingRoute
  '/warehouse-stats': typeof AppAuthedSidebarWarehouseStatsRoute
  '/whats-new': typeof AppAuthedSidebarWhatsNewRoute
  '/sale/display': typeof AppAuthedSaleDisplayRoute
  '/station/production': typeof AppAuthedStationProductionRoute
  '/station/warehouse': typeof AppAuthedStationWarehouseRoute
  '/settings/zalo/callback': typeof AppSettingsZaloCallbackRoute
  '/sale': typeof AppAuthedSaleIndexRoute
  '/accounting/cash-flow': typeof AppAuthedSidebarAccountingCashFlowRoute
  '/accounting/expense-categories': typeof AppAuthedSidebarAccountingExpenseCategoriesRoute
  '/accounting/expense-rules': typeof AppAuthedSidebarAccountingExpenseRulesRoute
  '/accounting/expense-sync': typeof AppAuthedSidebarAccountingExpenseSyncRoute
  '/accounting/expenses': typeof AppAuthedSidebarAccountingExpensesRoute
  '/accounting/grower-payments': typeof AppAuthedSidebarAccountingGrowerPaymentsRoute
  '/accounting/reconciliation': typeof AppAuthedSidebarAccountingReconciliationRoute
  '/accounting/remittances': typeof AppAuthedSidebarAccountingRemittancesRoute
  '/agricultural-materials/stats': typeof AppAuthedSidebarAgriculturalMaterialsStatsRoute
  '/agriculture/area-map': typeof AppAuthedSidebarAgricultureAreaMapRoute
  '/agriculture/cameras': typeof AppAuthedSidebarAgricultureCamerasRoute
  '/agriculture/care-reminders': typeof AppAuthedSidebarAgricultureCareRemindersRoute
  '/agriculture/irrigation-devices': typeof AppAuthedSidebarAgricultureIrrigationDevicesRoute
  '/agriculture/my-reports': typeof AppAuthedSidebarAgricultureMyReportsRoute
  '/agriculture/my-weighings': typeof AppAuthedSidebarAgricultureMyWeighingsRoute
  '/agriculture/tea-types': typeof AppAuthedSidebarAgricultureTeaTypesRoute
  '/contract-deliveries/$id': typeof AppAuthedSidebarContractDeliveriesIdRoute
  '/contract-deliveries/new': typeof AppAuthedSidebarContractDeliveriesNewRoute
  '/customers/$customerId': typeof AppAuthedSidebarCustomersCustomerIdRoute
  '/customers/new': typeof AppAuthedSidebarCustomersNewRoute
  '/delivery-trips/$id': typeof AppAuthedSidebarDeliveryTripsIdRoute
  '/dried-tea-purchases/$id': typeof AppAuthedSidebarDriedTeaPurchasesIdRoute
  '/driver/available-orders': typeof AppAuthedSidebarDriverAvailableOrdersRoute
  '/driver/cash': typeof AppAuthedSidebarDriverCashRoute
  '/logistics/shipping-carriers': typeof AppAuthedSidebarLogisticsShippingCarriersRoute
  '/logistics/vtp-overdue': typeof AppAuthedSidebarLogisticsVtpOverdueRoute
  '/orders/$orderId': typeof AppAuthedSidebarOrdersOrderIdRoute
  '/orders/new': typeof AppAuthedSidebarOrdersNewRoute
  '/orders/quick': typeof AppAuthedSidebarOrdersQuickRoute
  '/packaging-warehouse/stats': typeof AppAuthedSidebarPackagingWarehouseStatsRoute
  '/products/$productId': typeof AppAuthedSidebarProductsProductIdRoute
  '/products/categories': typeof AppAuthedSidebarProductsCategoriesRoute
  '/products/certification-badges': typeof AppAuthedSidebarProductsCertificationBadgesRoute
  '/products/kiotviet-mapping': typeof AppAuthedSidebarProductsKiotvietMappingRoute
  '/products/new': typeof AppAuthedSidebarProductsNewRoute
  '/products/online-prices': typeof AppAuthedSidebarProductsOnlinePricesRoute
  '/reports/care-logs': typeof AppAuthedSidebarReportsCareLogsRoute
  '/reports/cashbook': typeof AppAuthedSidebarReportsCashbookRoute
  '/reports/debts': typeof AppAuthedSidebarReportsDebtsRoute
  '/reports/delivery': typeof AppAuthedSidebarReportsDeliveryRoute
  '/reports/expenses': typeof AppAuthedSidebarReportsExpensesRoute
  '/reports/geography': typeof AppAuthedSidebarReportsGeographyRoute
  '/reports/growers': typeof AppAuthedSidebarReportsGrowersRoute
  '/reports/inventory': typeof AppAuthedSidebarReportsInventoryRoute
  '/reports/positions': typeof AppAuthedSidebarReportsPositionsRoute
  '/reports/revenue': typeof AppAuthedSidebarReportsRevenueRoute
  '/reports/sales': typeof AppAuthedSidebarReportsSalesRoute
  '/reports/scenting-stock': typeof AppAuthedSidebarReportsScentingStockRoute
  '/reports/sorting-stock': typeof AppAuthedSidebarReportsSortingStockRoute
  '/reports/staff': typeof AppAuthedSidebarReportsStaffRoute
  '/reports/stock-out': typeof AppAuthedSidebarReportsStockOutRoute
  '/reports/website': typeof AppAuthedSidebarReportsWebsiteRoute
  '/reports/yield-loss': typeof AppAuthedSidebarReportsYieldLossRoute
  '/reports/zalo-mini-app': typeof AppAuthedSidebarReportsZaloMiniAppRoute
  '/retail/categories': typeof AppAuthedSidebarRetailCategoriesRoute
  '/retail/contact': typeof AppAuthedSidebarRetailContactRoute
  '/retail/guide-videos': typeof AppAuthedSidebarRetailGuideVideosRoute
  '/retail/home': typeof AppAuthedSidebarRetailHomeRoute
  '/retail/media': typeof AppAuthedSidebarRetailMediaRoute
  '/retail/member-tiers': typeof AppAuthedSidebarRetailMemberTiersRoute
  '/retail/online-prices': typeof AppAuthedSidebarRetailOnlinePricesRoute
  '/retail/post-categories': typeof AppAuthedSidebarRetailPostCategoriesRoute
  '/retail/site-settings': typeof AppAuthedSidebarRetailSiteSettingsRoute
  '/scenting-warehouse/grades': typeof AppAuthedSidebarScentingWarehouseGradesRoute
  '/scenting-warehouse/stats': typeof AppAuthedSidebarScentingWarehouseStatsRoute
  '/settings/face-recognition': typeof AppAuthedSidebarSettingsFaceRecognitionRoute
  '/settings/invoice': typeof AppAuthedSidebarSettingsInvoiceRoute
  '/settings/lot-sizes': typeof AppAuthedSidebarSettingsLotSizesRoute
  '/settings/notifications': typeof AppAuthedSidebarSettingsNotificationsRoute
  '/settings/printing': typeof AppAuthedSidebarSettingsPrintingRoute
  '/settings/production-station-voice': typeof AppAuthedSidebarSettingsProductionStationVoiceRoute
  '/settings/sidebar-layout': typeof AppAuthedSidebarSettingsSidebarLayoutRoute
  '/settings/sla': typeof AppAuthedSidebarSettingsSlaRoute
  '/settings/station-voice': typeof AppAuthedSidebarSettingsStationVoiceRoute
  '/settings/warehouse-station-voice': typeof AppAuthedSidebarSettingsWarehouseStationVoiceRoute
  '/sorting-warehouse/stats': typeof AppAuthedSidebarSortingWarehouseStatsRoute
  '/sorting-warehouse/tea-grades': typeof AppAuthedSidebarSortingWarehouseTeaGradesRoute
  '/stocktake/$id': typeof AppAuthedSidebarStocktakeIdRoute
  '/stocktake/new': typeof AppAuthedSidebarStocktakeNewRoute
  '/tea-purchases/$id': typeof AppAuthedSidebarTeaPurchasesIdRoute
  '/tea-purchases/processing': typeof AppAuthedSidebarTeaPurchasesProcessingRoute
  '/vehicles/$vehicleId': typeof AppAuthedSidebarVehiclesVehicleIdRoute
  '/warehouse-positions/$id': typeof AppAuthedSidebarWarehousePositionsIdRoute
  '/warehouse-positions/new': typeof AppAuthedSidebarWarehousePositionsNewRoute
  '/warehouse-sales/dashboard': typeof AppAuthedSidebarWarehouseSalesDashboardRoute
  '/warehouse-sales/defects': typeof AppAuthedSidebarWarehouseSalesDefectsRoute
  '/warehouse-sales/stats': typeof AppAuthedSidebarWarehouseSalesStatsRoute
  '/work-activities/board': typeof AppAuthedSidebarWorkActivitiesBoardRoute
  '/work-activities/calendar': typeof AppAuthedSidebarWorkActivitiesCalendarRoute
  '/work-activities/guests': typeof AppAuthedSidebarWorkActivitiesGuestsRoute
  '/support/t/$ref': typeof AppAuthedSupportTRefRoute
  '/accounting': typeof AppAuthedSidebarAccountingIndexRoute
  '/agricultural-materials': typeof AppAuthedSidebarAgriculturalMaterialsIndexRoute
  '/api-keys': typeof AppAuthedSidebarApiKeysIndexRoute
  '/contract-deliveries': typeof AppAuthedSidebarContractDeliveriesIndexRoute
  '/customers': typeof AppAuthedSidebarCustomersIndexRoute
  '/delivery-trips': typeof AppAuthedSidebarDeliveryTripsIndexRoute
  '/dried-tea-purchases': typeof AppAuthedSidebarDriedTeaPurchasesIndexRoute
  '/orders': typeof AppAuthedSidebarOrdersIndexRoute
  '/packaging': typeof AppAuthedSidebarPackagingIndexRoute
  '/products': typeof AppAuthedSidebarProductsIndexRoute
  '/reports': typeof AppAuthedSidebarReportsIndexRoute
  '/smartlab': typeof AppAuthedSidebarSmartlabIndexRoute
  '/stocktake': typeof AppAuthedSidebarStocktakeIndexRoute
  '/tea-purchases': typeof AppAuthedSidebarTeaPurchasesIndexRoute
  '/users': typeof AppAuthedSidebarUsersIndexRoute
  '/vehicles': typeof AppAuthedSidebarVehiclesIndexRoute
  '/warehouse-positions': typeof AppAuthedSidebarWarehousePositionsIndexRoute
  '/accounting/reports/daily': typeof AppAuthedSidebarAccountingReportsDailyRoute
  '/agricultural-materials/lots/$id': typeof AppAuthedSidebarAgriculturalMaterialsLotsIdRoute
  '/agricultural-materials/stock-in-notes/$id': typeof AppAuthedSidebarAgriculturalMaterialsStockInNotesIdRoute
  '/agricultural-materials/stock-in-notes/new': typeof AppAuthedSidebarAgriculturalMaterialsStockInNotesNewRoute
  '/agricultural-materials/stock-out-notes/$id': typeof AppAuthedSidebarAgriculturalMaterialsStockOutNotesIdRoute
  '/agricultural-materials/stock-out-notes/new': typeof AppAuthedSidebarAgriculturalMaterialsStockOutNotesNewRoute
  '/agriculture/care-logs/new': typeof AppAuthedSidebarAgricultureCareLogsNewRoute
  '/agriculture/growers/$id': typeof AppAuthedSidebarAgricultureGrowersIdRoute
  '/agriculture/growers/new': typeof AppAuthedSidebarAgricultureGrowersNewRoute
  '/agriculture/my-grower/$growerId': typeof AppAuthedSidebarAgricultureMyGrowerGrowerIdRoute
  '/customers/groups/$groupId': typeof AppAuthedSidebarCustomersGroupsGroupIdRoute
  '/packaging-warehouse/lots/$id': typeof AppAuthedSidebarPackagingWarehouseLotsIdRoute
  '/packaging-warehouse/stock-in-notes/$id': typeof AppAuthedSidebarPackagingWarehouseStockInNotesIdRoute
  '/packaging-warehouse/stock-in-notes/new': typeof AppAuthedSidebarPackagingWarehouseStockInNotesNewRoute
  '/packaging-warehouse/stock-out-notes/$id': typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIdRoute
  '/packaging-warehouse/stock-out-notes/new': typeof AppAuthedSidebarPackagingWarehouseStockOutNotesNewRoute
  '/packaging-warehouse/withdrawal-notes/$id': typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesIdRoute
  '/packaging-warehouse/withdrawal-notes/new': typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesNewRoute
  '/retail/accounts/$accountId': typeof AppAuthedSidebarRetailAccountsAccountIdRoute
  '/retail/groups/$groupId': typeof AppAuthedSidebarRetailGroupsGroupIdRoute
  '/retail/groups/new': typeof AppAuthedSidebarRetailGroupsNewRoute
  '/retail/pages/$pageId': typeof AppAuthedSidebarRetailPagesPageIdRoute
  '/retail/pages/new': typeof AppAuthedSidebarRetailPagesNewRoute
  '/retail/posts/$postId': typeof AppAuthedSidebarRetailPostsPostIdRoute
  '/retail/posts/new': typeof AppAuthedSidebarRetailPostsNewRoute
  '/sales-warehouse/lots/$id': typeof AppAuthedSidebarSalesWarehouseLotsIdRoute
  '/sales-warehouse/stock-in-notes/$id': typeof AppAuthedSidebarSalesWarehouseStockInNotesIdRoute
  '/sales-warehouse/stock-in-notes/new': typeof AppAuthedSidebarSalesWarehouseStockInNotesNewRoute
  '/sales-warehouse/stock-in-notes/quick': typeof AppAuthedSidebarSalesWarehouseStockInNotesQuickRoute
  '/sales-warehouse/stock-out-notes/$id': typeof AppAuthedSidebarSalesWarehouseStockOutNotesIdRoute
  '/sales-warehouse/stock-out-notes/new': typeof AppAuthedSidebarSalesWarehouseStockOutNotesNewRoute
  '/sales-warehouse/transfer-notes/$id': typeof AppAuthedSidebarSalesWarehouseTransferNotesIdRoute
  '/sales-warehouse/transfer-notes/new': typeof AppAuthedSidebarSalesWarehouseTransferNotesNewRoute
  '/scenting-warehouse/lots/$id': typeof AppAuthedSidebarScentingWarehouseLotsIdRoute
  '/scenting-warehouse/stock-in-notes/$id': typeof AppAuthedSidebarScentingWarehouseStockInNotesIdRoute
  '/scenting-warehouse/stock-in-notes/new': typeof AppAuthedSidebarScentingWarehouseStockInNotesNewRoute
  '/scenting-warehouse/stock-out-notes/$id': typeof AppAuthedSidebarScentingWarehouseStockOutNotesIdRoute
  '/scenting-warehouse/stock-out-notes/new': typeof AppAuthedSidebarScentingWarehouseStockOutNotesNewRoute
  '/scenting-warehouse/withdrawal-notes/$id': typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesIdRoute
  '/scenting-warehouse/withdrawal-notes/new': typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesNewRoute
  '/settings/roles/$id': typeof AppAuthedSidebarSettingsRolesIdRoute
  '/settings/zalo/messages': typeof AppAuthedSidebarSettingsZaloMessagesRoute
  '/settings/zalo/purposes': typeof AppAuthedSidebarSettingsZaloPurposesRoute
  '/sorting-warehouse/lots/$id': typeof AppAuthedSidebarSortingWarehouseLotsIdRoute
  '/sorting-warehouse/stock-in-notes/$id': typeof AppAuthedSidebarSortingWarehouseStockInNotesIdRoute
  '/sorting-warehouse/stock-in-notes/new': typeof AppAuthedSidebarSortingWarehouseStockInNotesNewRoute
  '/sorting-warehouse/stock-out-notes/$id': typeof AppAuthedSidebarSortingWarehouseStockOutNotesIdRoute
  '/sorting-warehouse/stock-out-notes/new': typeof AppAuthedSidebarSortingWarehouseStockOutNotesNewRoute
  '/sorting-warehouse/withdrawal-notes/$id': typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesIdRoute
  '/sorting-warehouse/withdrawal-notes/new': typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesNewRoute
  '/agricultural-materials/lots': typeof AppAuthedSidebarAgriculturalMaterialsLotsIndexRoute
  '/agricultural-materials/stock-in-notes': typeof AppAuthedSidebarAgriculturalMaterialsStockInNotesIndexRoute
  '/agricultural-materials/stock-out-notes': typeof AppAuthedSidebarAgriculturalMaterialsStockOutNotesIndexRoute
  '/agriculture/care-logs': typeof AppAuthedSidebarAgricultureCareLogsIndexRoute
  '/agriculture/growers': typeof AppAuthedSidebarAgricultureGrowersIndexRoute
  '/agriculture/my-grower': typeof AppAuthedSidebarAgricultureMyGrowerIndexRoute
  '/customers/groups': typeof AppAuthedSidebarCustomersGroupsIndexRoute
  '/organization/departments': typeof AppAuthedSidebarOrganizationDepartmentsIndexRoute
  '/organization/employees': typeof AppAuthedSidebarOrganizationEmployeesIndexRoute
  '/packaging-warehouse/count-log': typeof AppAuthedSidebarPackagingWarehouseCountLogIndexRoute
  '/packaging-warehouse/lots': typeof AppAuthedSidebarPackagingWarehouseLotsIndexRoute
  '/packaging-warehouse/stock-in-notes': typeof AppAuthedSidebarPackagingWarehouseStockInNotesIndexRoute
  '/packaging-warehouse/stock-out-notes': typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIndexRoute
  '/packaging-warehouse/withdrawal-notes': typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesIndexRoute
  '/retail/accounts': typeof AppAuthedSidebarRetailAccountsIndexRoute
  '/retail/groups': typeof AppAuthedSidebarRetailGroupsIndexRoute
  '/retail/pages': typeof AppAuthedSidebarRetailPagesIndexRoute
  '/retail/posts': typeof AppAuthedSidebarRetailPostsIndexRoute
  '/sales-warehouse/box-log': typeof AppAuthedSidebarSalesWarehouseBoxLogIndexRoute
  '/sales-warehouse/lots': typeof AppAuthedSidebarSalesWarehouseLotsIndexRoute
  '/sales-warehouse/other-log': typeof AppAuthedSidebarSalesWarehouseOtherLogIndexRoute
  '/sales-warehouse/packaging-log': typeof AppAuthedSidebarSalesWarehousePackagingLogIndexRoute
  '/sales-warehouse/stock-in-notes': typeof AppAuthedSidebarSalesWarehouseStockInNotesIndexRoute
  '/sales-warehouse/stock-out-notes': typeof AppAuthedSidebarSalesWarehouseStockOutNotesIndexRoute
  '/sales-warehouse/transfer-notes': typeof AppAuthedSidebarSalesWarehouseTransferNotesIndexRoute
  '/scenting-warehouse/log': typeof AppAuthedSidebarScentingWarehouseLogIndexRoute
  '/scenting-warehouse/lots': typeof AppAuthedSidebarScentingWarehouseLotsIndexRoute
  '/scenting-warehouse/stock-in-notes': typeof AppAuthedSidebarScentingWarehouseStockInNotesIndexRoute
  '/scenting-warehouse/stock-out-notes': typeof AppAuthedSidebarScentingWarehouseStockOutNotesIndexRoute
  '/scenting-warehouse/withdrawal-notes': typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesIndexRoute
  '/settings/roles': typeof AppAuthedSidebarSettingsRolesIndexRoute
  '/settings/zalo': typeof AppAuthedSidebarSettingsZaloIndexRoute
  '/sorting-warehouse/lots': typeof AppAuthedSidebarSortingWarehouseLotsIndexRoute
  '/sorting-warehouse/stock-in-notes': typeof AppAuthedSidebarSortingWarehouseStockInNotesIndexRoute
  '/sorting-warehouse/stock-out-notes': typeof AppAuthedSidebarSortingWarehouseStockOutNotesIndexRoute
  '/sorting-warehouse/withdrawal-notes': typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesIndexRoute
  '/agricultural-materials/stock-in-notes/$id/edit': typeof AppAuthedSidebarAgriculturalMaterialsStockInNotesIdEditRoute
  '/agricultural-materials/stock-out-notes/$id/edit': typeof AppAuthedSidebarAgriculturalMaterialsStockOutNotesIdEditRoute
  '/agriculture/care-logs/$id/edit': typeof AppAuthedSidebarAgricultureCareLogsIdEditRoute
  '/agriculture/growers/$id/edit': typeof AppAuthedSidebarAgricultureGrowersIdEditRoute
  '/packaging-warehouse/stock-in-notes/$id/edit': typeof AppAuthedSidebarPackagingWarehouseStockInNotesIdEditRoute
  '/packaging-warehouse/stock-out-notes/$id/edit': typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIdEditRoute
  '/sales-warehouse/stock-in-notes/$id/edit': typeof AppAuthedSidebarSalesWarehouseStockInNotesIdEditRoute
  '/sales-warehouse/stock-out-notes/$id/edit': typeof AppAuthedSidebarSalesWarehouseStockOutNotesIdEditRoute
  '/sales-warehouse/transfer-notes/$id/edit': typeof AppAuthedSidebarSalesWarehouseTransferNotesIdEditRoute
  '/scenting-warehouse/stock-in-notes/$id/edit': typeof AppAuthedSidebarScentingWarehouseStockInNotesIdEditRoute
  '/scenting-warehouse/stock-out-notes/$id/edit': typeof AppAuthedSidebarScentingWarehouseStockOutNotesIdEditRoute
  '/settings/zalo/templates/$id': typeof AppAuthedSidebarSettingsZaloTemplatesIdRoute
  '/sorting-warehouse/stock-in-notes/$id/edit': typeof AppAuthedSidebarSortingWarehouseStockInNotesIdEditRoute
  '/sorting-warehouse/stock-out-notes/$id/edit': typeof AppAuthedSidebarSortingWarehouseStockOutNotesIdEditRoute
  '/settings/zalo/templates': typeof AppAuthedSidebarSettingsZaloTemplatesIndexRoute
  '/agriculture/growers/$id/faces/$faceId': typeof AppAuthedSidebarAgricultureGrowersIdFacesFaceIdRoute
  '/agriculture/my-grower/$growerId/faces/$faceId': typeof AppAuthedSidebarAgricultureMyGrowerGrowerIdFacesFaceIdRoute
  '/agriculture/growers/$id/faces': typeof AppAuthedSidebarAgricultureGrowersIdFacesIndexRoute
  '/agriculture/my-grower/$growerId/faces': typeof AppAuthedSidebarAgricultureMyGrowerGrowerIdFacesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/_authed': typeof AppAuthedRouteWithChildren
  '/grower-areas/$id': typeof GrowerAreasIdRoute
  '/trace/$code': typeof TraceCodeRoute
  '/_app/_authed/_sidebar': typeof AppAuthedSidebarRouteWithChildren
  '/_app/_authed/customer-display': typeof AppAuthedCustomerDisplayRoute
  '/_app/_authed/sale': typeof AppAuthedSaleRouteWithChildren
  '/_app/_authed/station': typeof AppAuthedStationRoute
  '/_app/_authed/_sidebar/agriculture': typeof AppAuthedSidebarAgricultureRouteRouteWithChildren
  '/_app/_authed/_sidebar/retail': typeof AppAuthedSidebarRetailRouteRouteWithChildren
  '/_app/_authed/_sidebar/dev-playground': typeof AppAuthedSidebarDevPlaygroundRoute
  '/_app/_authed/_sidebar/kiotviet-orders': typeof AppAuthedSidebarKiotvietOrdersRoute
  '/_app/_authed/_sidebar/tea-machines': typeof AppAuthedSidebarTeaMachinesRoute
  '/_app/_authed/_sidebar/tracking': typeof AppAuthedSidebarTrackingRoute
  '/_app/_authed/_sidebar/warehouse-stats': typeof AppAuthedSidebarWarehouseStatsRoute
  '/_app/_authed/_sidebar/whats-new': typeof AppAuthedSidebarWhatsNewRoute
  '/_app/_authed/sale/display': typeof AppAuthedSaleDisplayRoute
  '/_app/_authed/station_/production': typeof AppAuthedStationProductionRoute
  '/_app/_authed/station_/warehouse': typeof AppAuthedStationWarehouseRoute
  '/_app/settings/zalo/callback': typeof AppSettingsZaloCallbackRoute
  '/_app/_authed/_sidebar/': typeof AppAuthedSidebarIndexRoute
  '/_app/_authed/sale/': typeof AppAuthedSaleIndexRoute
  '/_app/_authed/_sidebar/accounting/cash-flow': typeof AppAuthedSidebarAccountingCashFlowRoute
  '/_app/_authed/_sidebar/accounting/expense-categories': typeof AppAuthedSidebarAccountingExpenseCategoriesRoute
  '/_app/_authed/_sidebar/accounting/expense-rules': typeof AppAuthedSidebarAccountingExpenseRulesRoute
  '/_app/_authed/_sidebar/accounting/expense-sync': typeof AppAuthedSidebarAccountingExpenseSyncRoute
  '/_app/_authed/_sidebar/accounting/expenses': typeof AppAuthedSidebarAccountingExpensesRoute
  '/_app/_authed/_sidebar/accounting/grower-payments': typeof AppAuthedSidebarAccountingGrowerPaymentsRoute
  '/_app/_authed/_sidebar/accounting/reconciliation': typeof AppAuthedSidebarAccountingReconciliationRoute
  '/_app/_authed/_sidebar/accounting/remittances': typeof AppAuthedSidebarAccountingRemittancesRoute
  '/_app/_authed/_sidebar/agricultural-materials/stats': typeof AppAuthedSidebarAgriculturalMaterialsStatsRoute
  '/_app/_authed/_sidebar/agriculture/area-map': typeof AppAuthedSidebarAgricultureAreaMapRoute
  '/_app/_authed/_sidebar/agriculture/cameras': typeof AppAuthedSidebarAgricultureCamerasRoute
  '/_app/_authed/_sidebar/agriculture/care-logs': typeof AppAuthedSidebarAgricultureCareLogsRouteWithChildren
  '/_app/_authed/_sidebar/agriculture/care-reminders': typeof AppAuthedSidebarAgricultureCareRemindersRoute
  '/_app/_authed/_sidebar/agriculture/growers': typeof AppAuthedSidebarAgricultureGrowersRouteWithChildren
  '/_app/_authed/_sidebar/agriculture/irrigation-devices': typeof AppAuthedSidebarAgricultureIrrigationDevicesRoute
  '/_app/_authed/_sidebar/agriculture/my-reports': typeof AppAuthedSidebarAgricultureMyReportsRoute
  '/_app/_authed/_sidebar/agriculture/my-weighings': typeof AppAuthedSidebarAgricultureMyWeighingsRoute
  '/_app/_authed/_sidebar/agriculture/tea-types': typeof AppAuthedSidebarAgricultureTeaTypesRoute
  '/_app/_authed/_sidebar/contract-deliveries/$id': typeof AppAuthedSidebarContractDeliveriesIdRoute
  '/_app/_authed/_sidebar/contract-deliveries/new': typeof AppAuthedSidebarContractDeliveriesNewRoute
  '/_app/_authed/_sidebar/customers/$customerId': typeof AppAuthedSidebarCustomersCustomerIdRoute
  '/_app/_authed/_sidebar/customers/new': typeof AppAuthedSidebarCustomersNewRoute
  '/_app/_authed/_sidebar/delivery-trips/$id': typeof AppAuthedSidebarDeliveryTripsIdRoute
  '/_app/_authed/_sidebar/dried-tea-purchases/$id': typeof AppAuthedSidebarDriedTeaPurchasesIdRoute
  '/_app/_authed/_sidebar/driver/available-orders': typeof AppAuthedSidebarDriverAvailableOrdersRoute
  '/_app/_authed/_sidebar/driver/cash': typeof AppAuthedSidebarDriverCashRoute
  '/_app/_authed/_sidebar/logistics/shipping-carriers': typeof AppAuthedSidebarLogisticsShippingCarriersRoute
  '/_app/_authed/_sidebar/logistics/vtp-overdue': typeof AppAuthedSidebarLogisticsVtpOverdueRoute
  '/_app/_authed/_sidebar/orders/$orderId': typeof AppAuthedSidebarOrdersOrderIdRoute
  '/_app/_authed/_sidebar/orders/new': typeof AppAuthedSidebarOrdersNewRoute
  '/_app/_authed/_sidebar/orders/quick': typeof AppAuthedSidebarOrdersQuickRoute
  '/_app/_authed/_sidebar/packaging-warehouse/stats': typeof AppAuthedSidebarPackagingWarehouseStatsRoute
  '/_app/_authed/_sidebar/products/$productId': typeof AppAuthedSidebarProductsProductIdRoute
  '/_app/_authed/_sidebar/products/categories': typeof AppAuthedSidebarProductsCategoriesRoute
  '/_app/_authed/_sidebar/products/certification-badges': typeof AppAuthedSidebarProductsCertificationBadgesRoute
  '/_app/_authed/_sidebar/products/kiotviet-mapping': typeof AppAuthedSidebarProductsKiotvietMappingRoute
  '/_app/_authed/_sidebar/products/new': typeof AppAuthedSidebarProductsNewRoute
  '/_app/_authed/_sidebar/products/online-prices': typeof AppAuthedSidebarProductsOnlinePricesRoute
  '/_app/_authed/_sidebar/reports/care-logs': typeof AppAuthedSidebarReportsCareLogsRoute
  '/_app/_authed/_sidebar/reports/cashbook': typeof AppAuthedSidebarReportsCashbookRoute
  '/_app/_authed/_sidebar/reports/debts': typeof AppAuthedSidebarReportsDebtsRoute
  '/_app/_authed/_sidebar/reports/delivery': typeof AppAuthedSidebarReportsDeliveryRoute
  '/_app/_authed/_sidebar/reports/expenses': typeof AppAuthedSidebarReportsExpensesRoute
  '/_app/_authed/_sidebar/reports/geography': typeof AppAuthedSidebarReportsGeographyRoute
  '/_app/_authed/_sidebar/reports/growers': typeof AppAuthedSidebarReportsGrowersRoute
  '/_app/_authed/_sidebar/reports/inventory': typeof AppAuthedSidebarReportsInventoryRoute
  '/_app/_authed/_sidebar/reports/positions': typeof AppAuthedSidebarReportsPositionsRoute
  '/_app/_authed/_sidebar/reports/revenue': typeof AppAuthedSidebarReportsRevenueRoute
  '/_app/_authed/_sidebar/reports/sales': typeof AppAuthedSidebarReportsSalesRoute
  '/_app/_authed/_sidebar/reports/scenting-stock': typeof AppAuthedSidebarReportsScentingStockRoute
  '/_app/_authed/_sidebar/reports/sorting-stock': typeof AppAuthedSidebarReportsSortingStockRoute
  '/_app/_authed/_sidebar/reports/staff': typeof AppAuthedSidebarReportsStaffRoute
  '/_app/_authed/_sidebar/reports/stock-out': typeof AppAuthedSidebarReportsStockOutRoute
  '/_app/_authed/_sidebar/reports/website': typeof AppAuthedSidebarReportsWebsiteRoute
  '/_app/_authed/_sidebar/reports/yield-loss': typeof AppAuthedSidebarReportsYieldLossRoute
  '/_app/_authed/_sidebar/reports/zalo-mini-app': typeof AppAuthedSidebarReportsZaloMiniAppRoute
  '/_app/_authed/_sidebar/retail/categories': typeof AppAuthedSidebarRetailCategoriesRoute
  '/_app/_authed/_sidebar/retail/contact': typeof AppAuthedSidebarRetailContactRoute
  '/_app/_authed/_sidebar/retail/guide-videos': typeof AppAuthedSidebarRetailGuideVideosRoute
  '/_app/_authed/_sidebar/retail/home': typeof AppAuthedSidebarRetailHomeRoute
  '/_app/_authed/_sidebar/retail/media': typeof AppAuthedSidebarRetailMediaRoute
  '/_app/_authed/_sidebar/retail/member-tiers': typeof AppAuthedSidebarRetailMemberTiersRoute
  '/_app/_authed/_sidebar/retail/online-prices': typeof AppAuthedSidebarRetailOnlinePricesRoute
  '/_app/_authed/_sidebar/retail/post-categories': typeof AppAuthedSidebarRetailPostCategoriesRoute
  '/_app/_authed/_sidebar/retail/site-settings': typeof AppAuthedSidebarRetailSiteSettingsRoute
  '/_app/_authed/_sidebar/scenting-warehouse/grades': typeof AppAuthedSidebarScentingWarehouseGradesRoute
  '/_app/_authed/_sidebar/scenting-warehouse/stats': typeof AppAuthedSidebarScentingWarehouseStatsRoute
  '/_app/_authed/_sidebar/settings/face-recognition': typeof AppAuthedSidebarSettingsFaceRecognitionRoute
  '/_app/_authed/_sidebar/settings/invoice': typeof AppAuthedSidebarSettingsInvoiceRoute
  '/_app/_authed/_sidebar/settings/lot-sizes': typeof AppAuthedSidebarSettingsLotSizesRoute
  '/_app/_authed/_sidebar/settings/notifications': typeof AppAuthedSidebarSettingsNotificationsRoute
  '/_app/_authed/_sidebar/settings/printing': typeof AppAuthedSidebarSettingsPrintingRoute
  '/_app/_authed/_sidebar/settings/production-station-voice': typeof AppAuthedSidebarSettingsProductionStationVoiceRoute
  '/_app/_authed/_sidebar/settings/sidebar-layout': typeof AppAuthedSidebarSettingsSidebarLayoutRoute
  '/_app/_authed/_sidebar/settings/sla': typeof AppAuthedSidebarSettingsSlaRoute
  '/_app/_authed/_sidebar/settings/station-voice': typeof AppAuthedSidebarSettingsStationVoiceRoute
  '/_app/_authed/_sidebar/settings/warehouse-station-voice': typeof AppAuthedSidebarSettingsWarehouseStationVoiceRoute
  '/_app/_authed/_sidebar/settings/zalo': typeof AppAuthedSidebarSettingsZaloRouteWithChildren
  '/_app/_authed/_sidebar/sorting-warehouse/stats': typeof AppAuthedSidebarSortingWarehouseStatsRoute
  '/_app/_authed/_sidebar/sorting-warehouse/tea-grades': typeof AppAuthedSidebarSortingWarehouseTeaGradesRoute
  '/_app/_authed/_sidebar/stocktake/$id': typeof AppAuthedSidebarStocktakeIdRoute
  '/_app/_authed/_sidebar/stocktake/new': typeof AppAuthedSidebarStocktakeNewRoute
  '/_app/_authed/_sidebar/tea-purchases/$id': typeof AppAuthedSidebarTeaPurchasesIdRoute
  '/_app/_authed/_sidebar/tea-purchases/processing': typeof AppAuthedSidebarTeaPurchasesProcessingRoute
  '/_app/_authed/_sidebar/vehicles/$vehicleId': typeof AppAuthedSidebarVehiclesVehicleIdRoute
  '/_app/_authed/_sidebar/warehouse-positions/$id': typeof AppAuthedSidebarWarehousePositionsIdRoute
  '/_app/_authed/_sidebar/warehouse-positions/new': typeof AppAuthedSidebarWarehousePositionsNewRoute
  '/_app/_authed/_sidebar/warehouse-sales/dashboard': typeof AppAuthedSidebarWarehouseSalesDashboardRoute
  '/_app/_authed/_sidebar/warehouse-sales/defects': typeof AppAuthedSidebarWarehouseSalesDefectsRoute
  '/_app/_authed/_sidebar/warehouse-sales/stats': typeof AppAuthedSidebarWarehouseSalesStatsRoute
  '/_app/_authed/_sidebar/work-activities/board': typeof AppAuthedSidebarWorkActivitiesBoardRoute
  '/_app/_authed/_sidebar/work-activities/calendar': typeof AppAuthedSidebarWorkActivitiesCalendarRoute
  '/_app/_authed/_sidebar/work-activities/guests': typeof AppAuthedSidebarWorkActivitiesGuestsRoute
  '/_app/_authed/support/t/$ref': typeof AppAuthedSupportTRefRoute
  '/_app/_authed/_sidebar/accounting/': typeof AppAuthedSidebarAccountingIndexRoute
  '/_app/_authed/_sidebar/agricultural-materials/': typeof AppAuthedSidebarAgriculturalMaterialsIndexRoute
  '/_app/_authed/_sidebar/api-keys/': typeof AppAuthedSidebarApiKeysIndexRoute
  '/_app/_authed/_sidebar/contract-deliveries/': typeof AppAuthedSidebarContractDeliveriesIndexRoute
  '/_app/_authed/_sidebar/customers/': typeof AppAuthedSidebarCustomersIndexRoute
  '/_app/_authed/_sidebar/delivery-trips/': typeof AppAuthedSidebarDeliveryTripsIndexRoute
  '/_app/_authed/_sidebar/dried-tea-purchases/': typeof AppAuthedSidebarDriedTeaPurchasesIndexRoute
  '/_app/_authed/_sidebar/orders/': typeof AppAuthedSidebarOrdersIndexRoute
  '/_app/_authed/_sidebar/packaging/': typeof AppAuthedSidebarPackagingIndexRoute
  '/_app/_authed/_sidebar/products/': typeof AppAuthedSidebarProductsIndexRoute
  '/_app/_authed/_sidebar/reports/': typeof AppAuthedSidebarReportsIndexRoute
  '/_app/_authed/_sidebar/smartlab/': typeof AppAuthedSidebarSmartlabIndexRoute
  '/_app/_authed/_sidebar/stocktake/': typeof AppAuthedSidebarStocktakeIndexRoute
  '/_app/_authed/_sidebar/tea-purchases/': typeof AppAuthedSidebarTeaPurchasesIndexRoute
  '/_app/_authed/_sidebar/users/': typeof AppAuthedSidebarUsersIndexRoute
  '/_app/_authed/_sidebar/vehicles/': typeof AppAuthedSidebarVehiclesIndexRoute
  '/_app/_authed/_sidebar/warehouse-positions/': typeof AppAuthedSidebarWarehousePositionsIndexRoute
  '/_app/_authed/_sidebar/accounting/reports/daily': typeof AppAuthedSidebarAccountingReportsDailyRoute
  '/_app/_authed/_sidebar/agricultural-materials/lots/$id': typeof AppAuthedSidebarAgriculturalMaterialsLotsIdRoute
  '/_app/_authed/_sidebar/agricultural-materials/stock-in-notes/$id': typeof AppAuthedSidebarAgriculturalMaterialsStockInNotesIdRoute
  '/_app/_authed/_sidebar/agricultural-materials/stock-in-notes/new': typeof AppAuthedSidebarAgriculturalMaterialsStockInNotesNewRoute
  '/_app/_authed/_sidebar/agricultural-materials/stock-out-notes/$id': typeof AppAuthedSidebarAgriculturalMaterialsStockOutNotesIdRoute
  '/_app/_authed/_sidebar/agricultural-materials/stock-out-notes/new': typeof AppAuthedSidebarAgriculturalMaterialsStockOutNotesNewRoute
  '/_app/_authed/_sidebar/agriculture/care-logs/new': typeof AppAuthedSidebarAgricultureCareLogsNewRoute
  '/_app/_authed/_sidebar/agriculture/growers/$id': typeof AppAuthedSidebarAgricultureGrowersIdRoute
  '/_app/_authed/_sidebar/agriculture/growers/new': typeof AppAuthedSidebarAgricultureGrowersNewRoute
  '/_app/_authed/_sidebar/agriculture/my-grower/$growerId': typeof AppAuthedSidebarAgricultureMyGrowerGrowerIdRoute
  '/_app/_authed/_sidebar/customers/groups/$groupId': typeof AppAuthedSidebarCustomersGroupsGroupIdRoute
  '/_app/_authed/_sidebar/packaging-warehouse/lots/$id': typeof AppAuthedSidebarPackagingWarehouseLotsIdRoute
  '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/$id': typeof AppAuthedSidebarPackagingWarehouseStockInNotesIdRoute
  '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/new': typeof AppAuthedSidebarPackagingWarehouseStockInNotesNewRoute
  '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/$id': typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIdRoute
  '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/new': typeof AppAuthedSidebarPackagingWarehouseStockOutNotesNewRoute
  '/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/$id': typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesIdRoute
  '/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/new': typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesNewRoute
  '/_app/_authed/_sidebar/retail/accounts/$accountId': typeof AppAuthedSidebarRetailAccountsAccountIdRoute
  '/_app/_authed/_sidebar/retail/groups/$groupId': typeof AppAuthedSidebarRetailGroupsGroupIdRoute
  '/_app/_authed/_sidebar/retail/groups/new': typeof AppAuthedSidebarRetailGroupsNewRoute
  '/_app/_authed/_sidebar/retail/pages/$pageId': typeof AppAuthedSidebarRetailPagesPageIdRoute
  '/_app/_authed/_sidebar/retail/pages/new': typeof AppAuthedSidebarRetailPagesNewRoute
  '/_app/_authed/_sidebar/retail/posts/$postId': typeof AppAuthedSidebarRetailPostsPostIdRoute
  '/_app/_authed/_sidebar/retail/posts/new': typeof AppAuthedSidebarRetailPostsNewRoute
  '/_app/_authed/_sidebar/sales-warehouse/lots/$id': typeof AppAuthedSidebarSalesWarehouseLotsIdRoute
  '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/$id': typeof AppAuthedSidebarSalesWarehouseStockInNotesIdRoute
  '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/new': typeof AppAuthedSidebarSalesWarehouseStockInNotesNewRoute
  '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/quick': typeof AppAuthedSidebarSalesWarehouseStockInNotesQuickRoute
  '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/$id': typeof AppAuthedSidebarSalesWarehouseStockOutNotesIdRoute
  '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/new': typeof AppAuthedSidebarSalesWarehouseStockOutNotesNewRoute
  '/_app/_authed/_sidebar/sales-warehouse/transfer-notes/$id': typeof AppAuthedSidebarSalesWarehouseTransferNotesIdRoute
  '/_app/_authed/_sidebar/sales-warehouse/transfer-notes/new': typeof AppAuthedSidebarSalesWarehouseTransferNotesNewRoute
  '/_app/_authed/_sidebar/scenting-warehouse/lots/$id': typeof AppAuthedSidebarScentingWarehouseLotsIdRoute
  '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/$id': typeof AppAuthedSidebarScentingWarehouseStockInNotesIdRoute
  '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/new': typeof AppAuthedSidebarScentingWarehouseStockInNotesNewRoute
  '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/$id': typeof AppAuthedSidebarScentingWarehouseStockOutNotesIdRoute
  '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/new': typeof AppAuthedSidebarScentingWarehouseStockOutNotesNewRoute
  '/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/$id': typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesIdRoute
  '/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/new': typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesNewRoute
  '/_app/_authed/_sidebar/settings/roles/$id': typeof AppAuthedSidebarSettingsRolesIdRoute
  '/_app/_authed/_sidebar/settings/zalo/messages': typeof AppAuthedSidebarSettingsZaloMessagesRoute
  '/_app/_authed/_sidebar/settings/zalo/purposes': typeof AppAuthedSidebarSettingsZaloPurposesRoute
  '/_app/_authed/_sidebar/sorting-warehouse/lots/$id': typeof AppAuthedSidebarSortingWarehouseLotsIdRoute
  '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/$id': typeof AppAuthedSidebarSortingWarehouseStockInNotesIdRoute
  '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/new': typeof AppAuthedSidebarSortingWarehouseStockInNotesNewRoute
  '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/$id': typeof AppAuthedSidebarSortingWarehouseStockOutNotesIdRoute
  '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/new': typeof AppAuthedSidebarSortingWarehouseStockOutNotesNewRoute
  '/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/$id': typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesIdRoute
  '/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/new': typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesNewRoute
  '/_app/_authed/_sidebar/agricultural-materials/lots/': typeof AppAuthedSidebarAgriculturalMaterialsLotsIndexRoute
  '/_app/_authed/_sidebar/agricultural-materials/stock-in-notes/': typeof AppAuthedSidebarAgriculturalMaterialsStockInNotesIndexRoute
  '/_app/_authed/_sidebar/agricultural-materials/stock-out-notes/': typeof AppAuthedSidebarAgriculturalMaterialsStockOutNotesIndexRoute
  '/_app/_authed/_sidebar/agriculture/care-logs/': typeof AppAuthedSidebarAgricultureCareLogsIndexRoute
  '/_app/_authed/_sidebar/agriculture/growers/': typeof AppAuthedSidebarAgricultureGrowersIndexRoute
  '/_app/_authed/_sidebar/agriculture/my-grower/': typeof AppAuthedSidebarAgricultureMyGrowerIndexRoute
  '/_app/_authed/_sidebar/customers/groups/': typeof AppAuthedSidebarCustomersGroupsIndexRoute
  '/_app/_authed/_sidebar/organization/departments/': typeof AppAuthedSidebarOrganizationDepartmentsIndexRoute
  '/_app/_authed/_sidebar/organization/employees/': typeof AppAuthedSidebarOrganizationEmployeesIndexRoute
  '/_app/_authed/_sidebar/packaging-warehouse/count-log/': typeof AppAuthedSidebarPackagingWarehouseCountLogIndexRoute
  '/_app/_authed/_sidebar/packaging-warehouse/lots/': typeof AppAuthedSidebarPackagingWarehouseLotsIndexRoute
  '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/': typeof AppAuthedSidebarPackagingWarehouseStockInNotesIndexRoute
  '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/': typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIndexRoute
  '/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/': typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesIndexRoute
  '/_app/_authed/_sidebar/retail/accounts/': typeof AppAuthedSidebarRetailAccountsIndexRoute
  '/_app/_authed/_sidebar/retail/groups/': typeof AppAuthedSidebarRetailGroupsIndexRoute
  '/_app/_authed/_sidebar/retail/pages/': typeof AppAuthedSidebarRetailPagesIndexRoute
  '/_app/_authed/_sidebar/retail/posts/': typeof AppAuthedSidebarRetailPostsIndexRoute
  '/_app/_authed/_sidebar/sales-warehouse/box-log/': typeof AppAuthedSidebarSalesWarehouseBoxLogIndexRoute
  '/_app/_authed/_sidebar/sales-warehouse/lots/': typeof AppAuthedSidebarSalesWarehouseLotsIndexRoute
  '/_app/_authed/_sidebar/sales-warehouse/other-log/': typeof AppAuthedSidebarSalesWarehouseOtherLogIndexRoute
  '/_app/_authed/_sidebar/sales-warehouse/packaging-log/': typeof AppAuthedSidebarSalesWarehousePackagingLogIndexRoute
  '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/': typeof AppAuthedSidebarSalesWarehouseStockInNotesIndexRoute
  '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/': typeof AppAuthedSidebarSalesWarehouseStockOutNotesIndexRoute
  '/_app/_authed/_sidebar/sales-warehouse/transfer-notes/': typeof AppAuthedSidebarSalesWarehouseTransferNotesIndexRoute
  '/_app/_authed/_sidebar/scenting-warehouse/log/': typeof AppAuthedSidebarScentingWarehouseLogIndexRoute
  '/_app/_authed/_sidebar/scenting-warehouse/lots/': typeof AppAuthedSidebarScentingWarehouseLotsIndexRoute
  '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/': typeof AppAuthedSidebarScentingWarehouseStockInNotesIndexRoute
  '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/': typeof AppAuthedSidebarScentingWarehouseStockOutNotesIndexRoute
  '/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/': typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesIndexRoute
  '/_app/_authed/_sidebar/settings/roles/': typeof AppAuthedSidebarSettingsRolesIndexRoute
  '/_app/_authed/_sidebar/settings/zalo/': typeof AppAuthedSidebarSettingsZaloIndexRoute
  '/_app/_authed/_sidebar/sorting-warehouse/lots/': typeof AppAuthedSidebarSortingWarehouseLotsIndexRoute
  '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/': typeof AppAuthedSidebarSortingWarehouseStockInNotesIndexRoute
  '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/': typeof AppAuthedSidebarSortingWarehouseStockOutNotesIndexRoute
  '/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/': typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesIndexRoute
  '/_app/_authed/_sidebar/agricultural-materials/stock-in-notes/$id_/edit': typeof AppAuthedSidebarAgriculturalMaterialsStockInNotesIdEditRoute
  '/_app/_authed/_sidebar/agricultural-materials/stock-out-notes/$id_/edit': typeof AppAuthedSidebarAgriculturalMaterialsStockOutNotesIdEditRoute
  '/_app/_authed/_sidebar/agriculture/care-logs/$id/edit': typeof AppAuthedSidebarAgricultureCareLogsIdEditRoute
  '/_app/_authed/_sidebar/agriculture/growers/$id_/edit': typeof AppAuthedSidebarAgricultureGrowersIdEditRoute
  '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/$id_/edit': typeof AppAuthedSidebarPackagingWarehouseStockInNotesIdEditRoute
  '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/$id_/edit': typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIdEditRoute
  '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/$id_/edit': typeof AppAuthedSidebarSalesWarehouseStockInNotesIdEditRoute
  '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/$id_/edit': typeof AppAuthedSidebarSalesWarehouseStockOutNotesIdEditRoute
  '/_app/_authed/_sidebar/sales-warehouse/transfer-notes/$id_/edit': typeof AppAuthedSidebarSalesWarehouseTransferNotesIdEditRoute
  '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/$id_/edit': typeof AppAuthedSidebarScentingWarehouseStockInNotesIdEditRoute
  '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/$id_/edit': typeof AppAuthedSidebarScentingWarehouseStockOutNotesIdEditRoute
  '/_app/_authed/_sidebar/settings/zalo/templates/$id': typeof AppAuthedSidebarSettingsZaloTemplatesIdRoute
  '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/$id_/edit': typeof AppAuthedSidebarSortingWarehouseStockInNotesIdEditRoute
  '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/$id_/edit': typeof AppAuthedSidebarSortingWarehouseStockOutNotesIdEditRoute
  '/_app/_authed/_sidebar/settings/zalo/templates/': typeof AppAuthedSidebarSettingsZaloTemplatesIndexRoute
  '/_app/_authed/_sidebar/agriculture/growers/$id_/faces/$faceId': typeof AppAuthedSidebarAgricultureGrowersIdFacesFaceIdRoute
  '/_app/_authed/_sidebar/agriculture/my-grower/$growerId_/faces/$faceId': typeof AppAuthedSidebarAgricultureMyGrowerGrowerIdFacesFaceIdRoute
  '/_app/_authed/_sidebar/agriculture/growers/$id_/faces/': typeof AppAuthedSidebarAgricultureGrowersIdFacesIndexRoute
  '/_app/_authed/_sidebar/agriculture/my-grower/$growerId_/faces/': typeof AppAuthedSidebarAgricultureMyGrowerGrowerIdFacesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/grower-areas/$id'
    | '/trace/$code'
    | '/customer-display'
    | '/sale'
    | '/station'
    | '/agriculture'
    | '/retail'
    | '/dev-playground'
    | '/kiotviet-orders'
    | '/tea-machines'
    | '/tracking'
    | '/warehouse-stats'
    | '/whats-new'
    | '/sale/display'
    | '/station/production'
    | '/station/warehouse'
    | '/settings/zalo/callback'
    | '/sale/'
    | '/accounting/cash-flow'
    | '/accounting/expense-categories'
    | '/accounting/expense-rules'
    | '/accounting/expense-sync'
    | '/accounting/expenses'
    | '/accounting/grower-payments'
    | '/accounting/reconciliation'
    | '/accounting/remittances'
    | '/agricultural-materials/stats'
    | '/agriculture/area-map'
    | '/agriculture/cameras'
    | '/agriculture/care-logs'
    | '/agriculture/care-reminders'
    | '/agriculture/growers'
    | '/agriculture/irrigation-devices'
    | '/agriculture/my-reports'
    | '/agriculture/my-weighings'
    | '/agriculture/tea-types'
    | '/contract-deliveries/$id'
    | '/contract-deliveries/new'
    | '/customers/$customerId'
    | '/customers/new'
    | '/delivery-trips/$id'
    | '/dried-tea-purchases/$id'
    | '/driver/available-orders'
    | '/driver/cash'
    | '/logistics/shipping-carriers'
    | '/logistics/vtp-overdue'
    | '/orders/$orderId'
    | '/orders/new'
    | '/orders/quick'
    | '/packaging-warehouse/stats'
    | '/products/$productId'
    | '/products/categories'
    | '/products/certification-badges'
    | '/products/kiotviet-mapping'
    | '/products/new'
    | '/products/online-prices'
    | '/reports/care-logs'
    | '/reports/cashbook'
    | '/reports/debts'
    | '/reports/delivery'
    | '/reports/expenses'
    | '/reports/geography'
    | '/reports/growers'
    | '/reports/inventory'
    | '/reports/positions'
    | '/reports/revenue'
    | '/reports/sales'
    | '/reports/scenting-stock'
    | '/reports/sorting-stock'
    | '/reports/staff'
    | '/reports/stock-out'
    | '/reports/website'
    | '/reports/yield-loss'
    | '/reports/zalo-mini-app'
    | '/retail/categories'
    | '/retail/contact'
    | '/retail/guide-videos'
    | '/retail/home'
    | '/retail/media'
    | '/retail/member-tiers'
    | '/retail/online-prices'
    | '/retail/post-categories'
    | '/retail/site-settings'
    | '/scenting-warehouse/grades'
    | '/scenting-warehouse/stats'
    | '/settings/face-recognition'
    | '/settings/invoice'
    | '/settings/lot-sizes'
    | '/settings/notifications'
    | '/settings/printing'
    | '/settings/production-station-voice'
    | '/settings/sidebar-layout'
    | '/settings/sla'
    | '/settings/station-voice'
    | '/settings/warehouse-station-voice'
    | '/settings/zalo'
    | '/sorting-warehouse/stats'
    | '/sorting-warehouse/tea-grades'
    | '/stocktake/$id'
    | '/stocktake/new'
    | '/tea-purchases/$id'
    | '/tea-purchases/processing'
    | '/vehicles/$vehicleId'
    | '/warehouse-positions/$id'
    | '/warehouse-positions/new'
    | '/warehouse-sales/dashboard'
    | '/warehouse-sales/defects'
    | '/warehouse-sales/stats'
    | '/work-activities/board'
    | '/work-activities/calendar'
    | '/work-activities/guests'
    | '/support/t/$ref'
    | '/accounting/'
    | '/agricultural-materials/'
    | '/api-keys/'
    | '/contract-deliveries/'
    | '/customers/'
    | '/delivery-trips/'
    | '/dried-tea-purchases/'
    | '/orders/'
    | '/packaging/'
    | '/products/'
    | '/reports/'
    | '/smartlab/'
    | '/stocktake/'
    | '/tea-purchases/'
    | '/users/'
    | '/vehicles/'
    | '/warehouse-positions/'
    | '/accounting/reports/daily'
    | '/agricultural-materials/lots/$id'
    | '/agricultural-materials/stock-in-notes/$id'
    | '/agricultural-materials/stock-in-notes/new'
    | '/agricultural-materials/stock-out-notes/$id'
    | '/agricultural-materials/stock-out-notes/new'
    | '/agriculture/care-logs/new'
    | '/agriculture/growers/$id'
    | '/agriculture/growers/new'
    | '/agriculture/my-grower/$growerId'
    | '/customers/groups/$groupId'
    | '/packaging-warehouse/lots/$id'
    | '/packaging-warehouse/stock-in-notes/$id'
    | '/packaging-warehouse/stock-in-notes/new'
    | '/packaging-warehouse/stock-out-notes/$id'
    | '/packaging-warehouse/stock-out-notes/new'
    | '/packaging-warehouse/withdrawal-notes/$id'
    | '/packaging-warehouse/withdrawal-notes/new'
    | '/retail/accounts/$accountId'
    | '/retail/groups/$groupId'
    | '/retail/groups/new'
    | '/retail/pages/$pageId'
    | '/retail/pages/new'
    | '/retail/posts/$postId'
    | '/retail/posts/new'
    | '/sales-warehouse/lots/$id'
    | '/sales-warehouse/stock-in-notes/$id'
    | '/sales-warehouse/stock-in-notes/new'
    | '/sales-warehouse/stock-in-notes/quick'
    | '/sales-warehouse/stock-out-notes/$id'
    | '/sales-warehouse/stock-out-notes/new'
    | '/sales-warehouse/transfer-notes/$id'
    | '/sales-warehouse/transfer-notes/new'
    | '/scenting-warehouse/lots/$id'
    | '/scenting-warehouse/stock-in-notes/$id'
    | '/scenting-warehouse/stock-in-notes/new'
    | '/scenting-warehouse/stock-out-notes/$id'
    | '/scenting-warehouse/stock-out-notes/new'
    | '/scenting-warehouse/withdrawal-notes/$id'
    | '/scenting-warehouse/withdrawal-notes/new'
    | '/settings/roles/$id'
    | '/settings/zalo/messages'
    | '/settings/zalo/purposes'
    | '/sorting-warehouse/lots/$id'
    | '/sorting-warehouse/stock-in-notes/$id'
    | '/sorting-warehouse/stock-in-notes/new'
    | '/sorting-warehouse/stock-out-notes/$id'
    | '/sorting-warehouse/stock-out-notes/new'
    | '/sorting-warehouse/withdrawal-notes/$id'
    | '/sorting-warehouse/withdrawal-notes/new'
    | '/agricultural-materials/lots/'
    | '/agricultural-materials/stock-in-notes/'
    | '/agricultural-materials/stock-out-notes/'
    | '/agriculture/care-logs/'
    | '/agriculture/growers/'
    | '/agriculture/my-grower/'
    | '/customers/groups/'
    | '/organization/departments/'
    | '/organization/employees/'
    | '/packaging-warehouse/count-log/'
    | '/packaging-warehouse/lots/'
    | '/packaging-warehouse/stock-in-notes/'
    | '/packaging-warehouse/stock-out-notes/'
    | '/packaging-warehouse/withdrawal-notes/'
    | '/retail/accounts/'
    | '/retail/groups/'
    | '/retail/pages/'
    | '/retail/posts/'
    | '/sales-warehouse/box-log/'
    | '/sales-warehouse/lots/'
    | '/sales-warehouse/other-log/'
    | '/sales-warehouse/packaging-log/'
    | '/sales-warehouse/stock-in-notes/'
    | '/sales-warehouse/stock-out-notes/'
    | '/sales-warehouse/transfer-notes/'
    | '/scenting-warehouse/log/'
    | '/scenting-warehouse/lots/'
    | '/scenting-warehouse/stock-in-notes/'
    | '/scenting-warehouse/stock-out-notes/'
    | '/scenting-warehouse/withdrawal-notes/'
    | '/settings/roles/'
    | '/settings/zalo/'
    | '/sorting-warehouse/lots/'
    | '/sorting-warehouse/stock-in-notes/'
    | '/sorting-warehouse/stock-out-notes/'
    | '/sorting-warehouse/withdrawal-notes/'
    | '/agricultural-materials/stock-in-notes/$id/edit'
    | '/agricultural-materials/stock-out-notes/$id/edit'
    | '/agriculture/care-logs/$id/edit'
    | '/agriculture/growers/$id/edit'
    | '/packaging-warehouse/stock-in-notes/$id/edit'
    | '/packaging-warehouse/stock-out-notes/$id/edit'
    | '/sales-warehouse/stock-in-notes/$id/edit'
    | '/sales-warehouse/stock-out-notes/$id/edit'
    | '/sales-warehouse/transfer-notes/$id/edit'
    | '/scenting-warehouse/stock-in-notes/$id/edit'
    | '/scenting-warehouse/stock-out-notes/$id/edit'
    | '/settings/zalo/templates/$id'
    | '/sorting-warehouse/stock-in-notes/$id/edit'
    | '/sorting-warehouse/stock-out-notes/$id/edit'
    | '/settings/zalo/templates/'
    | '/agriculture/growers/$id/faces/$faceId'
    | '/agriculture/my-grower/$growerId/faces/$faceId'
    | '/agriculture/growers/$id/faces/'
    | '/agriculture/my-grower/$growerId/faces/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/grower-areas/$id'
    | '/trace/$code'
    | '/customer-display'
    | '/station'
    | '/agriculture'
    | '/retail'
    | '/dev-playground'
    | '/kiotviet-orders'
    | '/tea-machines'
    | '/tracking'
    | '/warehouse-stats'
    | '/whats-new'
    | '/sale/display'
    | '/station/production'
    | '/station/warehouse'
    | '/settings/zalo/callback'
    | '/sale'
    | '/accounting/cash-flow'
    | '/accounting/expense-categories'
    | '/accounting/expense-rules'
    | '/accounting/expense-sync'
    | '/accounting/expenses'
    | '/accounting/grower-payments'
    | '/accounting/reconciliation'
    | '/accounting/remittances'
    | '/agricultural-materials/stats'
    | '/agriculture/area-map'
    | '/agriculture/cameras'
    | '/agriculture/care-reminders'
    | '/agriculture/irrigation-devices'
    | '/agriculture/my-reports'
    | '/agriculture/my-weighings'
    | '/agriculture/tea-types'
    | '/contract-deliveries/$id'
    | '/contract-deliveries/new'
    | '/customers/$customerId'
    | '/customers/new'
    | '/delivery-trips/$id'
    | '/dried-tea-purchases/$id'
    | '/driver/available-orders'
    | '/driver/cash'
    | '/logistics/shipping-carriers'
    | '/logistics/vtp-overdue'
    | '/orders/$orderId'
    | '/orders/new'
    | '/orders/quick'
    | '/packaging-warehouse/stats'
    | '/products/$productId'
    | '/products/categories'
    | '/products/certification-badges'
    | '/products/kiotviet-mapping'
    | '/products/new'
    | '/products/online-prices'
    | '/reports/care-logs'
    | '/reports/cashbook'
    | '/reports/debts'
    | '/reports/delivery'
    | '/reports/expenses'
    | '/reports/geography'
    | '/reports/growers'
    | '/reports/inventory'
    | '/reports/positions'
    | '/reports/revenue'
    | '/reports/sales'
    | '/reports/scenting-stock'
    | '/reports/sorting-stock'
    | '/reports/staff'
    | '/reports/stock-out'
    | '/reports/website'
    | '/reports/yield-loss'
    | '/reports/zalo-mini-app'
    | '/retail/categories'
    | '/retail/contact'
    | '/retail/guide-videos'
    | '/retail/home'
    | '/retail/media'
    | '/retail/member-tiers'
    | '/retail/online-prices'
    | '/retail/post-categories'
    | '/retail/site-settings'
    | '/scenting-warehouse/grades'
    | '/scenting-warehouse/stats'
    | '/settings/face-recognition'
    | '/settings/invoice'
    | '/settings/lot-sizes'
    | '/settings/notifications'
    | '/settings/printing'
    | '/settings/production-station-voice'
    | '/settings/sidebar-layout'
    | '/settings/sla'
    | '/settings/station-voice'
    | '/settings/warehouse-station-voice'
    | '/sorting-warehouse/stats'
    | '/sorting-warehouse/tea-grades'
    | '/stocktake/$id'
    | '/stocktake/new'
    | '/tea-purchases/$id'
    | '/tea-purchases/processing'
    | '/vehicles/$vehicleId'
    | '/warehouse-positions/$id'
    | '/warehouse-positions/new'
    | '/warehouse-sales/dashboard'
    | '/warehouse-sales/defects'
    | '/warehouse-sales/stats'
    | '/work-activities/board'
    | '/work-activities/calendar'
    | '/work-activities/guests'
    | '/support/t/$ref'
    | '/accounting'
    | '/agricultural-materials'
    | '/api-keys'
    | '/contract-deliveries'
    | '/customers'
    | '/delivery-trips'
    | '/dried-tea-purchases'
    | '/orders'
    | '/packaging'
    | '/products'
    | '/reports'
    | '/smartlab'
    | '/stocktake'
    | '/tea-purchases'
    | '/users'
    | '/vehicles'
    | '/warehouse-positions'
    | '/accounting/reports/daily'
    | '/agricultural-materials/lots/$id'
    | '/agricultural-materials/stock-in-notes/$id'
    | '/agricultural-materials/stock-in-notes/new'
    | '/agricultural-materials/stock-out-notes/$id'
    | '/agricultural-materials/stock-out-notes/new'
    | '/agriculture/care-logs/new'
    | '/agriculture/growers/$id'
    | '/agriculture/growers/new'
    | '/agriculture/my-grower/$growerId'
    | '/customers/groups/$groupId'
    | '/packaging-warehouse/lots/$id'
    | '/packaging-warehouse/stock-in-notes/$id'
    | '/packaging-warehouse/stock-in-notes/new'
    | '/packaging-warehouse/stock-out-notes/$id'
    | '/packaging-warehouse/stock-out-notes/new'
    | '/packaging-warehouse/withdrawal-notes/$id'
    | '/packaging-warehouse/withdrawal-notes/new'
    | '/retail/accounts/$accountId'
    | '/retail/groups/$groupId'
    | '/retail/groups/new'
    | '/retail/pages/$pageId'
    | '/retail/pages/new'
    | '/retail/posts/$postId'
    | '/retail/posts/new'
    | '/sales-warehouse/lots/$id'
    | '/sales-warehouse/stock-in-notes/$id'
    | '/sales-warehouse/stock-in-notes/new'
    | '/sales-warehouse/stock-in-notes/quick'
    | '/sales-warehouse/stock-out-notes/$id'
    | '/sales-warehouse/stock-out-notes/new'
    | '/sales-warehouse/transfer-notes/$id'
    | '/sales-warehouse/transfer-notes/new'
    | '/scenting-warehouse/lots/$id'
    | '/scenting-warehouse/stock-in-notes/$id'
    | '/scenting-warehouse/stock-in-notes/new'
    | '/scenting-warehouse/stock-out-notes/$id'
    | '/scenting-warehouse/stock-out-notes/new'
    | '/scenting-warehouse/withdrawal-notes/$id'
    | '/scenting-warehouse/withdrawal-notes/new'
    | '/settings/roles/$id'
    | '/settings/zalo/messages'
    | '/settings/zalo/purposes'
    | '/sorting-warehouse/lots/$id'
    | '/sorting-warehouse/stock-in-notes/$id'
    | '/sorting-warehouse/stock-in-notes/new'
    | '/sorting-warehouse/stock-out-notes/$id'
    | '/sorting-warehouse/stock-out-notes/new'
    | '/sorting-warehouse/withdrawal-notes/$id'
    | '/sorting-warehouse/withdrawal-notes/new'
    | '/agricultural-materials/lots'
    | '/agricultural-materials/stock-in-notes'
    | '/agricultural-materials/stock-out-notes'
    | '/agriculture/care-logs'
    | '/agriculture/growers'
    | '/agriculture/my-grower'
    | '/customers/groups'
    | '/organization/departments'
    | '/organization/employees'
    | '/packaging-warehouse/count-log'
    | '/packaging-warehouse/lots'
    | '/packaging-warehouse/stock-in-notes'
    | '/packaging-warehouse/stock-out-notes'
    | '/packaging-warehouse/withdrawal-notes'
    | '/retail/accounts'
    | '/retail/groups'
    | '/retail/pages'
    | '/retail/posts'
    | '/sales-warehouse/box-log'
    | '/sales-warehouse/lots'
    | '/sales-warehouse/other-log'
    | '/sales-warehouse/packaging-log'
    | '/sales-warehouse/stock-in-notes'
    | '/sales-warehouse/stock-out-notes'
    | '/sales-warehouse/transfer-notes'
    | '/scenting-warehouse/log'
    | '/scenting-warehouse/lots'
    | '/scenting-warehouse/stock-in-notes'
    | '/scenting-warehouse/stock-out-notes'
    | '/scenting-warehouse/withdrawal-notes'
    | '/settings/roles'
    | '/settings/zalo'
    | '/sorting-warehouse/lots'
    | '/sorting-warehouse/stock-in-notes'
    | '/sorting-warehouse/stock-out-notes'
    | '/sorting-warehouse/withdrawal-notes'
    | '/agricultural-materials/stock-in-notes/$id/edit'
    | '/agricultural-materials/stock-out-notes/$id/edit'
    | '/agriculture/care-logs/$id/edit'
    | '/agriculture/growers/$id/edit'
    | '/packaging-warehouse/stock-in-notes/$id/edit'
    | '/packaging-warehouse/stock-out-notes/$id/edit'
    | '/sales-warehouse/stock-in-notes/$id/edit'
    | '/sales-warehouse/stock-out-notes/$id/edit'
    | '/sales-warehouse/transfer-notes/$id/edit'
    | '/scenting-warehouse/stock-in-notes/$id/edit'
    | '/scenting-warehouse/stock-out-notes/$id/edit'
    | '/settings/zalo/templates/$id'
    | '/sorting-warehouse/stock-in-notes/$id/edit'
    | '/sorting-warehouse/stock-out-notes/$id/edit'
    | '/settings/zalo/templates'
    | '/agriculture/growers/$id/faces/$faceId'
    | '/agriculture/my-grower/$growerId/faces/$faceId'
    | '/agriculture/growers/$id/faces'
    | '/agriculture/my-grower/$growerId/faces'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/_authed'
    | '/grower-areas/$id'
    | '/trace/$code'
    | '/_app/_authed/_sidebar'
    | '/_app/_authed/customer-display'
    | '/_app/_authed/sale'
    | '/_app/_authed/station'
    | '/_app/_authed/_sidebar/agriculture'
    | '/_app/_authed/_sidebar/retail'
    | '/_app/_authed/_sidebar/dev-playground'
    | '/_app/_authed/_sidebar/kiotviet-orders'
    | '/_app/_authed/_sidebar/tea-machines'
    | '/_app/_authed/_sidebar/tracking'
    | '/_app/_authed/_sidebar/warehouse-stats'
    | '/_app/_authed/_sidebar/whats-new'
    | '/_app/_authed/sale/display'
    | '/_app/_authed/station_/production'
    | '/_app/_authed/station_/warehouse'
    | '/_app/settings/zalo/callback'
    | '/_app/_authed/_sidebar/'
    | '/_app/_authed/sale/'
    | '/_app/_authed/_sidebar/accounting/cash-flow'
    | '/_app/_authed/_sidebar/accounting/expense-categories'
    | '/_app/_authed/_sidebar/accounting/expense-rules'
    | '/_app/_authed/_sidebar/accounting/expense-sync'
    | '/_app/_authed/_sidebar/accounting/expenses'
    | '/_app/_authed/_sidebar/accounting/grower-payments'
    | '/_app/_authed/_sidebar/accounting/reconciliation'
    | '/_app/_authed/_sidebar/accounting/remittances'
    | '/_app/_authed/_sidebar/agricultural-materials/stats'
    | '/_app/_authed/_sidebar/agriculture/area-map'
    | '/_app/_authed/_sidebar/agriculture/cameras'
    | '/_app/_authed/_sidebar/agriculture/care-logs'
    | '/_app/_authed/_sidebar/agriculture/care-reminders'
    | '/_app/_authed/_sidebar/agriculture/growers'
    | '/_app/_authed/_sidebar/agriculture/irrigation-devices'
    | '/_app/_authed/_sidebar/agriculture/my-reports'
    | '/_app/_authed/_sidebar/agriculture/my-weighings'
    | '/_app/_authed/_sidebar/agriculture/tea-types'
    | '/_app/_authed/_sidebar/contract-deliveries/$id'
    | '/_app/_authed/_sidebar/contract-deliveries/new'
    | '/_app/_authed/_sidebar/customers/$customerId'
    | '/_app/_authed/_sidebar/customers/new'
    | '/_app/_authed/_sidebar/delivery-trips/$id'
    | '/_app/_authed/_sidebar/dried-tea-purchases/$id'
    | '/_app/_authed/_sidebar/driver/available-orders'
    | '/_app/_authed/_sidebar/driver/cash'
    | '/_app/_authed/_sidebar/logistics/shipping-carriers'
    | '/_app/_authed/_sidebar/logistics/vtp-overdue'
    | '/_app/_authed/_sidebar/orders/$orderId'
    | '/_app/_authed/_sidebar/orders/new'
    | '/_app/_authed/_sidebar/orders/quick'
    | '/_app/_authed/_sidebar/packaging-warehouse/stats'
    | '/_app/_authed/_sidebar/products/$productId'
    | '/_app/_authed/_sidebar/products/categories'
    | '/_app/_authed/_sidebar/products/certification-badges'
    | '/_app/_authed/_sidebar/products/kiotviet-mapping'
    | '/_app/_authed/_sidebar/products/new'
    | '/_app/_authed/_sidebar/products/online-prices'
    | '/_app/_authed/_sidebar/reports/care-logs'
    | '/_app/_authed/_sidebar/reports/cashbook'
    | '/_app/_authed/_sidebar/reports/debts'
    | '/_app/_authed/_sidebar/reports/delivery'
    | '/_app/_authed/_sidebar/reports/expenses'
    | '/_app/_authed/_sidebar/reports/geography'
    | '/_app/_authed/_sidebar/reports/growers'
    | '/_app/_authed/_sidebar/reports/inventory'
    | '/_app/_authed/_sidebar/reports/positions'
    | '/_app/_authed/_sidebar/reports/revenue'
    | '/_app/_authed/_sidebar/reports/sales'
    | '/_app/_authed/_sidebar/reports/scenting-stock'
    | '/_app/_authed/_sidebar/reports/sorting-stock'
    | '/_app/_authed/_sidebar/reports/staff'
    | '/_app/_authed/_sidebar/reports/stock-out'
    | '/_app/_authed/_sidebar/reports/website'
    | '/_app/_authed/_sidebar/reports/yield-loss'
    | '/_app/_authed/_sidebar/reports/zalo-mini-app'
    | '/_app/_authed/_sidebar/retail/categories'
    | '/_app/_authed/_sidebar/retail/contact'
    | '/_app/_authed/_sidebar/retail/guide-videos'
    | '/_app/_authed/_sidebar/retail/home'
    | '/_app/_authed/_sidebar/retail/media'
    | '/_app/_authed/_sidebar/retail/member-tiers'
    | '/_app/_authed/_sidebar/retail/online-prices'
    | '/_app/_authed/_sidebar/retail/post-categories'
    | '/_app/_authed/_sidebar/retail/site-settings'
    | '/_app/_authed/_sidebar/scenting-warehouse/grades'
    | '/_app/_authed/_sidebar/scenting-warehouse/stats'
    | '/_app/_authed/_sidebar/settings/face-recognition'
    | '/_app/_authed/_sidebar/settings/invoice'
    | '/_app/_authed/_sidebar/settings/lot-sizes'
    | '/_app/_authed/_sidebar/settings/notifications'
    | '/_app/_authed/_sidebar/settings/printing'
    | '/_app/_authed/_sidebar/settings/production-station-voice'
    | '/_app/_authed/_sidebar/settings/sidebar-layout'
    | '/_app/_authed/_sidebar/settings/sla'
    | '/_app/_authed/_sidebar/settings/station-voice'
    | '/_app/_authed/_sidebar/settings/warehouse-station-voice'
    | '/_app/_authed/_sidebar/settings/zalo'
    | '/_app/_authed/_sidebar/sorting-warehouse/stats'
    | '/_app/_authed/_sidebar/sorting-warehouse/tea-grades'
    | '/_app/_authed/_sidebar/stocktake/$id'
    | '/_app/_authed/_sidebar/stocktake/new'
    | '/_app/_authed/_sidebar/tea-purchases/$id'
    | '/_app/_authed/_sidebar/tea-purchases/processing'
    | '/_app/_authed/_sidebar/vehicles/$vehicleId'
    | '/_app/_authed/_sidebar/warehouse-positions/$id'
    | '/_app/_authed/_sidebar/warehouse-positions/new'
    | '/_app/_authed/_sidebar/warehouse-sales/dashboard'
    | '/_app/_authed/_sidebar/warehouse-sales/defects'
    | '/_app/_authed/_sidebar/warehouse-sales/stats'
    | '/_app/_authed/_sidebar/work-activities/board'
    | '/_app/_authed/_sidebar/work-activities/calendar'
    | '/_app/_authed/_sidebar/work-activities/guests'
    | '/_app/_authed/support/t/$ref'
    | '/_app/_authed/_sidebar/accounting/'
    | '/_app/_authed/_sidebar/agricultural-materials/'
    | '/_app/_authed/_sidebar/api-keys/'
    | '/_app/_authed/_sidebar/contract-deliveries/'
    | '/_app/_authed/_sidebar/customers/'
    | '/_app/_authed/_sidebar/delivery-trips/'
    | '/_app/_authed/_sidebar/dried-tea-purchases/'
    | '/_app/_authed/_sidebar/orders/'
    | '/_app/_authed/_sidebar/packaging/'
    | '/_app/_authed/_sidebar/products/'
    | '/_app/_authed/_sidebar/reports/'
    | '/_app/_authed/_sidebar/smartlab/'
    | '/_app/_authed/_sidebar/stocktake/'
    | '/_app/_authed/_sidebar/tea-purchases/'
    | '/_app/_authed/_sidebar/users/'
    | '/_app/_authed/_sidebar/vehicles/'
    | '/_app/_authed/_sidebar/warehouse-positions/'
    | '/_app/_authed/_sidebar/accounting/reports/daily'
    | '/_app/_authed/_sidebar/agricultural-materials/lots/$id'
    | '/_app/_authed/_sidebar/agricultural-materials/stock-in-notes/$id'
    | '/_app/_authed/_sidebar/agricultural-materials/stock-in-notes/new'
    | '/_app/_authed/_sidebar/agricultural-materials/stock-out-notes/$id'
    | '/_app/_authed/_sidebar/agricultural-materials/stock-out-notes/new'
    | '/_app/_authed/_sidebar/agriculture/care-logs/new'
    | '/_app/_authed/_sidebar/agriculture/growers/$id'
    | '/_app/_authed/_sidebar/agriculture/growers/new'
    | '/_app/_authed/_sidebar/agriculture/my-grower/$growerId'
    | '/_app/_authed/_sidebar/customers/groups/$groupId'
    | '/_app/_authed/_sidebar/packaging-warehouse/lots/$id'
    | '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/$id'
    | '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/new'
    | '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/$id'
    | '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/new'
    | '/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/$id'
    | '/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/new'
    | '/_app/_authed/_sidebar/retail/accounts/$accountId'
    | '/_app/_authed/_sidebar/retail/groups/$groupId'
    | '/_app/_authed/_sidebar/retail/groups/new'
    | '/_app/_authed/_sidebar/retail/pages/$pageId'
    | '/_app/_authed/_sidebar/retail/pages/new'
    | '/_app/_authed/_sidebar/retail/posts/$postId'
    | '/_app/_authed/_sidebar/retail/posts/new'
    | '/_app/_authed/_sidebar/sales-warehouse/lots/$id'
    | '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/$id'
    | '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/new'
    | '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/quick'
    | '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/$id'
    | '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/new'
    | '/_app/_authed/_sidebar/sales-warehouse/transfer-notes/$id'
    | '/_app/_authed/_sidebar/sales-warehouse/transfer-notes/new'
    | '/_app/_authed/_sidebar/scenting-warehouse/lots/$id'
    | '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/$id'
    | '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/new'
    | '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/$id'
    | '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/new'
    | '/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/$id'
    | '/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/new'
    | '/_app/_authed/_sidebar/settings/roles/$id'
    | '/_app/_authed/_sidebar/settings/zalo/messages'
    | '/_app/_authed/_sidebar/settings/zalo/purposes'
    | '/_app/_authed/_sidebar/sorting-warehouse/lots/$id'
    | '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/$id'
    | '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/new'
    | '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/$id'
    | '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/new'
    | '/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/$id'
    | '/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/new'
    | '/_app/_authed/_sidebar/agricultural-materials/lots/'
    | '/_app/_authed/_sidebar/agricultural-materials/stock-in-notes/'
    | '/_app/_authed/_sidebar/agricultural-materials/stock-out-notes/'
    | '/_app/_authed/_sidebar/agriculture/care-logs/'
    | '/_app/_authed/_sidebar/agriculture/growers/'
    | '/_app/_authed/_sidebar/agriculture/my-grower/'
    | '/_app/_authed/_sidebar/customers/groups/'
    | '/_app/_authed/_sidebar/organization/departments/'
    | '/_app/_authed/_sidebar/organization/employees/'
    | '/_app/_authed/_sidebar/packaging-warehouse/count-log/'
    | '/_app/_authed/_sidebar/packaging-warehouse/lots/'
    | '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/'
    | '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/'
    | '/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/'
    | '/_app/_authed/_sidebar/retail/accounts/'
    | '/_app/_authed/_sidebar/retail/groups/'
    | '/_app/_authed/_sidebar/retail/pages/'
    | '/_app/_authed/_sidebar/retail/posts/'
    | '/_app/_authed/_sidebar/sales-warehouse/box-log/'
    | '/_app/_authed/_sidebar/sales-warehouse/lots/'
    | '/_app/_authed/_sidebar/sales-warehouse/other-log/'
    | '/_app/_authed/_sidebar/sales-warehouse/packaging-log/'
    | '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/'
    | '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/'
    | '/_app/_authed/_sidebar/sales-warehouse/transfer-notes/'
    | '/_app/_authed/_sidebar/scenting-warehouse/log/'
    | '/_app/_authed/_sidebar/scenting-warehouse/lots/'
    | '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/'
    | '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/'
    | '/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/'
    | '/_app/_authed/_sidebar/settings/roles/'
    | '/_app/_authed/_sidebar/settings/zalo/'
    | '/_app/_authed/_sidebar/sorting-warehouse/lots/'
    | '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/'
    | '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/'
    | '/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/'
    | '/_app/_authed/_sidebar/agricultural-materials/stock-in-notes/$id_/edit'
    | '/_app/_authed/_sidebar/agricultural-materials/stock-out-notes/$id_/edit'
    | '/_app/_authed/_sidebar/agriculture/care-logs/$id/edit'
    | '/_app/_authed/_sidebar/agriculture/growers/$id_/edit'
    | '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/$id_/edit'
    | '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/$id_/edit'
    | '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/$id_/edit'
    | '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/$id_/edit'
    | '/_app/_authed/_sidebar/sales-warehouse/transfer-notes/$id_/edit'
    | '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/$id_/edit'
    | '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/$id_/edit'
    | '/_app/_authed/_sidebar/settings/zalo/templates/$id'
    | '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/$id_/edit'
    | '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/$id_/edit'
    | '/_app/_authed/_sidebar/settings/zalo/templates/'
    | '/_app/_authed/_sidebar/agriculture/growers/$id_/faces/$faceId'
    | '/_app/_authed/_sidebar/agriculture/my-grower/$growerId_/faces/$faceId'
    | '/_app/_authed/_sidebar/agriculture/growers/$id_/faces/'
    | '/_app/_authed/_sidebar/agriculture/my-grower/$growerId_/faces/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  GrowerAreasIdRoute: typeof GrowerAreasIdRoute
  TraceCodeRoute: typeof TraceCodeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/_authed': {
      id: '/_app/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppAuthedRouteImport
      parentRoute: typeof AppRoute
    }
    '/grower-areas/$id': {
      id: '/grower-areas/$id'
      path: '/grower-areas/$id'
      fullPath: '/grower-areas/$id'
      preLoaderRoute: typeof GrowerAreasIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trace/$code': {
      id: '/trace/$code'
      path: '/trace/$code'
      fullPath: '/trace/$code'
      preLoaderRoute: typeof TraceCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/_authed/_sidebar': {
      id: '/_app/_authed/_sidebar'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppAuthedSidebarRouteImport
      parentRoute: typeof AppAuthedRoute
    }
    '/_app/_authed/customer-display': {
      id: '/_app/_authed/customer-display'
      path: '/customer-display'
      fullPath: '/customer-display'
      preLoaderRoute: typeof AppAuthedCustomerDisplayRouteImport
      parentRoute: typeof AppAuthedRoute
    }
    '/_app/_authed/sale': {
      id: '/_app/_authed/sale'
      path: '/sale'
      fullPath: '/sale'
      preLoaderRoute: typeof AppAuthedSaleRouteImport
      parentRoute: typeof AppAuthedRoute
    }
    '/_app/_authed/station': {
      id: '/_app/_authed/station'
      path: '/station'
      fullPath: '/station'
      preLoaderRoute: typeof AppAuthedStationRouteImport
      parentRoute: typeof AppAuthedRoute
    }
    '/_app/_authed/_sidebar/': {
      id: '/_app/_authed/_sidebar/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppAuthedSidebarIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/agriculture': {
      id: '/_app/_authed/_sidebar/agriculture'
      path: '/agriculture'
      fullPath: '/agriculture'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureRouteRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/dev-playground': {
      id: '/_app/_authed/_sidebar/dev-playground'
      path: '/dev-playground'
      fullPath: '/dev-playground'
      preLoaderRoute: typeof AppAuthedSidebarDevPlaygroundRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/kiotviet-orders': {
      id: '/_app/_authed/_sidebar/kiotviet-orders'
      path: '/kiotviet-orders'
      fullPath: '/kiotviet-orders'
      preLoaderRoute: typeof AppAuthedSidebarKiotvietOrdersRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/retail': {
      id: '/_app/_authed/_sidebar/retail'
      path: '/retail'
      fullPath: '/retail'
      preLoaderRoute: typeof AppAuthedSidebarRetailRouteRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/tea-machines': {
      id: '/_app/_authed/_sidebar/tea-machines'
      path: '/tea-machines'
      fullPath: '/tea-machines'
      preLoaderRoute: typeof AppAuthedSidebarTeaMachinesRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/tracking': {
      id: '/_app/_authed/_sidebar/tracking'
      path: '/tracking'
      fullPath: '/tracking'
      preLoaderRoute: typeof AppAuthedSidebarTrackingRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/warehouse-stats': {
      id: '/_app/_authed/_sidebar/warehouse-stats'
      path: '/warehouse-stats'
      fullPath: '/warehouse-stats'
      preLoaderRoute: typeof AppAuthedSidebarWarehouseStatsRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/whats-new': {
      id: '/_app/_authed/_sidebar/whats-new'
      path: '/whats-new'
      fullPath: '/whats-new'
      preLoaderRoute: typeof AppAuthedSidebarWhatsNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/sale/': {
      id: '/_app/_authed/sale/'
      path: '/'
      fullPath: '/sale/'
      preLoaderRoute: typeof AppAuthedSaleIndexRouteImport
      parentRoute: typeof AppAuthedSaleRoute
    }
    '/_app/_authed/sale/display': {
      id: '/_app/_authed/sale/display'
      path: '/display'
      fullPath: '/sale/display'
      preLoaderRoute: typeof AppAuthedSaleDisplayRouteImport
      parentRoute: typeof AppAuthedSaleRoute
    }
    '/_app/_authed/station_/production': {
      id: '/_app/_authed/station_/production'
      path: '/station/production'
      fullPath: '/station/production'
      preLoaderRoute: typeof AppAuthedStationProductionRouteImport
      parentRoute: typeof AppAuthedRoute
    }
    '/_app/_authed/station_/warehouse': {
      id: '/_app/_authed/station_/warehouse'
      path: '/station/warehouse'
      fullPath: '/station/warehouse'
      preLoaderRoute: typeof AppAuthedStationWarehouseRouteImport
      parentRoute: typeof AppAuthedRoute
    }
    '/_app/settings/zalo/callback': {
      id: '/_app/settings/zalo/callback'
      path: '/settings/zalo/callback'
      fullPath: '/settings/zalo/callback'
      preLoaderRoute: typeof AppSettingsZaloCallbackRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_authed/_sidebar/accounting/': {
      id: '/_app/_authed/_sidebar/accounting/'
      path: '/accounting'
      fullPath: '/accounting/'
      preLoaderRoute: typeof AppAuthedSidebarAccountingIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/accounting/cash-flow': {
      id: '/_app/_authed/_sidebar/accounting/cash-flow'
      path: '/accounting/cash-flow'
      fullPath: '/accounting/cash-flow'
      preLoaderRoute: typeof AppAuthedSidebarAccountingCashFlowRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/accounting/expense-categories': {
      id: '/_app/_authed/_sidebar/accounting/expense-categories'
      path: '/accounting/expense-categories'
      fullPath: '/accounting/expense-categories'
      preLoaderRoute: typeof AppAuthedSidebarAccountingExpenseCategoriesRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/accounting/expense-rules': {
      id: '/_app/_authed/_sidebar/accounting/expense-rules'
      path: '/accounting/expense-rules'
      fullPath: '/accounting/expense-rules'
      preLoaderRoute: typeof AppAuthedSidebarAccountingExpenseRulesRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/accounting/expense-sync': {
      id: '/_app/_authed/_sidebar/accounting/expense-sync'
      path: '/accounting/expense-sync'
      fullPath: '/accounting/expense-sync'
      preLoaderRoute: typeof AppAuthedSidebarAccountingExpenseSyncRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/accounting/expenses': {
      id: '/_app/_authed/_sidebar/accounting/expenses'
      path: '/accounting/expenses'
      fullPath: '/accounting/expenses'
      preLoaderRoute: typeof AppAuthedSidebarAccountingExpensesRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/accounting/grower-payments': {
      id: '/_app/_authed/_sidebar/accounting/grower-payments'
      path: '/accounting/grower-payments'
      fullPath: '/accounting/grower-payments'
      preLoaderRoute: typeof AppAuthedSidebarAccountingGrowerPaymentsRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/accounting/reconciliation': {
      id: '/_app/_authed/_sidebar/accounting/reconciliation'
      path: '/accounting/reconciliation'
      fullPath: '/accounting/reconciliation'
      preLoaderRoute: typeof AppAuthedSidebarAccountingReconciliationRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/accounting/remittances': {
      id: '/_app/_authed/_sidebar/accounting/remittances'
      path: '/accounting/remittances'
      fullPath: '/accounting/remittances'
      preLoaderRoute: typeof AppAuthedSidebarAccountingRemittancesRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/agricultural-materials/': {
      id: '/_app/_authed/_sidebar/agricultural-materials/'
      path: '/agricultural-materials'
      fullPath: '/agricultural-materials/'
      preLoaderRoute: typeof AppAuthedSidebarAgriculturalMaterialsIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/agricultural-materials/stats': {
      id: '/_app/_authed/_sidebar/agricultural-materials/stats'
      path: '/agricultural-materials/stats'
      fullPath: '/agricultural-materials/stats'
      preLoaderRoute: typeof AppAuthedSidebarAgriculturalMaterialsStatsRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/agriculture/area-map': {
      id: '/_app/_authed/_sidebar/agriculture/area-map'
      path: '/area-map'
      fullPath: '/agriculture/area-map'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureAreaMapRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureRouteRoute
    }
    '/_app/_authed/_sidebar/agriculture/cameras': {
      id: '/_app/_authed/_sidebar/agriculture/cameras'
      path: '/cameras'
      fullPath: '/agriculture/cameras'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureCamerasRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureRouteRoute
    }
    '/_app/_authed/_sidebar/agriculture/care-logs': {
      id: '/_app/_authed/_sidebar/agriculture/care-logs'
      path: '/care-logs'
      fullPath: '/agriculture/care-logs'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureCareLogsRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureRouteRoute
    }
    '/_app/_authed/_sidebar/agriculture/care-reminders': {
      id: '/_app/_authed/_sidebar/agriculture/care-reminders'
      path: '/care-reminders'
      fullPath: '/agriculture/care-reminders'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureCareRemindersRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureRouteRoute
    }
    '/_app/_authed/_sidebar/agriculture/growers': {
      id: '/_app/_authed/_sidebar/agriculture/growers'
      path: '/growers'
      fullPath: '/agriculture/growers'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureGrowersRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureRouteRoute
    }
    '/_app/_authed/_sidebar/agriculture/irrigation-devices': {
      id: '/_app/_authed/_sidebar/agriculture/irrigation-devices'
      path: '/irrigation-devices'
      fullPath: '/agriculture/irrigation-devices'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureIrrigationDevicesRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureRouteRoute
    }
    '/_app/_authed/_sidebar/agriculture/my-reports': {
      id: '/_app/_authed/_sidebar/agriculture/my-reports'
      path: '/my-reports'
      fullPath: '/agriculture/my-reports'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureMyReportsRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureRouteRoute
    }
    '/_app/_authed/_sidebar/agriculture/my-weighings': {
      id: '/_app/_authed/_sidebar/agriculture/my-weighings'
      path: '/my-weighings'
      fullPath: '/agriculture/my-weighings'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureMyWeighingsRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureRouteRoute
    }
    '/_app/_authed/_sidebar/agriculture/tea-types': {
      id: '/_app/_authed/_sidebar/agriculture/tea-types'
      path: '/tea-types'
      fullPath: '/agriculture/tea-types'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureTeaTypesRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureRouteRoute
    }
    '/_app/_authed/_sidebar/api-keys/': {
      id: '/_app/_authed/_sidebar/api-keys/'
      path: '/api-keys'
      fullPath: '/api-keys/'
      preLoaderRoute: typeof AppAuthedSidebarApiKeysIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/contract-deliveries/': {
      id: '/_app/_authed/_sidebar/contract-deliveries/'
      path: '/contract-deliveries'
      fullPath: '/contract-deliveries/'
      preLoaderRoute: typeof AppAuthedSidebarContractDeliveriesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/contract-deliveries/$id': {
      id: '/_app/_authed/_sidebar/contract-deliveries/$id'
      path: '/contract-deliveries/$id'
      fullPath: '/contract-deliveries/$id'
      preLoaderRoute: typeof AppAuthedSidebarContractDeliveriesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/contract-deliveries/new': {
      id: '/_app/_authed/_sidebar/contract-deliveries/new'
      path: '/contract-deliveries/new'
      fullPath: '/contract-deliveries/new'
      preLoaderRoute: typeof AppAuthedSidebarContractDeliveriesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/customers/': {
      id: '/_app/_authed/_sidebar/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AppAuthedSidebarCustomersIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/customers/$customerId': {
      id: '/_app/_authed/_sidebar/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof AppAuthedSidebarCustomersCustomerIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/customers/new': {
      id: '/_app/_authed/_sidebar/customers/new'
      path: '/customers/new'
      fullPath: '/customers/new'
      preLoaderRoute: typeof AppAuthedSidebarCustomersNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/delivery-trips/': {
      id: '/_app/_authed/_sidebar/delivery-trips/'
      path: '/delivery-trips'
      fullPath: '/delivery-trips/'
      preLoaderRoute: typeof AppAuthedSidebarDeliveryTripsIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/delivery-trips/$id': {
      id: '/_app/_authed/_sidebar/delivery-trips/$id'
      path: '/delivery-trips/$id'
      fullPath: '/delivery-trips/$id'
      preLoaderRoute: typeof AppAuthedSidebarDeliveryTripsIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/dried-tea-purchases/': {
      id: '/_app/_authed/_sidebar/dried-tea-purchases/'
      path: '/dried-tea-purchases'
      fullPath: '/dried-tea-purchases/'
      preLoaderRoute: typeof AppAuthedSidebarDriedTeaPurchasesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/dried-tea-purchases/$id': {
      id: '/_app/_authed/_sidebar/dried-tea-purchases/$id'
      path: '/dried-tea-purchases/$id'
      fullPath: '/dried-tea-purchases/$id'
      preLoaderRoute: typeof AppAuthedSidebarDriedTeaPurchasesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/driver/available-orders': {
      id: '/_app/_authed/_sidebar/driver/available-orders'
      path: '/driver/available-orders'
      fullPath: '/driver/available-orders'
      preLoaderRoute: typeof AppAuthedSidebarDriverAvailableOrdersRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/driver/cash': {
      id: '/_app/_authed/_sidebar/driver/cash'
      path: '/driver/cash'
      fullPath: '/driver/cash'
      preLoaderRoute: typeof AppAuthedSidebarDriverCashRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/logistics/shipping-carriers': {
      id: '/_app/_authed/_sidebar/logistics/shipping-carriers'
      path: '/logistics/shipping-carriers'
      fullPath: '/logistics/shipping-carriers'
      preLoaderRoute: typeof AppAuthedSidebarLogisticsShippingCarriersRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/logistics/vtp-overdue': {
      id: '/_app/_authed/_sidebar/logistics/vtp-overdue'
      path: '/logistics/vtp-overdue'
      fullPath: '/logistics/vtp-overdue'
      preLoaderRoute: typeof AppAuthedSidebarLogisticsVtpOverdueRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/orders/': {
      id: '/_app/_authed/_sidebar/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof AppAuthedSidebarOrdersIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/orders/$orderId': {
      id: '/_app/_authed/_sidebar/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof AppAuthedSidebarOrdersOrderIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/orders/new': {
      id: '/_app/_authed/_sidebar/orders/new'
      path: '/orders/new'
      fullPath: '/orders/new'
      preLoaderRoute: typeof AppAuthedSidebarOrdersNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/orders/quick': {
      id: '/_app/_authed/_sidebar/orders/quick'
      path: '/orders/quick'
      fullPath: '/orders/quick'
      preLoaderRoute: typeof AppAuthedSidebarOrdersQuickRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/stats': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/stats'
      path: '/packaging-warehouse/stats'
      fullPath: '/packaging-warehouse/stats'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseStatsRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging/': {
      id: '/_app/_authed/_sidebar/packaging/'
      path: '/packaging'
      fullPath: '/packaging/'
      preLoaderRoute: typeof AppAuthedSidebarPackagingIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/products/': {
      id: '/_app/_authed/_sidebar/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof AppAuthedSidebarProductsIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/products/$productId': {
      id: '/_app/_authed/_sidebar/products/$productId'
      path: '/products/$productId'
      fullPath: '/products/$productId'
      preLoaderRoute: typeof AppAuthedSidebarProductsProductIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/products/categories': {
      id: '/_app/_authed/_sidebar/products/categories'
      path: '/products/categories'
      fullPath: '/products/categories'
      preLoaderRoute: typeof AppAuthedSidebarProductsCategoriesRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/products/certification-badges': {
      id: '/_app/_authed/_sidebar/products/certification-badges'
      path: '/products/certification-badges'
      fullPath: '/products/certification-badges'
      preLoaderRoute: typeof AppAuthedSidebarProductsCertificationBadgesRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/products/kiotviet-mapping': {
      id: '/_app/_authed/_sidebar/products/kiotviet-mapping'
      path: '/products/kiotviet-mapping'
      fullPath: '/products/kiotviet-mapping'
      preLoaderRoute: typeof AppAuthedSidebarProductsKiotvietMappingRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/products/new': {
      id: '/_app/_authed/_sidebar/products/new'
      path: '/products/new'
      fullPath: '/products/new'
      preLoaderRoute: typeof AppAuthedSidebarProductsNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/products/online-prices': {
      id: '/_app/_authed/_sidebar/products/online-prices'
      path: '/products/online-prices'
      fullPath: '/products/online-prices'
      preLoaderRoute: typeof AppAuthedSidebarProductsOnlinePricesRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/reports/': {
      id: '/_app/_authed/_sidebar/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AppAuthedSidebarReportsIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/reports/care-logs': {
      id: '/_app/_authed/_sidebar/reports/care-logs'
      path: '/reports/care-logs'
      fullPath: '/reports/care-logs'
      preLoaderRoute: typeof AppAuthedSidebarReportsCareLogsRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/reports/cashbook': {
      id: '/_app/_authed/_sidebar/reports/cashbook'
      path: '/reports/cashbook'
      fullPath: '/reports/cashbook'
      preLoaderRoute: typeof AppAuthedSidebarReportsCashbookRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/reports/debts': {
      id: '/_app/_authed/_sidebar/reports/debts'
      path: '/reports/debts'
      fullPath: '/reports/debts'
      preLoaderRoute: typeof AppAuthedSidebarReportsDebtsRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/reports/delivery': {
      id: '/_app/_authed/_sidebar/reports/delivery'
      path: '/reports/delivery'
      fullPath: '/reports/delivery'
      preLoaderRoute: typeof AppAuthedSidebarReportsDeliveryRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/reports/expenses': {
      id: '/_app/_authed/_sidebar/reports/expenses'
      path: '/reports/expenses'
      fullPath: '/reports/expenses'
      preLoaderRoute: typeof AppAuthedSidebarReportsExpensesRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/reports/geography': {
      id: '/_app/_authed/_sidebar/reports/geography'
      path: '/reports/geography'
      fullPath: '/reports/geography'
      preLoaderRoute: typeof AppAuthedSidebarReportsGeographyRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/reports/growers': {
      id: '/_app/_authed/_sidebar/reports/growers'
      path: '/reports/growers'
      fullPath: '/reports/growers'
      preLoaderRoute: typeof AppAuthedSidebarReportsGrowersRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/reports/inventory': {
      id: '/_app/_authed/_sidebar/reports/inventory'
      path: '/reports/inventory'
      fullPath: '/reports/inventory'
      preLoaderRoute: typeof AppAuthedSidebarReportsInventoryRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/reports/positions': {
      id: '/_app/_authed/_sidebar/reports/positions'
      path: '/reports/positions'
      fullPath: '/reports/positions'
      preLoaderRoute: typeof AppAuthedSidebarReportsPositionsRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/reports/revenue': {
      id: '/_app/_authed/_sidebar/reports/revenue'
      path: '/reports/revenue'
      fullPath: '/reports/revenue'
      preLoaderRoute: typeof AppAuthedSidebarReportsRevenueRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/reports/sales': {
      id: '/_app/_authed/_sidebar/reports/sales'
      path: '/reports/sales'
      fullPath: '/reports/sales'
      preLoaderRoute: typeof AppAuthedSidebarReportsSalesRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/reports/scenting-stock': {
      id: '/_app/_authed/_sidebar/reports/scenting-stock'
      path: '/reports/scenting-stock'
      fullPath: '/reports/scenting-stock'
      preLoaderRoute: typeof AppAuthedSidebarReportsScentingStockRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/reports/sorting-stock': {
      id: '/_app/_authed/_sidebar/reports/sorting-stock'
      path: '/reports/sorting-stock'
      fullPath: '/reports/sorting-stock'
      preLoaderRoute: typeof AppAuthedSidebarReportsSortingStockRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/reports/staff': {
      id: '/_app/_authed/_sidebar/reports/staff'
      path: '/reports/staff'
      fullPath: '/reports/staff'
      preLoaderRoute: typeof AppAuthedSidebarReportsStaffRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/reports/stock-out': {
      id: '/_app/_authed/_sidebar/reports/stock-out'
      path: '/reports/stock-out'
      fullPath: '/reports/stock-out'
      preLoaderRoute: typeof AppAuthedSidebarReportsStockOutRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/reports/website': {
      id: '/_app/_authed/_sidebar/reports/website'
      path: '/reports/website'
      fullPath: '/reports/website'
      preLoaderRoute: typeof AppAuthedSidebarReportsWebsiteRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/reports/yield-loss': {
      id: '/_app/_authed/_sidebar/reports/yield-loss'
      path: '/reports/yield-loss'
      fullPath: '/reports/yield-loss'
      preLoaderRoute: typeof AppAuthedSidebarReportsYieldLossRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/reports/zalo-mini-app': {
      id: '/_app/_authed/_sidebar/reports/zalo-mini-app'
      path: '/reports/zalo-mini-app'
      fullPath: '/reports/zalo-mini-app'
      preLoaderRoute: typeof AppAuthedSidebarReportsZaloMiniAppRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/retail/categories': {
      id: '/_app/_authed/_sidebar/retail/categories'
      path: '/categories'
      fullPath: '/retail/categories'
      preLoaderRoute: typeof AppAuthedSidebarRetailCategoriesRouteImport
      parentRoute: typeof AppAuthedSidebarRetailRouteRoute
    }
    '/_app/_authed/_sidebar/retail/contact': {
      id: '/_app/_authed/_sidebar/retail/contact'
      path: '/contact'
      fullPath: '/retail/contact'
      preLoaderRoute: typeof AppAuthedSidebarRetailContactRouteImport
      parentRoute: typeof AppAuthedSidebarRetailRouteRoute
    }
    '/_app/_authed/_sidebar/retail/guide-videos': {
      id: '/_app/_authed/_sidebar/retail/guide-videos'
      path: '/guide-videos'
      fullPath: '/retail/guide-videos'
      preLoaderRoute: typeof AppAuthedSidebarRetailGuideVideosRouteImport
      parentRoute: typeof AppAuthedSidebarRetailRouteRoute
    }
    '/_app/_authed/_sidebar/retail/home': {
      id: '/_app/_authed/_sidebar/retail/home'
      path: '/home'
      fullPath: '/retail/home'
      preLoaderRoute: typeof AppAuthedSidebarRetailHomeRouteImport
      parentRoute: typeof AppAuthedSidebarRetailRouteRoute
    }
    '/_app/_authed/_sidebar/retail/media': {
      id: '/_app/_authed/_sidebar/retail/media'
      path: '/media'
      fullPath: '/retail/media'
      preLoaderRoute: typeof AppAuthedSidebarRetailMediaRouteImport
      parentRoute: typeof AppAuthedSidebarRetailRouteRoute
    }
    '/_app/_authed/_sidebar/retail/member-tiers': {
      id: '/_app/_authed/_sidebar/retail/member-tiers'
      path: '/member-tiers'
      fullPath: '/retail/member-tiers'
      preLoaderRoute: typeof AppAuthedSidebarRetailMemberTiersRouteImport
      parentRoute: typeof AppAuthedSidebarRetailRouteRoute
    }
    '/_app/_authed/_sidebar/retail/online-prices': {
      id: '/_app/_authed/_sidebar/retail/online-prices'
      path: '/online-prices'
      fullPath: '/retail/online-prices'
      preLoaderRoute: typeof AppAuthedSidebarRetailOnlinePricesRouteImport
      parentRoute: typeof AppAuthedSidebarRetailRouteRoute
    }
    '/_app/_authed/_sidebar/retail/post-categories': {
      id: '/_app/_authed/_sidebar/retail/post-categories'
      path: '/post-categories'
      fullPath: '/retail/post-categories'
      preLoaderRoute: typeof AppAuthedSidebarRetailPostCategoriesRouteImport
      parentRoute: typeof AppAuthedSidebarRetailRouteRoute
    }
    '/_app/_authed/_sidebar/retail/site-settings': {
      id: '/_app/_authed/_sidebar/retail/site-settings'
      path: '/site-settings'
      fullPath: '/retail/site-settings'
      preLoaderRoute: typeof AppAuthedSidebarRetailSiteSettingsRouteImport
      parentRoute: typeof AppAuthedSidebarRetailRouteRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/grades': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/grades'
      path: '/scenting-warehouse/grades'
      fullPath: '/scenting-warehouse/grades'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseGradesRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/stats': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/stats'
      path: '/scenting-warehouse/stats'
      fullPath: '/scenting-warehouse/stats'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseStatsRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/settings/face-recognition': {
      id: '/_app/_authed/_sidebar/settings/face-recognition'
      path: '/settings/face-recognition'
      fullPath: '/settings/face-recognition'
      preLoaderRoute: typeof AppAuthedSidebarSettingsFaceRecognitionRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/settings/invoice': {
      id: '/_app/_authed/_sidebar/settings/invoice'
      path: '/settings/invoice'
      fullPath: '/settings/invoice'
      preLoaderRoute: typeof AppAuthedSidebarSettingsInvoiceRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/settings/lot-sizes': {
      id: '/_app/_authed/_sidebar/settings/lot-sizes'
      path: '/settings/lot-sizes'
      fullPath: '/settings/lot-sizes'
      preLoaderRoute: typeof AppAuthedSidebarSettingsLotSizesRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/settings/notifications': {
      id: '/_app/_authed/_sidebar/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AppAuthedSidebarSettingsNotificationsRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/settings/printing': {
      id: '/_app/_authed/_sidebar/settings/printing'
      path: '/settings/printing'
      fullPath: '/settings/printing'
      preLoaderRoute: typeof AppAuthedSidebarSettingsPrintingRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/settings/production-station-voice': {
      id: '/_app/_authed/_sidebar/settings/production-station-voice'
      path: '/settings/production-station-voice'
      fullPath: '/settings/production-station-voice'
      preLoaderRoute: typeof AppAuthedSidebarSettingsProductionStationVoiceRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/settings/sidebar-layout': {
      id: '/_app/_authed/_sidebar/settings/sidebar-layout'
      path: '/settings/sidebar-layout'
      fullPath: '/settings/sidebar-layout'
      preLoaderRoute: typeof AppAuthedSidebarSettingsSidebarLayoutRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/settings/sla': {
      id: '/_app/_authed/_sidebar/settings/sla'
      path: '/settings/sla'
      fullPath: '/settings/sla'
      preLoaderRoute: typeof AppAuthedSidebarSettingsSlaRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/settings/station-voice': {
      id: '/_app/_authed/_sidebar/settings/station-voice'
      path: '/settings/station-voice'
      fullPath: '/settings/station-voice'
      preLoaderRoute: typeof AppAuthedSidebarSettingsStationVoiceRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/settings/warehouse-station-voice': {
      id: '/_app/_authed/_sidebar/settings/warehouse-station-voice'
      path: '/settings/warehouse-station-voice'
      fullPath: '/settings/warehouse-station-voice'
      preLoaderRoute: typeof AppAuthedSidebarSettingsWarehouseStationVoiceRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/settings/zalo': {
      id: '/_app/_authed/_sidebar/settings/zalo'
      path: '/settings/zalo'
      fullPath: '/settings/zalo'
      preLoaderRoute: typeof AppAuthedSidebarSettingsZaloRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/smartlab/': {
      id: '/_app/_authed/_sidebar/smartlab/'
      path: '/smartlab'
      fullPath: '/smartlab/'
      preLoaderRoute: typeof AppAuthedSidebarSmartlabIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/stats': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/stats'
      path: '/sorting-warehouse/stats'
      fullPath: '/sorting-warehouse/stats'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseStatsRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/tea-grades': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/tea-grades'
      path: '/sorting-warehouse/tea-grades'
      fullPath: '/sorting-warehouse/tea-grades'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseTeaGradesRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/stocktake/': {
      id: '/_app/_authed/_sidebar/stocktake/'
      path: '/stocktake'
      fullPath: '/stocktake/'
      preLoaderRoute: typeof AppAuthedSidebarStocktakeIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/stocktake/$id': {
      id: '/_app/_authed/_sidebar/stocktake/$id'
      path: '/stocktake/$id'
      fullPath: '/stocktake/$id'
      preLoaderRoute: typeof AppAuthedSidebarStocktakeIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/stocktake/new': {
      id: '/_app/_authed/_sidebar/stocktake/new'
      path: '/stocktake/new'
      fullPath: '/stocktake/new'
      preLoaderRoute: typeof AppAuthedSidebarStocktakeNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/tea-purchases/': {
      id: '/_app/_authed/_sidebar/tea-purchases/'
      path: '/tea-purchases'
      fullPath: '/tea-purchases/'
      preLoaderRoute: typeof AppAuthedSidebarTeaPurchasesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/tea-purchases/$id': {
      id: '/_app/_authed/_sidebar/tea-purchases/$id'
      path: '/tea-purchases/$id'
      fullPath: '/tea-purchases/$id'
      preLoaderRoute: typeof AppAuthedSidebarTeaPurchasesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/tea-purchases/processing': {
      id: '/_app/_authed/_sidebar/tea-purchases/processing'
      path: '/tea-purchases/processing'
      fullPath: '/tea-purchases/processing'
      preLoaderRoute: typeof AppAuthedSidebarTeaPurchasesProcessingRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/users/': {
      id: '/_app/_authed/_sidebar/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AppAuthedSidebarUsersIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/vehicles/': {
      id: '/_app/_authed/_sidebar/vehicles/'
      path: '/vehicles'
      fullPath: '/vehicles/'
      preLoaderRoute: typeof AppAuthedSidebarVehiclesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/vehicles/$vehicleId': {
      id: '/_app/_authed/_sidebar/vehicles/$vehicleId'
      path: '/vehicles/$vehicleId'
      fullPath: '/vehicles/$vehicleId'
      preLoaderRoute: typeof AppAuthedSidebarVehiclesVehicleIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/warehouse-positions/': {
      id: '/_app/_authed/_sidebar/warehouse-positions/'
      path: '/warehouse-positions'
      fullPath: '/warehouse-positions/'
      preLoaderRoute: typeof AppAuthedSidebarWarehousePositionsIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/warehouse-positions/$id': {
      id: '/_app/_authed/_sidebar/warehouse-positions/$id'
      path: '/warehouse-positions/$id'
      fullPath: '/warehouse-positions/$id'
      preLoaderRoute: typeof AppAuthedSidebarWarehousePositionsIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/warehouse-positions/new': {
      id: '/_app/_authed/_sidebar/warehouse-positions/new'
      path: '/warehouse-positions/new'
      fullPath: '/warehouse-positions/new'
      preLoaderRoute: typeof AppAuthedSidebarWarehousePositionsNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/warehouse-sales/dashboard': {
      id: '/_app/_authed/_sidebar/warehouse-sales/dashboard'
      path: '/warehouse-sales/dashboard'
      fullPath: '/warehouse-sales/dashboard'
      preLoaderRoute: typeof AppAuthedSidebarWarehouseSalesDashboardRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/warehouse-sales/defects': {
      id: '/_app/_authed/_sidebar/warehouse-sales/defects'
      path: '/warehouse-sales/defects'
      fullPath: '/warehouse-sales/defects'
      preLoaderRoute: typeof AppAuthedSidebarWarehouseSalesDefectsRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/warehouse-sales/stats': {
      id: '/_app/_authed/_sidebar/warehouse-sales/stats'
      path: '/warehouse-sales/stats'
      fullPath: '/warehouse-sales/stats'
      preLoaderRoute: typeof AppAuthedSidebarWarehouseSalesStatsRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/work-activities/board': {
      id: '/_app/_authed/_sidebar/work-activities/board'
      path: '/work-activities/board'
      fullPath: '/work-activities/board'
      preLoaderRoute: typeof AppAuthedSidebarWorkActivitiesBoardRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/work-activities/calendar': {
      id: '/_app/_authed/_sidebar/work-activities/calendar'
      path: '/work-activities/calendar'
      fullPath: '/work-activities/calendar'
      preLoaderRoute: typeof AppAuthedSidebarWorkActivitiesCalendarRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/work-activities/guests': {
      id: '/_app/_authed/_sidebar/work-activities/guests'
      path: '/work-activities/guests'
      fullPath: '/work-activities/guests'
      preLoaderRoute: typeof AppAuthedSidebarWorkActivitiesGuestsRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/support/t/$ref': {
      id: '/_app/_authed/support/t/$ref'
      path: '/support/t/$ref'
      fullPath: '/support/t/$ref'
      preLoaderRoute: typeof AppAuthedSupportTRefRouteImport
      parentRoute: typeof AppAuthedRoute
    }
    '/_app/_authed/_sidebar/accounting/reports/daily': {
      id: '/_app/_authed/_sidebar/accounting/reports/daily'
      path: '/accounting/reports/daily'
      fullPath: '/accounting/reports/daily'
      preLoaderRoute: typeof AppAuthedSidebarAccountingReportsDailyRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/agricultural-materials/lots/': {
      id: '/_app/_authed/_sidebar/agricultural-materials/lots/'
      path: '/agricultural-materials/lots'
      fullPath: '/agricultural-materials/lots/'
      preLoaderRoute: typeof AppAuthedSidebarAgriculturalMaterialsLotsIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/agricultural-materials/lots/$id': {
      id: '/_app/_authed/_sidebar/agricultural-materials/lots/$id'
      path: '/agricultural-materials/lots/$id'
      fullPath: '/agricultural-materials/lots/$id'
      preLoaderRoute: typeof AppAuthedSidebarAgriculturalMaterialsLotsIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/agricultural-materials/stock-in-notes/': {
      id: '/_app/_authed/_sidebar/agricultural-materials/stock-in-notes/'
      path: '/agricultural-materials/stock-in-notes'
      fullPath: '/agricultural-materials/stock-in-notes/'
      preLoaderRoute: typeof AppAuthedSidebarAgriculturalMaterialsStockInNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/agricultural-materials/stock-in-notes/$id': {
      id: '/_app/_authed/_sidebar/agricultural-materials/stock-in-notes/$id'
      path: '/agricultural-materials/stock-in-notes/$id'
      fullPath: '/agricultural-materials/stock-in-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarAgriculturalMaterialsStockInNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/agricultural-materials/stock-in-notes/new': {
      id: '/_app/_authed/_sidebar/agricultural-materials/stock-in-notes/new'
      path: '/agricultural-materials/stock-in-notes/new'
      fullPath: '/agricultural-materials/stock-in-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarAgriculturalMaterialsStockInNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/agricultural-materials/stock-out-notes/': {
      id: '/_app/_authed/_sidebar/agricultural-materials/stock-out-notes/'
      path: '/agricultural-materials/stock-out-notes'
      fullPath: '/agricultural-materials/stock-out-notes/'
      preLoaderRoute: typeof AppAuthedSidebarAgriculturalMaterialsStockOutNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/agricultural-materials/stock-out-notes/$id': {
      id: '/_app/_authed/_sidebar/agricultural-materials/stock-out-notes/$id'
      path: '/agricultural-materials/stock-out-notes/$id'
      fullPath: '/agricultural-materials/stock-out-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarAgriculturalMaterialsStockOutNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/agricultural-materials/stock-out-notes/new': {
      id: '/_app/_authed/_sidebar/agricultural-materials/stock-out-notes/new'
      path: '/agricultural-materials/stock-out-notes/new'
      fullPath: '/agricultural-materials/stock-out-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarAgriculturalMaterialsStockOutNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/agriculture/care-logs/': {
      id: '/_app/_authed/_sidebar/agriculture/care-logs/'
      path: '/'
      fullPath: '/agriculture/care-logs/'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureCareLogsIndexRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureCareLogsRoute
    }
    '/_app/_authed/_sidebar/agriculture/care-logs/new': {
      id: '/_app/_authed/_sidebar/agriculture/care-logs/new'
      path: '/new'
      fullPath: '/agriculture/care-logs/new'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureCareLogsNewRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureCareLogsRoute
    }
    '/_app/_authed/_sidebar/agriculture/growers/': {
      id: '/_app/_authed/_sidebar/agriculture/growers/'
      path: '/'
      fullPath: '/agriculture/growers/'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureGrowersIndexRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureGrowersRoute
    }
    '/_app/_authed/_sidebar/agriculture/growers/$id': {
      id: '/_app/_authed/_sidebar/agriculture/growers/$id'
      path: '/$id'
      fullPath: '/agriculture/growers/$id'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureGrowersIdRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureGrowersRoute
    }
    '/_app/_authed/_sidebar/agriculture/growers/new': {
      id: '/_app/_authed/_sidebar/agriculture/growers/new'
      path: '/new'
      fullPath: '/agriculture/growers/new'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureGrowersNewRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureGrowersRoute
    }
    '/_app/_authed/_sidebar/agriculture/my-grower/': {
      id: '/_app/_authed/_sidebar/agriculture/my-grower/'
      path: '/my-grower'
      fullPath: '/agriculture/my-grower/'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureMyGrowerIndexRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureRouteRoute
    }
    '/_app/_authed/_sidebar/agriculture/my-grower/$growerId': {
      id: '/_app/_authed/_sidebar/agriculture/my-grower/$growerId'
      path: '/my-grower/$growerId'
      fullPath: '/agriculture/my-grower/$growerId'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureMyGrowerGrowerIdRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureRouteRoute
    }
    '/_app/_authed/_sidebar/customers/groups/': {
      id: '/_app/_authed/_sidebar/customers/groups/'
      path: '/customers/groups'
      fullPath: '/customers/groups/'
      preLoaderRoute: typeof AppAuthedSidebarCustomersGroupsIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/customers/groups/$groupId': {
      id: '/_app/_authed/_sidebar/customers/groups/$groupId'
      path: '/customers/groups/$groupId'
      fullPath: '/customers/groups/$groupId'
      preLoaderRoute: typeof AppAuthedSidebarCustomersGroupsGroupIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/organization/departments/': {
      id: '/_app/_authed/_sidebar/organization/departments/'
      path: '/organization/departments'
      fullPath: '/organization/departments/'
      preLoaderRoute: typeof AppAuthedSidebarOrganizationDepartmentsIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/organization/employees/': {
      id: '/_app/_authed/_sidebar/organization/employees/'
      path: '/organization/employees'
      fullPath: '/organization/employees/'
      preLoaderRoute: typeof AppAuthedSidebarOrganizationEmployeesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/count-log/': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/count-log/'
      path: '/packaging-warehouse/count-log'
      fullPath: '/packaging-warehouse/count-log/'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseCountLogIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/lots/': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/lots/'
      path: '/packaging-warehouse/lots'
      fullPath: '/packaging-warehouse/lots/'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseLotsIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/lots/$id': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/lots/$id'
      path: '/packaging-warehouse/lots/$id'
      fullPath: '/packaging-warehouse/lots/$id'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseLotsIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/'
      path: '/packaging-warehouse/stock-in-notes'
      fullPath: '/packaging-warehouse/stock-in-notes/'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseStockInNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/$id': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/$id'
      path: '/packaging-warehouse/stock-in-notes/$id'
      fullPath: '/packaging-warehouse/stock-in-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseStockInNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/new': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/new'
      path: '/packaging-warehouse/stock-in-notes/new'
      fullPath: '/packaging-warehouse/stock-in-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseStockInNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/'
      path: '/packaging-warehouse/stock-out-notes'
      fullPath: '/packaging-warehouse/stock-out-notes/'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/$id': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/$id'
      path: '/packaging-warehouse/stock-out-notes/$id'
      fullPath: '/packaging-warehouse/stock-out-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/new': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/new'
      path: '/packaging-warehouse/stock-out-notes/new'
      fullPath: '/packaging-warehouse/stock-out-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseStockOutNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/'
      path: '/packaging-warehouse/withdrawal-notes'
      fullPath: '/packaging-warehouse/withdrawal-notes/'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/$id': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/$id'
      path: '/packaging-warehouse/withdrawal-notes/$id'
      fullPath: '/packaging-warehouse/withdrawal-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/new': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/new'
      path: '/packaging-warehouse/withdrawal-notes/new'
      fullPath: '/packaging-warehouse/withdrawal-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/retail/accounts/': {
      id: '/_app/_authed/_sidebar/retail/accounts/'
      path: '/accounts'
      fullPath: '/retail/accounts/'
      preLoaderRoute: typeof AppAuthedSidebarRetailAccountsIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRetailRouteRoute
    }
    '/_app/_authed/_sidebar/retail/accounts/$accountId': {
      id: '/_app/_authed/_sidebar/retail/accounts/$accountId'
      path: '/accounts/$accountId'
      fullPath: '/retail/accounts/$accountId'
      preLoaderRoute: typeof AppAuthedSidebarRetailAccountsAccountIdRouteImport
      parentRoute: typeof AppAuthedSidebarRetailRouteRoute
    }
    '/_app/_authed/_sidebar/retail/groups/': {
      id: '/_app/_authed/_sidebar/retail/groups/'
      path: '/groups'
      fullPath: '/retail/groups/'
      preLoaderRoute: typeof AppAuthedSidebarRetailGroupsIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRetailRouteRoute
    }
    '/_app/_authed/_sidebar/retail/groups/$groupId': {
      id: '/_app/_authed/_sidebar/retail/groups/$groupId'
      path: '/groups/$groupId'
      fullPath: '/retail/groups/$groupId'
      preLoaderRoute: typeof AppAuthedSidebarRetailGroupsGroupIdRouteImport
      parentRoute: typeof AppAuthedSidebarRetailRouteRoute
    }
    '/_app/_authed/_sidebar/retail/groups/new': {
      id: '/_app/_authed/_sidebar/retail/groups/new'
      path: '/groups/new'
      fullPath: '/retail/groups/new'
      preLoaderRoute: typeof AppAuthedSidebarRetailGroupsNewRouteImport
      parentRoute: typeof AppAuthedSidebarRetailRouteRoute
    }
    '/_app/_authed/_sidebar/retail/pages/': {
      id: '/_app/_authed/_sidebar/retail/pages/'
      path: '/pages'
      fullPath: '/retail/pages/'
      preLoaderRoute: typeof AppAuthedSidebarRetailPagesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRetailRouteRoute
    }
    '/_app/_authed/_sidebar/retail/pages/$pageId': {
      id: '/_app/_authed/_sidebar/retail/pages/$pageId'
      path: '/pages/$pageId'
      fullPath: '/retail/pages/$pageId'
      preLoaderRoute: typeof AppAuthedSidebarRetailPagesPageIdRouteImport
      parentRoute: typeof AppAuthedSidebarRetailRouteRoute
    }
    '/_app/_authed/_sidebar/retail/pages/new': {
      id: '/_app/_authed/_sidebar/retail/pages/new'
      path: '/pages/new'
      fullPath: '/retail/pages/new'
      preLoaderRoute: typeof AppAuthedSidebarRetailPagesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRetailRouteRoute
    }
    '/_app/_authed/_sidebar/retail/posts/': {
      id: '/_app/_authed/_sidebar/retail/posts/'
      path: '/posts'
      fullPath: '/retail/posts/'
      preLoaderRoute: typeof AppAuthedSidebarRetailPostsIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRetailRouteRoute
    }
    '/_app/_authed/_sidebar/retail/posts/$postId': {
      id: '/_app/_authed/_sidebar/retail/posts/$postId'
      path: '/posts/$postId'
      fullPath: '/retail/posts/$postId'
      preLoaderRoute: typeof AppAuthedSidebarRetailPostsPostIdRouteImport
      parentRoute: typeof AppAuthedSidebarRetailRouteRoute
    }
    '/_app/_authed/_sidebar/retail/posts/new': {
      id: '/_app/_authed/_sidebar/retail/posts/new'
      path: '/posts/new'
      fullPath: '/retail/posts/new'
      preLoaderRoute: typeof AppAuthedSidebarRetailPostsNewRouteImport
      parentRoute: typeof AppAuthedSidebarRetailRouteRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/box-log/': {
      id: '/_app/_authed/_sidebar/sales-warehouse/box-log/'
      path: '/sales-warehouse/box-log'
      fullPath: '/sales-warehouse/box-log/'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseBoxLogIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/lots/': {
      id: '/_app/_authed/_sidebar/sales-warehouse/lots/'
      path: '/sales-warehouse/lots'
      fullPath: '/sales-warehouse/lots/'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseLotsIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/lots/$id': {
      id: '/_app/_authed/_sidebar/sales-warehouse/lots/$id'
      path: '/sales-warehouse/lots/$id'
      fullPath: '/sales-warehouse/lots/$id'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseLotsIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/other-log/': {
      id: '/_app/_authed/_sidebar/sales-warehouse/other-log/'
      path: '/sales-warehouse/other-log'
      fullPath: '/sales-warehouse/other-log/'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseOtherLogIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/packaging-log/': {
      id: '/_app/_authed/_sidebar/sales-warehouse/packaging-log/'
      path: '/sales-warehouse/packaging-log'
      fullPath: '/sales-warehouse/packaging-log/'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehousePackagingLogIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/': {
      id: '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/'
      path: '/sales-warehouse/stock-in-notes'
      fullPath: '/sales-warehouse/stock-in-notes/'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseStockInNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/$id': {
      id: '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/$id'
      path: '/sales-warehouse/stock-in-notes/$id'
      fullPath: '/sales-warehouse/stock-in-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseStockInNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/new': {
      id: '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/new'
      path: '/sales-warehouse/stock-in-notes/new'
      fullPath: '/sales-warehouse/stock-in-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseStockInNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/quick': {
      id: '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/quick'
      path: '/sales-warehouse/stock-in-notes/quick'
      fullPath: '/sales-warehouse/stock-in-notes/quick'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseStockInNotesQuickRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/': {
      id: '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/'
      path: '/sales-warehouse/stock-out-notes'
      fullPath: '/sales-warehouse/stock-out-notes/'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseStockOutNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/$id': {
      id: '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/$id'
      path: '/sales-warehouse/stock-out-notes/$id'
      fullPath: '/sales-warehouse/stock-out-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseStockOutNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/new': {
      id: '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/new'
      path: '/sales-warehouse/stock-out-notes/new'
      fullPath: '/sales-warehouse/stock-out-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseStockOutNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/transfer-notes/': {
      id: '/_app/_authed/_sidebar/sales-warehouse/transfer-notes/'
      path: '/sales-warehouse/transfer-notes'
      fullPath: '/sales-warehouse/transfer-notes/'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseTransferNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/transfer-notes/$id': {
      id: '/_app/_authed/_sidebar/sales-warehouse/transfer-notes/$id'
      path: '/sales-warehouse/transfer-notes/$id'
      fullPath: '/sales-warehouse/transfer-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseTransferNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/transfer-notes/new': {
      id: '/_app/_authed/_sidebar/sales-warehouse/transfer-notes/new'
      path: '/sales-warehouse/transfer-notes/new'
      fullPath: '/sales-warehouse/transfer-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseTransferNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/log/': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/log/'
      path: '/scenting-warehouse/log'
      fullPath: '/scenting-warehouse/log/'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseLogIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/lots/': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/lots/'
      path: '/scenting-warehouse/lots'
      fullPath: '/scenting-warehouse/lots/'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseLotsIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/lots/$id': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/lots/$id'
      path: '/scenting-warehouse/lots/$id'
      fullPath: '/scenting-warehouse/lots/$id'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseLotsIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/'
      path: '/scenting-warehouse/stock-in-notes'
      fullPath: '/scenting-warehouse/stock-in-notes/'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseStockInNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/$id': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/$id'
      path: '/scenting-warehouse/stock-in-notes/$id'
      fullPath: '/scenting-warehouse/stock-in-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseStockInNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/new': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/new'
      path: '/scenting-warehouse/stock-in-notes/new'
      fullPath: '/scenting-warehouse/stock-in-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseStockInNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/'
      path: '/scenting-warehouse/stock-out-notes'
      fullPath: '/scenting-warehouse/stock-out-notes/'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseStockOutNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/$id': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/$id'
      path: '/scenting-warehouse/stock-out-notes/$id'
      fullPath: '/scenting-warehouse/stock-out-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseStockOutNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/new': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/new'
      path: '/scenting-warehouse/stock-out-notes/new'
      fullPath: '/scenting-warehouse/stock-out-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseStockOutNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/'
      path: '/scenting-warehouse/withdrawal-notes'
      fullPath: '/scenting-warehouse/withdrawal-notes/'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/$id': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/$id'
      path: '/scenting-warehouse/withdrawal-notes/$id'
      fullPath: '/scenting-warehouse/withdrawal-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/new': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/new'
      path: '/scenting-warehouse/withdrawal-notes/new'
      fullPath: '/scenting-warehouse/withdrawal-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/settings/roles/': {
      id: '/_app/_authed/_sidebar/settings/roles/'
      path: '/settings/roles'
      fullPath: '/settings/roles/'
      preLoaderRoute: typeof AppAuthedSidebarSettingsRolesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/settings/roles/$id': {
      id: '/_app/_authed/_sidebar/settings/roles/$id'
      path: '/settings/roles/$id'
      fullPath: '/settings/roles/$id'
      preLoaderRoute: typeof AppAuthedSidebarSettingsRolesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/settings/zalo/': {
      id: '/_app/_authed/_sidebar/settings/zalo/'
      path: '/'
      fullPath: '/settings/zalo/'
      preLoaderRoute: typeof AppAuthedSidebarSettingsZaloIndexRouteImport
      parentRoute: typeof AppAuthedSidebarSettingsZaloRoute
    }
    '/_app/_authed/_sidebar/settings/zalo/messages': {
      id: '/_app/_authed/_sidebar/settings/zalo/messages'
      path: '/messages'
      fullPath: '/settings/zalo/messages'
      preLoaderRoute: typeof AppAuthedSidebarSettingsZaloMessagesRouteImport
      parentRoute: typeof AppAuthedSidebarSettingsZaloRoute
    }
    '/_app/_authed/_sidebar/settings/zalo/purposes': {
      id: '/_app/_authed/_sidebar/settings/zalo/purposes'
      path: '/purposes'
      fullPath: '/settings/zalo/purposes'
      preLoaderRoute: typeof AppAuthedSidebarSettingsZaloPurposesRouteImport
      parentRoute: typeof AppAuthedSidebarSettingsZaloRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/lots/': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/lots/'
      path: '/sorting-warehouse/lots'
      fullPath: '/sorting-warehouse/lots/'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseLotsIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/lots/$id': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/lots/$id'
      path: '/sorting-warehouse/lots/$id'
      fullPath: '/sorting-warehouse/lots/$id'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseLotsIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/'
      path: '/sorting-warehouse/stock-in-notes'
      fullPath: '/sorting-warehouse/stock-in-notes/'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseStockInNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/$id': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/$id'
      path: '/sorting-warehouse/stock-in-notes/$id'
      fullPath: '/sorting-warehouse/stock-in-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseStockInNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/new': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/new'
      path: '/sorting-warehouse/stock-in-notes/new'
      fullPath: '/sorting-warehouse/stock-in-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseStockInNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/'
      path: '/sorting-warehouse/stock-out-notes'
      fullPath: '/sorting-warehouse/stock-out-notes/'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseStockOutNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/$id': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/$id'
      path: '/sorting-warehouse/stock-out-notes/$id'
      fullPath: '/sorting-warehouse/stock-out-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseStockOutNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/new': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/new'
      path: '/sorting-warehouse/stock-out-notes/new'
      fullPath: '/sorting-warehouse/stock-out-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseStockOutNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/'
      path: '/sorting-warehouse/withdrawal-notes'
      fullPath: '/sorting-warehouse/withdrawal-notes/'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/$id': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/$id'
      path: '/sorting-warehouse/withdrawal-notes/$id'
      fullPath: '/sorting-warehouse/withdrawal-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/new': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/new'
      path: '/sorting-warehouse/withdrawal-notes/new'
      fullPath: '/sorting-warehouse/withdrawal-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/agricultural-materials/stock-in-notes/$id_/edit': {
      id: '/_app/_authed/_sidebar/agricultural-materials/stock-in-notes/$id_/edit'
      path: '/agricultural-materials/stock-in-notes/$id/edit'
      fullPath: '/agricultural-materials/stock-in-notes/$id/edit'
      preLoaderRoute: typeof AppAuthedSidebarAgriculturalMaterialsStockInNotesIdEditRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/agricultural-materials/stock-out-notes/$id_/edit': {
      id: '/_app/_authed/_sidebar/agricultural-materials/stock-out-notes/$id_/edit'
      path: '/agricultural-materials/stock-out-notes/$id/edit'
      fullPath: '/agricultural-materials/stock-out-notes/$id/edit'
      preLoaderRoute: typeof AppAuthedSidebarAgriculturalMaterialsStockOutNotesIdEditRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/agriculture/care-logs/$id/edit': {
      id: '/_app/_authed/_sidebar/agriculture/care-logs/$id/edit'
      path: '/$id/edit'
      fullPath: '/agriculture/care-logs/$id/edit'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureCareLogsIdEditRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureCareLogsRoute
    }
    '/_app/_authed/_sidebar/agriculture/growers/$id_/edit': {
      id: '/_app/_authed/_sidebar/agriculture/growers/$id_/edit'
      path: '/$id/edit'
      fullPath: '/agriculture/growers/$id/edit'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureGrowersIdEditRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureGrowersRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/$id_/edit': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/$id_/edit'
      path: '/packaging-warehouse/stock-in-notes/$id/edit'
      fullPath: '/packaging-warehouse/stock-in-notes/$id/edit'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseStockInNotesIdEditRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/$id_/edit': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/$id_/edit'
      path: '/packaging-warehouse/stock-out-notes/$id/edit'
      fullPath: '/packaging-warehouse/stock-out-notes/$id/edit'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIdEditRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/$id_/edit': {
      id: '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/$id_/edit'
      path: '/sales-warehouse/stock-in-notes/$id/edit'
      fullPath: '/sales-warehouse/stock-in-notes/$id/edit'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseStockInNotesIdEditRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/$id_/edit': {
      id: '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/$id_/edit'
      path: '/sales-warehouse/stock-out-notes/$id/edit'
      fullPath: '/sales-warehouse/stock-out-notes/$id/edit'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseStockOutNotesIdEditRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/transfer-notes/$id_/edit': {
      id: '/_app/_authed/_sidebar/sales-warehouse/transfer-notes/$id_/edit'
      path: '/sales-warehouse/transfer-notes/$id/edit'
      fullPath: '/sales-warehouse/transfer-notes/$id/edit'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseTransferNotesIdEditRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/$id_/edit': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/$id_/edit'
      path: '/scenting-warehouse/stock-in-notes/$id/edit'
      fullPath: '/scenting-warehouse/stock-in-notes/$id/edit'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseStockInNotesIdEditRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/$id_/edit': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/$id_/edit'
      path: '/scenting-warehouse/stock-out-notes/$id/edit'
      fullPath: '/scenting-warehouse/stock-out-notes/$id/edit'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseStockOutNotesIdEditRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/settings/zalo/templates/': {
      id: '/_app/_authed/_sidebar/settings/zalo/templates/'
      path: '/templates'
      fullPath: '/settings/zalo/templates/'
      preLoaderRoute: typeof AppAuthedSidebarSettingsZaloTemplatesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarSettingsZaloRoute
    }
    '/_app/_authed/_sidebar/settings/zalo/templates/$id': {
      id: '/_app/_authed/_sidebar/settings/zalo/templates/$id'
      path: '/templates/$id'
      fullPath: '/settings/zalo/templates/$id'
      preLoaderRoute: typeof AppAuthedSidebarSettingsZaloTemplatesIdRouteImport
      parentRoute: typeof AppAuthedSidebarSettingsZaloRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/$id_/edit': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/$id_/edit'
      path: '/sorting-warehouse/stock-in-notes/$id/edit'
      fullPath: '/sorting-warehouse/stock-in-notes/$id/edit'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseStockInNotesIdEditRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/$id_/edit': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/$id_/edit'
      path: '/sorting-warehouse/stock-out-notes/$id/edit'
      fullPath: '/sorting-warehouse/stock-out-notes/$id/edit'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseStockOutNotesIdEditRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/agriculture/growers/$id_/faces/': {
      id: '/_app/_authed/_sidebar/agriculture/growers/$id_/faces/'
      path: '/$id/faces'
      fullPath: '/agriculture/growers/$id/faces/'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureGrowersIdFacesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureGrowersRoute
    }
    '/_app/_authed/_sidebar/agriculture/growers/$id_/faces/$faceId': {
      id: '/_app/_authed/_sidebar/agriculture/growers/$id_/faces/$faceId'
      path: '/$id/faces/$faceId'
      fullPath: '/agriculture/growers/$id/faces/$faceId'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureGrowersIdFacesFaceIdRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureGrowersRoute
    }
    '/_app/_authed/_sidebar/agriculture/my-grower/$growerId_/faces/': {
      id: '/_app/_authed/_sidebar/agriculture/my-grower/$growerId_/faces/'
      path: '/my-grower/$growerId/faces'
      fullPath: '/agriculture/my-grower/$growerId/faces/'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureMyGrowerGrowerIdFacesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureRouteRoute
    }
    '/_app/_authed/_sidebar/agriculture/my-grower/$growerId_/faces/$faceId': {
      id: '/_app/_authed/_sidebar/agriculture/my-grower/$growerId_/faces/$faceId'
      path: '/my-grower/$growerId/faces/$faceId'
      fullPath: '/agriculture/my-grower/$growerId/faces/$faceId'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureMyGrowerGrowerIdFacesFaceIdRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureRouteRoute
    }
  }
}

interface AppAuthedSidebarAgricultureCareLogsRouteChildren {
  AppAuthedSidebarAgricultureCareLogsNewRoute: typeof AppAuthedSidebarAgricultureCareLogsNewRoute
  AppAuthedSidebarAgricultureCareLogsIndexRoute: typeof AppAuthedSidebarAgricultureCareLogsIndexRoute
  AppAuthedSidebarAgricultureCareLogsIdEditRoute: typeof AppAuthedSidebarAgricultureCareLogsIdEditRoute
}

const AppAuthedSidebarAgricultureCareLogsRouteChildren: AppAuthedSidebarAgricultureCareLogsRouteChildren =
  {
    AppAuthedSidebarAgricultureCareLogsNewRoute:
      AppAuthedSidebarAgricultureCareLogsNewRoute,
    AppAuthedSidebarAgricultureCareLogsIndexRoute:
      AppAuthedSidebarAgricultureCareLogsIndexRoute,
    AppAuthedSidebarAgricultureCareLogsIdEditRoute:
      AppAuthedSidebarAgricultureCareLogsIdEditRoute,
  }

const AppAuthedSidebarAgricultureCareLogsRouteWithChildren =
  AppAuthedSidebarAgricultureCareLogsRoute._addFileChildren(
    AppAuthedSidebarAgricultureCareLogsRouteChildren,
  )

interface AppAuthedSidebarAgricultureGrowersRouteChildren {
  AppAuthedSidebarAgricultureGrowersIdRoute: typeof AppAuthedSidebarAgricultureGrowersIdRoute
  AppAuthedSidebarAgricultureGrowersNewRoute: typeof AppAuthedSidebarAgricultureGrowersNewRoute
  AppAuthedSidebarAgricultureGrowersIndexRoute: typeof AppAuthedSidebarAgricultureGrowersIndexRoute
  AppAuthedSidebarAgricultureGrowersIdEditRoute: typeof AppAuthedSidebarAgricultureGrowersIdEditRoute
  AppAuthedSidebarAgricultureGrowersIdFacesFaceIdRoute: typeof AppAuthedSidebarAgricultureGrowersIdFacesFaceIdRoute
  AppAuthedSidebarAgricultureGrowersIdFacesIndexRoute: typeof AppAuthedSidebarAgricultureGrowersIdFacesIndexRoute
}

const AppAuthedSidebarAgricultureGrowersRouteChildren: AppAuthedSidebarAgricultureGrowersRouteChildren =
  {
    AppAuthedSidebarAgricultureGrowersIdRoute:
      AppAuthedSidebarAgricultureGrowersIdRoute,
    AppAuthedSidebarAgricultureGrowersNewRoute:
      AppAuthedSidebarAgricultureGrowersNewRoute,
    AppAuthedSidebarAgricultureGrowersIndexRoute:
      AppAuthedSidebarAgricultureGrowersIndexRoute,
    AppAuthedSidebarAgricultureGrowersIdEditRoute:
      AppAuthedSidebarAgricultureGrowersIdEditRoute,
    AppAuthedSidebarAgricultureGrowersIdFacesFaceIdRoute:
      AppAuthedSidebarAgricultureGrowersIdFacesFaceIdRoute,
    AppAuthedSidebarAgricultureGrowersIdFacesIndexRoute:
      AppAuthedSidebarAgricultureGrowersIdFacesIndexRoute,
  }

const AppAuthedSidebarAgricultureGrowersRouteWithChildren =
  AppAuthedSidebarAgricultureGrowersRoute._addFileChildren(
    AppAuthedSidebarAgricultureGrowersRouteChildren,
  )

interface AppAuthedSidebarAgricultureRouteRouteChildren {
  AppAuthedSidebarAgricultureAreaMapRoute: typeof AppAuthedSidebarAgricultureAreaMapRoute
  AppAuthedSidebarAgricultureCamerasRoute: typeof AppAuthedSidebarAgricultureCamerasRoute
  AppAuthedSidebarAgricultureCareLogsRoute: typeof AppAuthedSidebarAgricultureCareLogsRouteWithChildren
  AppAuthedSidebarAgricultureCareRemindersRoute: typeof AppAuthedSidebarAgricultureCareRemindersRoute
  AppAuthedSidebarAgricultureGrowersRoute: typeof AppAuthedSidebarAgricultureGrowersRouteWithChildren
  AppAuthedSidebarAgricultureIrrigationDevicesRoute: typeof AppAuthedSidebarAgricultureIrrigationDevicesRoute
  AppAuthedSidebarAgricultureMyReportsRoute: typeof AppAuthedSidebarAgricultureMyReportsRoute
  AppAuthedSidebarAgricultureMyWeighingsRoute: typeof AppAuthedSidebarAgricultureMyWeighingsRoute
  AppAuthedSidebarAgricultureTeaTypesRoute: typeof AppAuthedSidebarAgricultureTeaTypesRoute
  AppAuthedSidebarAgricultureMyGrowerGrowerIdRoute: typeof AppAuthedSidebarAgricultureMyGrowerGrowerIdRoute
  AppAuthedSidebarAgricultureMyGrowerIndexRoute: typeof AppAuthedSidebarAgricultureMyGrowerIndexRoute
  AppAuthedSidebarAgricultureMyGrowerGrowerIdFacesFaceIdRoute: typeof AppAuthedSidebarAgricultureMyGrowerGrowerIdFacesFaceIdRoute
  AppAuthedSidebarAgricultureMyGrowerGrowerIdFacesIndexRoute: typeof AppAuthedSidebarAgricultureMyGrowerGrowerIdFacesIndexRoute
}

const AppAuthedSidebarAgricultureRouteRouteChildren: AppAuthedSidebarAgricultureRouteRouteChildren =
  {
    AppAuthedSidebarAgricultureAreaMapRoute:
      AppAuthedSidebarAgricultureAreaMapRoute,
    AppAuthedSidebarAgricultureCamerasRoute:
      AppAuthedSidebarAgricultureCamerasRoute,
    AppAuthedSidebarAgricultureCareLogsRoute:
      AppAuthedSidebarAgricultureCareLogsRouteWithChildren,
    AppAuthedSidebarAgricultureCareRemindersRoute:
      AppAuthedSidebarAgricultureCareRemindersRoute,
    AppAuthedSidebarAgricultureGrowersRoute:
      AppAuthedSidebarAgricultureGrowersRouteWithChildren,
    AppAuthedSidebarAgricultureIrrigationDevicesRoute:
      AppAuthedSidebarAgricultureIrrigationDevicesRoute,
    AppAuthedSidebarAgricultureMyReportsRoute:
      AppAuthedSidebarAgricultureMyReportsRoute,
    AppAuthedSidebarAgricultureMyWeighingsRoute:
      AppAuthedSidebarAgricultureMyWeighingsRoute,
    AppAuthedSidebarAgricultureTeaTypesRoute:
      AppAuthedSidebarAgricultureTeaTypesRoute,
    AppAuthedSidebarAgricultureMyGrowerGrowerIdRoute:
      AppAuthedSidebarAgricultureMyGrowerGrowerIdRoute,
    AppAuthedSidebarAgricultureMyGrowerIndexRoute:
      AppAuthedSidebarAgricultureMyGrowerIndexRoute,
    AppAuthedSidebarAgricultureMyGrowerGrowerIdFacesFaceIdRoute:
      AppAuthedSidebarAgricultureMyGrowerGrowerIdFacesFaceIdRoute,
    AppAuthedSidebarAgricultureMyGrowerGrowerIdFacesIndexRoute:
      AppAuthedSidebarAgricultureMyGrowerGrowerIdFacesIndexRoute,
  }

const AppAuthedSidebarAgricultureRouteRouteWithChildren =
  AppAuthedSidebarAgricultureRouteRoute._addFileChildren(
    AppAuthedSidebarAgricultureRouteRouteChildren,
  )

interface AppAuthedSidebarRetailRouteRouteChildren {
  AppAuthedSidebarRetailCategoriesRoute: typeof AppAuthedSidebarRetailCategoriesRoute
  AppAuthedSidebarRetailContactRoute: typeof AppAuthedSidebarRetailContactRoute
  AppAuthedSidebarRetailGuideVideosRoute: typeof AppAuthedSidebarRetailGuideVideosRoute
  AppAuthedSidebarRetailHomeRoute: typeof AppAuthedSidebarRetailHomeRoute
  AppAuthedSidebarRetailMediaRoute: typeof AppAuthedSidebarRetailMediaRoute
  AppAuthedSidebarRetailMemberTiersRoute: typeof AppAuthedSidebarRetailMemberTiersRoute
  AppAuthedSidebarRetailOnlinePricesRoute: typeof AppAuthedSidebarRetailOnlinePricesRoute
  AppAuthedSidebarRetailPostCategoriesRoute: typeof AppAuthedSidebarRetailPostCategoriesRoute
  AppAuthedSidebarRetailSiteSettingsRoute: typeof AppAuthedSidebarRetailSiteSettingsRoute
  AppAuthedSidebarRetailAccountsAccountIdRoute: typeof AppAuthedSidebarRetailAccountsAccountIdRoute
  AppAuthedSidebarRetailGroupsGroupIdRoute: typeof AppAuthedSidebarRetailGroupsGroupIdRoute
  AppAuthedSidebarRetailGroupsNewRoute: typeof AppAuthedSidebarRetailGroupsNewRoute
  AppAuthedSidebarRetailPagesPageIdRoute: typeof AppAuthedSidebarRetailPagesPageIdRoute
  AppAuthedSidebarRetailPagesNewRoute: typeof AppAuthedSidebarRetailPagesNewRoute
  AppAuthedSidebarRetailPostsPostIdRoute: typeof AppAuthedSidebarRetailPostsPostIdRoute
  AppAuthedSidebarRetailPostsNewRoute: typeof AppAuthedSidebarRetailPostsNewRoute
  AppAuthedSidebarRetailAccountsIndexRoute: typeof AppAuthedSidebarRetailAccountsIndexRoute
  AppAuthedSidebarRetailGroupsIndexRoute: typeof AppAuthedSidebarRetailGroupsIndexRoute
  AppAuthedSidebarRetailPagesIndexRoute: typeof AppAuthedSidebarRetailPagesIndexRoute
  AppAuthedSidebarRetailPostsIndexRoute: typeof AppAuthedSidebarRetailPostsIndexRoute
}

const AppAuthedSidebarRetailRouteRouteChildren: AppAuthedSidebarRetailRouteRouteChildren =
  {
    AppAuthedSidebarRetailCategoriesRoute:
      AppAuthedSidebarRetailCategoriesRoute,
    AppAuthedSidebarRetailContactRoute: AppAuthedSidebarRetailContactRoute,
    AppAuthedSidebarRetailGuideVideosRoute:
      AppAuthedSidebarRetailGuideVideosRoute,
    AppAuthedSidebarRetailHomeRoute: AppAuthedSidebarRetailHomeRoute,
    AppAuthedSidebarRetailMediaRoute: AppAuthedSidebarRetailMediaRoute,
    AppAuthedSidebarRetailMemberTiersRoute:
      AppAuthedSidebarRetailMemberTiersRoute,
    AppAuthedSidebarRetailOnlinePricesRoute:
      AppAuthedSidebarRetailOnlinePricesRoute,
    AppAuthedSidebarRetailPostCategoriesRoute:
      AppAuthedSidebarRetailPostCategoriesRoute,
    AppAuthedSidebarRetailSiteSettingsRoute:
      AppAuthedSidebarRetailSiteSettingsRoute,
    AppAuthedSidebarRetailAccountsAccountIdRoute:
      AppAuthedSidebarRetailAccountsAccountIdRoute,
    AppAuthedSidebarRetailGroupsGroupIdRoute:
      AppAuthedSidebarRetailGroupsGroupIdRoute,
    AppAuthedSidebarRetailGroupsNewRoute: AppAuthedSidebarRetailGroupsNewRoute,
    AppAuthedSidebarRetailPagesPageIdRoute:
      AppAuthedSidebarRetailPagesPageIdRoute,
    AppAuthedSidebarRetailPagesNewRoute: AppAuthedSidebarRetailPagesNewRoute,
    AppAuthedSidebarRetailPostsPostIdRoute:
      AppAuthedSidebarRetailPostsPostIdRoute,
    AppAuthedSidebarRetailPostsNewRoute: AppAuthedSidebarRetailPostsNewRoute,
    AppAuthedSidebarRetailAccountsIndexRoute:
      AppAuthedSidebarRetailAccountsIndexRoute,
    AppAuthedSidebarRetailGroupsIndexRoute:
      AppAuthedSidebarRetailGroupsIndexRoute,
    AppAuthedSidebarRetailPagesIndexRoute:
      AppAuthedSidebarRetailPagesIndexRoute,
    AppAuthedSidebarRetailPostsIndexRoute:
      AppAuthedSidebarRetailPostsIndexRoute,
  }

const AppAuthedSidebarRetailRouteRouteWithChildren =
  AppAuthedSidebarRetailRouteRoute._addFileChildren(
    AppAuthedSidebarRetailRouteRouteChildren,
  )

interface AppAuthedSidebarSettingsZaloRouteChildren {
  AppAuthedSidebarSettingsZaloMessagesRoute: typeof AppAuthedSidebarSettingsZaloMessagesRoute
  AppAuthedSidebarSettingsZaloPurposesRoute: typeof AppAuthedSidebarSettingsZaloPurposesRoute
  AppAuthedSidebarSettingsZaloIndexRoute: typeof AppAuthedSidebarSettingsZaloIndexRoute
  AppAuthedSidebarSettingsZaloTemplatesIdRoute: typeof AppAuthedSidebarSettingsZaloTemplatesIdRoute
  AppAuthedSidebarSettingsZaloTemplatesIndexRoute: typeof AppAuthedSidebarSettingsZaloTemplatesIndexRoute
}

const AppAuthedSidebarSettingsZaloRouteChildren: AppAuthedSidebarSettingsZaloRouteChildren =
  {
    AppAuthedSidebarSettingsZaloMessagesRoute:
      AppAuthedSidebarSettingsZaloMessagesRoute,
    AppAuthedSidebarSettingsZaloPurposesRoute:
      AppAuthedSidebarSettingsZaloPurposesRoute,
    AppAuthedSidebarSettingsZaloIndexRoute:
      AppAuthedSidebarSettingsZaloIndexRoute,
    AppAuthedSidebarSettingsZaloTemplatesIdRoute:
      AppAuthedSidebarSettingsZaloTemplatesIdRoute,
    AppAuthedSidebarSettingsZaloTemplatesIndexRoute:
      AppAuthedSidebarSettingsZaloTemplatesIndexRoute,
  }

const AppAuthedSidebarSettingsZaloRouteWithChildren =
  AppAuthedSidebarSettingsZaloRoute._addFileChildren(
    AppAuthedSidebarSettingsZaloRouteChildren,
  )

interface AppAuthedSidebarRouteChildren {
  AppAuthedSidebarAgricultureRouteRoute: typeof AppAuthedSidebarAgricultureRouteRouteWithChildren
  AppAuthedSidebarRetailRouteRoute: typeof AppAuthedSidebarRetailRouteRouteWithChildren
  AppAuthedSidebarDevPlaygroundRoute: typeof AppAuthedSidebarDevPlaygroundRoute
  AppAuthedSidebarKiotvietOrdersRoute: typeof AppAuthedSidebarKiotvietOrdersRoute
  AppAuthedSidebarTeaMachinesRoute: typeof AppAuthedSidebarTeaMachinesRoute
  AppAuthedSidebarTrackingRoute: typeof AppAuthedSidebarTrackingRoute
  AppAuthedSidebarWarehouseStatsRoute: typeof AppAuthedSidebarWarehouseStatsRoute
  AppAuthedSidebarWhatsNewRoute: typeof AppAuthedSidebarWhatsNewRoute
  AppAuthedSidebarIndexRoute: typeof AppAuthedSidebarIndexRoute
  AppAuthedSidebarAccountingCashFlowRoute: typeof AppAuthedSidebarAccountingCashFlowRoute
  AppAuthedSidebarAccountingExpenseCategoriesRoute: typeof AppAuthedSidebarAccountingExpenseCategoriesRoute
  AppAuthedSidebarAccountingExpenseRulesRoute: typeof AppAuthedSidebarAccountingExpenseRulesRoute
  AppAuthedSidebarAccountingExpenseSyncRoute: typeof AppAuthedSidebarAccountingExpenseSyncRoute
  AppAuthedSidebarAccountingExpensesRoute: typeof AppAuthedSidebarAccountingExpensesRoute
  AppAuthedSidebarAccountingGrowerPaymentsRoute: typeof AppAuthedSidebarAccountingGrowerPaymentsRoute
  AppAuthedSidebarAccountingReconciliationRoute: typeof AppAuthedSidebarAccountingReconciliationRoute
  AppAuthedSidebarAccountingRemittancesRoute: typeof AppAuthedSidebarAccountingRemittancesRoute
  AppAuthedSidebarAgriculturalMaterialsStatsRoute: typeof AppAuthedSidebarAgriculturalMaterialsStatsRoute
  AppAuthedSidebarContractDeliveriesIdRoute: typeof AppAuthedSidebarContractDeliveriesIdRoute
  AppAuthedSidebarContractDeliveriesNewRoute: typeof AppAuthedSidebarContractDeliveriesNewRoute
  AppAuthedSidebarCustomersCustomerIdRoute: typeof AppAuthedSidebarCustomersCustomerIdRoute
  AppAuthedSidebarCustomersNewRoute: typeof AppAuthedSidebarCustomersNewRoute
  AppAuthedSidebarDeliveryTripsIdRoute: typeof AppAuthedSidebarDeliveryTripsIdRoute
  AppAuthedSidebarDriedTeaPurchasesIdRoute: typeof AppAuthedSidebarDriedTeaPurchasesIdRoute
  AppAuthedSidebarDriverAvailableOrdersRoute: typeof AppAuthedSidebarDriverAvailableOrdersRoute
  AppAuthedSidebarDriverCashRoute: typeof AppAuthedSidebarDriverCashRoute
  AppAuthedSidebarLogisticsShippingCarriersRoute: typeof AppAuthedSidebarLogisticsShippingCarriersRoute
  AppAuthedSidebarLogisticsVtpOverdueRoute: typeof AppAuthedSidebarLogisticsVtpOverdueRoute
  AppAuthedSidebarOrdersOrderIdRoute: typeof AppAuthedSidebarOrdersOrderIdRoute
  AppAuthedSidebarOrdersNewRoute: typeof AppAuthedSidebarOrdersNewRoute
  AppAuthedSidebarOrdersQuickRoute: typeof AppAuthedSidebarOrdersQuickRoute
  AppAuthedSidebarPackagingWarehouseStatsRoute: typeof AppAuthedSidebarPackagingWarehouseStatsRoute
  AppAuthedSidebarProductsProductIdRoute: typeof AppAuthedSidebarProductsProductIdRoute
  AppAuthedSidebarProductsCategoriesRoute: typeof AppAuthedSidebarProductsCategoriesRoute
  AppAuthedSidebarProductsCertificationBadgesRoute: typeof AppAuthedSidebarProductsCertificationBadgesRoute
  AppAuthedSidebarProductsKiotvietMappingRoute: typeof AppAuthedSidebarProductsKiotvietMappingRoute
  AppAuthedSidebarProductsNewRoute: typeof AppAuthedSidebarProductsNewRoute
  AppAuthedSidebarProductsOnlinePricesRoute: typeof AppAuthedSidebarProductsOnlinePricesRoute
  AppAuthedSidebarReportsCareLogsRoute: typeof AppAuthedSidebarReportsCareLogsRoute
  AppAuthedSidebarReportsCashbookRoute: typeof AppAuthedSidebarReportsCashbookRoute
  AppAuthedSidebarReportsDebtsRoute: typeof AppAuthedSidebarReportsDebtsRoute
  AppAuthedSidebarReportsDeliveryRoute: typeof AppAuthedSidebarReportsDeliveryRoute
  AppAuthedSidebarReportsExpensesRoute: typeof AppAuthedSidebarReportsExpensesRoute
  AppAuthedSidebarReportsGeographyRoute: typeof AppAuthedSidebarReportsGeographyRoute
  AppAuthedSidebarReportsGrowersRoute: typeof AppAuthedSidebarReportsGrowersRoute
  AppAuthedSidebarReportsInventoryRoute: typeof AppAuthedSidebarReportsInventoryRoute
  AppAuthedSidebarReportsPositionsRoute: typeof AppAuthedSidebarReportsPositionsRoute
  AppAuthedSidebarReportsRevenueRoute: typeof AppAuthedSidebarReportsRevenueRoute
  AppAuthedSidebarReportsSalesRoute: typeof AppAuthedSidebarReportsSalesRoute
  AppAuthedSidebarReportsScentingStockRoute: typeof AppAuthedSidebarReportsScentingStockRoute
  AppAuthedSidebarReportsSortingStockRoute: typeof AppAuthedSidebarReportsSortingStockRoute
  AppAuthedSidebarReportsStaffRoute: typeof AppAuthedSidebarReportsStaffRoute
  AppAuthedSidebarReportsStockOutRoute: typeof AppAuthedSidebarReportsStockOutRoute
  AppAuthedSidebarReportsWebsiteRoute: typeof AppAuthedSidebarReportsWebsiteRoute
  AppAuthedSidebarReportsYieldLossRoute: typeof AppAuthedSidebarReportsYieldLossRoute
  AppAuthedSidebarReportsZaloMiniAppRoute: typeof AppAuthedSidebarReportsZaloMiniAppRoute
  AppAuthedSidebarScentingWarehouseGradesRoute: typeof AppAuthedSidebarScentingWarehouseGradesRoute
  AppAuthedSidebarScentingWarehouseStatsRoute: typeof AppAuthedSidebarScentingWarehouseStatsRoute
  AppAuthedSidebarSettingsFaceRecognitionRoute: typeof AppAuthedSidebarSettingsFaceRecognitionRoute
  AppAuthedSidebarSettingsInvoiceRoute: typeof AppAuthedSidebarSettingsInvoiceRoute
  AppAuthedSidebarSettingsLotSizesRoute: typeof AppAuthedSidebarSettingsLotSizesRoute
  AppAuthedSidebarSettingsNotificationsRoute: typeof AppAuthedSidebarSettingsNotificationsRoute
  AppAuthedSidebarSettingsPrintingRoute: typeof AppAuthedSidebarSettingsPrintingRoute
  AppAuthedSidebarSettingsProductionStationVoiceRoute: typeof AppAuthedSidebarSettingsProductionStationVoiceRoute
  AppAuthedSidebarSettingsSidebarLayoutRoute: typeof AppAuthedSidebarSettingsSidebarLayoutRoute
  AppAuthedSidebarSettingsSlaRoute: typeof AppAuthedSidebarSettingsSlaRoute
  AppAuthedSidebarSettingsStationVoiceRoute: typeof AppAuthedSidebarSettingsStationVoiceRoute
  AppAuthedSidebarSettingsWarehouseStationVoiceRoute: typeof AppAuthedSidebarSettingsWarehouseStationVoiceRoute
  AppAuthedSidebarSettingsZaloRoute: typeof AppAuthedSidebarSettingsZaloRouteWithChildren
  AppAuthedSidebarSortingWarehouseStatsRoute: typeof AppAuthedSidebarSortingWarehouseStatsRoute
  AppAuthedSidebarSortingWarehouseTeaGradesRoute: typeof AppAuthedSidebarSortingWarehouseTeaGradesRoute
  AppAuthedSidebarStocktakeIdRoute: typeof AppAuthedSidebarStocktakeIdRoute
  AppAuthedSidebarStocktakeNewRoute: typeof AppAuthedSidebarStocktakeNewRoute
  AppAuthedSidebarTeaPurchasesIdRoute: typeof AppAuthedSidebarTeaPurchasesIdRoute
  AppAuthedSidebarTeaPurchasesProcessingRoute: typeof AppAuthedSidebarTeaPurchasesProcessingRoute
  AppAuthedSidebarVehiclesVehicleIdRoute: typeof AppAuthedSidebarVehiclesVehicleIdRoute
  AppAuthedSidebarWarehousePositionsIdRoute: typeof AppAuthedSidebarWarehousePositionsIdRoute
  AppAuthedSidebarWarehousePositionsNewRoute: typeof AppAuthedSidebarWarehousePositionsNewRoute
  AppAuthedSidebarWarehouseSalesDashboardRoute: typeof AppAuthedSidebarWarehouseSalesDashboardRoute
  AppAuthedSidebarWarehouseSalesDefectsRoute: typeof AppAuthedSidebarWarehouseSalesDefectsRoute
  AppAuthedSidebarWarehouseSalesStatsRoute: typeof AppAuthedSidebarWarehouseSalesStatsRoute
  AppAuthedSidebarWorkActivitiesBoardRoute: typeof AppAuthedSidebarWorkActivitiesBoardRoute
  AppAuthedSidebarWorkActivitiesCalendarRoute: typeof AppAuthedSidebarWorkActivitiesCalendarRoute
  AppAuthedSidebarWorkActivitiesGuestsRoute: typeof AppAuthedSidebarWorkActivitiesGuestsRoute
  AppAuthedSidebarAccountingIndexRoute: typeof AppAuthedSidebarAccountingIndexRoute
  AppAuthedSidebarAgriculturalMaterialsIndexRoute: typeof AppAuthedSidebarAgriculturalMaterialsIndexRoute
  AppAuthedSidebarApiKeysIndexRoute: typeof AppAuthedSidebarApiKeysIndexRoute
  AppAuthedSidebarContractDeliveriesIndexRoute: typeof AppAuthedSidebarContractDeliveriesIndexRoute
  AppAuthedSidebarCustomersIndexRoute: typeof AppAuthedSidebarCustomersIndexRoute
  AppAuthedSidebarDeliveryTripsIndexRoute: typeof AppAuthedSidebarDeliveryTripsIndexRoute
  AppAuthedSidebarDriedTeaPurchasesIndexRoute: typeof AppAuthedSidebarDriedTeaPurchasesIndexRoute
  AppAuthedSidebarOrdersIndexRoute: typeof AppAuthedSidebarOrdersIndexRoute
  AppAuthedSidebarPackagingIndexRoute: typeof AppAuthedSidebarPackagingIndexRoute
  AppAuthedSidebarProductsIndexRoute: typeof AppAuthedSidebarProductsIndexRoute
  AppAuthedSidebarReportsIndexRoute: typeof AppAuthedSidebarReportsIndexRoute
  AppAuthedSidebarSmartlabIndexRoute: typeof AppAuthedSidebarSmartlabIndexRoute
  AppAuthedSidebarStocktakeIndexRoute: typeof AppAuthedSidebarStocktakeIndexRoute
  AppAuthedSidebarTeaPurchasesIndexRoute: typeof AppAuthedSidebarTeaPurchasesIndexRoute
  AppAuthedSidebarUsersIndexRoute: typeof AppAuthedSidebarUsersIndexRoute
  AppAuthedSidebarVehiclesIndexRoute: typeof AppAuthedSidebarVehiclesIndexRoute
  AppAuthedSidebarWarehousePositionsIndexRoute: typeof AppAuthedSidebarWarehousePositionsIndexRoute
  AppAuthedSidebarAccountingReportsDailyRoute: typeof AppAuthedSidebarAccountingReportsDailyRoute
  AppAuthedSidebarAgriculturalMaterialsLotsIdRoute: typeof AppAuthedSidebarAgriculturalMaterialsLotsIdRoute
  AppAuthedSidebarAgriculturalMaterialsStockInNotesIdRoute: typeof AppAuthedSidebarAgriculturalMaterialsStockInNotesIdRoute
  AppAuthedSidebarAgriculturalMaterialsStockInNotesNewRoute: typeof AppAuthedSidebarAgriculturalMaterialsStockInNotesNewRoute
  AppAuthedSidebarAgriculturalMaterialsStockOutNotesIdRoute: typeof AppAuthedSidebarAgriculturalMaterialsStockOutNotesIdRoute
  AppAuthedSidebarAgriculturalMaterialsStockOutNotesNewRoute: typeof AppAuthedSidebarAgriculturalMaterialsStockOutNotesNewRoute
  AppAuthedSidebarCustomersGroupsGroupIdRoute: typeof AppAuthedSidebarCustomersGroupsGroupIdRoute
  AppAuthedSidebarPackagingWarehouseLotsIdRoute: typeof AppAuthedSidebarPackagingWarehouseLotsIdRoute
  AppAuthedSidebarPackagingWarehouseStockInNotesIdRoute: typeof AppAuthedSidebarPackagingWarehouseStockInNotesIdRoute
  AppAuthedSidebarPackagingWarehouseStockInNotesNewRoute: typeof AppAuthedSidebarPackagingWarehouseStockInNotesNewRoute
  AppAuthedSidebarPackagingWarehouseStockOutNotesIdRoute: typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIdRoute
  AppAuthedSidebarPackagingWarehouseStockOutNotesNewRoute: typeof AppAuthedSidebarPackagingWarehouseStockOutNotesNewRoute
  AppAuthedSidebarPackagingWarehouseWithdrawalNotesIdRoute: typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesIdRoute
  AppAuthedSidebarPackagingWarehouseWithdrawalNotesNewRoute: typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesNewRoute
  AppAuthedSidebarSalesWarehouseLotsIdRoute: typeof AppAuthedSidebarSalesWarehouseLotsIdRoute
  AppAuthedSidebarSalesWarehouseStockInNotesIdRoute: typeof AppAuthedSidebarSalesWarehouseStockInNotesIdRoute
  AppAuthedSidebarSalesWarehouseStockInNotesNewRoute: typeof AppAuthedSidebarSalesWarehouseStockInNotesNewRoute
  AppAuthedSidebarSalesWarehouseStockInNotesQuickRoute: typeof AppAuthedSidebarSalesWarehouseStockInNotesQuickRoute
  AppAuthedSidebarSalesWarehouseStockOutNotesIdRoute: typeof AppAuthedSidebarSalesWarehouseStockOutNotesIdRoute
  AppAuthedSidebarSalesWarehouseStockOutNotesNewRoute: typeof AppAuthedSidebarSalesWarehouseStockOutNotesNewRoute
  AppAuthedSidebarSalesWarehouseTransferNotesIdRoute: typeof AppAuthedSidebarSalesWarehouseTransferNotesIdRoute
  AppAuthedSidebarSalesWarehouseTransferNotesNewRoute: typeof AppAuthedSidebarSalesWarehouseTransferNotesNewRoute
  AppAuthedSidebarScentingWarehouseLotsIdRoute: typeof AppAuthedSidebarScentingWarehouseLotsIdRoute
  AppAuthedSidebarScentingWarehouseStockInNotesIdRoute: typeof AppAuthedSidebarScentingWarehouseStockInNotesIdRoute
  AppAuthedSidebarScentingWarehouseStockInNotesNewRoute: typeof AppAuthedSidebarScentingWarehouseStockInNotesNewRoute
  AppAuthedSidebarScentingWarehouseStockOutNotesIdRoute: typeof AppAuthedSidebarScentingWarehouseStockOutNotesIdRoute
  AppAuthedSidebarScentingWarehouseStockOutNotesNewRoute: typeof AppAuthedSidebarScentingWarehouseStockOutNotesNewRoute
  AppAuthedSidebarScentingWarehouseWithdrawalNotesIdRoute: typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesIdRoute
  AppAuthedSidebarScentingWarehouseWithdrawalNotesNewRoute: typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesNewRoute
  AppAuthedSidebarSettingsRolesIdRoute: typeof AppAuthedSidebarSettingsRolesIdRoute
  AppAuthedSidebarSortingWarehouseLotsIdRoute: typeof AppAuthedSidebarSortingWarehouseLotsIdRoute
  AppAuthedSidebarSortingWarehouseStockInNotesIdRoute: typeof AppAuthedSidebarSortingWarehouseStockInNotesIdRoute
  AppAuthedSidebarSortingWarehouseStockInNotesNewRoute: typeof AppAuthedSidebarSortingWarehouseStockInNotesNewRoute
  AppAuthedSidebarSortingWarehouseStockOutNotesIdRoute: typeof AppAuthedSidebarSortingWarehouseStockOutNotesIdRoute
  AppAuthedSidebarSortingWarehouseStockOutNotesNewRoute: typeof AppAuthedSidebarSortingWarehouseStockOutNotesNewRoute
  AppAuthedSidebarSortingWarehouseWithdrawalNotesIdRoute: typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesIdRoute
  AppAuthedSidebarSortingWarehouseWithdrawalNotesNewRoute: typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesNewRoute
  AppAuthedSidebarAgriculturalMaterialsLotsIndexRoute: typeof AppAuthedSidebarAgriculturalMaterialsLotsIndexRoute
  AppAuthedSidebarAgriculturalMaterialsStockInNotesIndexRoute: typeof AppAuthedSidebarAgriculturalMaterialsStockInNotesIndexRoute
  AppAuthedSidebarAgriculturalMaterialsStockOutNotesIndexRoute: typeof AppAuthedSidebarAgriculturalMaterialsStockOutNotesIndexRoute
  AppAuthedSidebarCustomersGroupsIndexRoute: typeof AppAuthedSidebarCustomersGroupsIndexRoute
  AppAuthedSidebarOrganizationDepartmentsIndexRoute: typeof AppAuthedSidebarOrganizationDepartmentsIndexRoute
  AppAuthedSidebarOrganizationEmployeesIndexRoute: typeof AppAuthedSidebarOrganizationEmployeesIndexRoute
  AppAuthedSidebarPackagingWarehouseCountLogIndexRoute: typeof AppAuthedSidebarPackagingWarehouseCountLogIndexRoute
  AppAuthedSidebarPackagingWarehouseLotsIndexRoute: typeof AppAuthedSidebarPackagingWarehouseLotsIndexRoute
  AppAuthedSidebarPackagingWarehouseStockInNotesIndexRoute: typeof AppAuthedSidebarPackagingWarehouseStockInNotesIndexRoute
  AppAuthedSidebarPackagingWarehouseStockOutNotesIndexRoute: typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIndexRoute
  AppAuthedSidebarPackagingWarehouseWithdrawalNotesIndexRoute: typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesIndexRoute
  AppAuthedSidebarSalesWarehouseBoxLogIndexRoute: typeof AppAuthedSidebarSalesWarehouseBoxLogIndexRoute
  AppAuthedSidebarSalesWarehouseLotsIndexRoute: typeof AppAuthedSidebarSalesWarehouseLotsIndexRoute
  AppAuthedSidebarSalesWarehouseOtherLogIndexRoute: typeof AppAuthedSidebarSalesWarehouseOtherLogIndexRoute
  AppAuthedSidebarSalesWarehousePackagingLogIndexRoute: typeof AppAuthedSidebarSalesWarehousePackagingLogIndexRoute
  AppAuthedSidebarSalesWarehouseStockInNotesIndexRoute: typeof AppAuthedSidebarSalesWarehouseStockInNotesIndexRoute
  AppAuthedSidebarSalesWarehouseStockOutNotesIndexRoute: typeof AppAuthedSidebarSalesWarehouseStockOutNotesIndexRoute
  AppAuthedSidebarSalesWarehouseTransferNotesIndexRoute: typeof AppAuthedSidebarSalesWarehouseTransferNotesIndexRoute
  AppAuthedSidebarScentingWarehouseLogIndexRoute: typeof AppAuthedSidebarScentingWarehouseLogIndexRoute
  AppAuthedSidebarScentingWarehouseLotsIndexRoute: typeof AppAuthedSidebarScentingWarehouseLotsIndexRoute
  AppAuthedSidebarScentingWarehouseStockInNotesIndexRoute: typeof AppAuthedSidebarScentingWarehouseStockInNotesIndexRoute
  AppAuthedSidebarScentingWarehouseStockOutNotesIndexRoute: typeof AppAuthedSidebarScentingWarehouseStockOutNotesIndexRoute
  AppAuthedSidebarScentingWarehouseWithdrawalNotesIndexRoute: typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesIndexRoute
  AppAuthedSidebarSettingsRolesIndexRoute: typeof AppAuthedSidebarSettingsRolesIndexRoute
  AppAuthedSidebarSortingWarehouseLotsIndexRoute: typeof AppAuthedSidebarSortingWarehouseLotsIndexRoute
  AppAuthedSidebarSortingWarehouseStockInNotesIndexRoute: typeof AppAuthedSidebarSortingWarehouseStockInNotesIndexRoute
  AppAuthedSidebarSortingWarehouseStockOutNotesIndexRoute: typeof AppAuthedSidebarSortingWarehouseStockOutNotesIndexRoute
  AppAuthedSidebarSortingWarehouseWithdrawalNotesIndexRoute: typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesIndexRoute
  AppAuthedSidebarAgriculturalMaterialsStockInNotesIdEditRoute: typeof AppAuthedSidebarAgriculturalMaterialsStockInNotesIdEditRoute
  AppAuthedSidebarAgriculturalMaterialsStockOutNotesIdEditRoute: typeof AppAuthedSidebarAgriculturalMaterialsStockOutNotesIdEditRoute
  AppAuthedSidebarPackagingWarehouseStockInNotesIdEditRoute: typeof AppAuthedSidebarPackagingWarehouseStockInNotesIdEditRoute
  AppAuthedSidebarPackagingWarehouseStockOutNotesIdEditRoute: typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIdEditRoute
  AppAuthedSidebarSalesWarehouseStockInNotesIdEditRoute: typeof AppAuthedSidebarSalesWarehouseStockInNotesIdEditRoute
  AppAuthedSidebarSalesWarehouseStockOutNotesIdEditRoute: typeof AppAuthedSidebarSalesWarehouseStockOutNotesIdEditRoute
  AppAuthedSidebarSalesWarehouseTransferNotesIdEditRoute: typeof AppAuthedSidebarSalesWarehouseTransferNotesIdEditRoute
  AppAuthedSidebarScentingWarehouseStockInNotesIdEditRoute: typeof AppAuthedSidebarScentingWarehouseStockInNotesIdEditRoute
  AppAuthedSidebarScentingWarehouseStockOutNotesIdEditRoute: typeof AppAuthedSidebarScentingWarehouseStockOutNotesIdEditRoute
  AppAuthedSidebarSortingWarehouseStockInNotesIdEditRoute: typeof AppAuthedSidebarSortingWarehouseStockInNotesIdEditRoute
  AppAuthedSidebarSortingWarehouseStockOutNotesIdEditRoute: typeof AppAuthedSidebarSortingWarehouseStockOutNotesIdEditRoute
}

const AppAuthedSidebarRouteChildren: AppAuthedSidebarRouteChildren = {
  AppAuthedSidebarAgricultureRouteRoute:
    AppAuthedSidebarAgricultureRouteRouteWithChildren,
  AppAuthedSidebarRetailRouteRoute:
    AppAuthedSidebarRetailRouteRouteWithChildren,
  AppAuthedSidebarDevPlaygroundRoute: AppAuthedSidebarDevPlaygroundRoute,
  AppAuthedSidebarKiotvietOrdersRoute: AppAuthedSidebarKiotvietOrdersRoute,
  AppAuthedSidebarTeaMachinesRoute: AppAuthedSidebarTeaMachinesRoute,
  AppAuthedSidebarTrackingRoute: AppAuthedSidebarTrackingRoute,
  AppAuthedSidebarWarehouseStatsRoute: AppAuthedSidebarWarehouseStatsRoute,
  AppAuthedSidebarWhatsNewRoute: AppAuthedSidebarWhatsNewRoute,
  AppAuthedSidebarIndexRoute: AppAuthedSidebarIndexRoute,
  AppAuthedSidebarAccountingCashFlowRoute:
    AppAuthedSidebarAccountingCashFlowRoute,
  AppAuthedSidebarAccountingExpenseCategoriesRoute:
    AppAuthedSidebarAccountingExpenseCategoriesRoute,
  AppAuthedSidebarAccountingExpenseRulesRoute:
    AppAuthedSidebarAccountingExpenseRulesRoute,
  AppAuthedSidebarAccountingExpenseSyncRoute:
    AppAuthedSidebarAccountingExpenseSyncRoute,
  AppAuthedSidebarAccountingExpensesRoute:
    AppAuthedSidebarAccountingExpensesRoute,
  AppAuthedSidebarAccountingGrowerPaymentsRoute:
    AppAuthedSidebarAccountingGrowerPaymentsRoute,
  AppAuthedSidebarAccountingReconciliationRoute:
    AppAuthedSidebarAccountingReconciliationRoute,
  AppAuthedSidebarAccountingRemittancesRoute:
    AppAuthedSidebarAccountingRemittancesRoute,
  AppAuthedSidebarAgriculturalMaterialsStatsRoute:
    AppAuthedSidebarAgriculturalMaterialsStatsRoute,
  AppAuthedSidebarContractDeliveriesIdRoute:
    AppAuthedSidebarContractDeliveriesIdRoute,
  AppAuthedSidebarContractDeliveriesNewRoute:
    AppAuthedSidebarContractDeliveriesNewRoute,
  AppAuthedSidebarCustomersCustomerIdRoute:
    AppAuthedSidebarCustomersCustomerIdRoute,
  AppAuthedSidebarCustomersNewRoute: AppAuthedSidebarCustomersNewRoute,
  AppAuthedSidebarDeliveryTripsIdRoute: AppAuthedSidebarDeliveryTripsIdRoute,
  AppAuthedSidebarDriedTeaPurchasesIdRoute:
    AppAuthedSidebarDriedTeaPurchasesIdRoute,
  AppAuthedSidebarDriverAvailableOrdersRoute:
    AppAuthedSidebarDriverAvailableOrdersRoute,
  AppAuthedSidebarDriverCashRoute: AppAuthedSidebarDriverCashRoute,
  AppAuthedSidebarLogisticsShippingCarriersRoute:
    AppAuthedSidebarLogisticsShippingCarriersRoute,
  AppAuthedSidebarLogisticsVtpOverdueRoute:
    AppAuthedSidebarLogisticsVtpOverdueRoute,
  AppAuthedSidebarOrdersOrderIdRoute: AppAuthedSidebarOrdersOrderIdRoute,
  AppAuthedSidebarOrdersNewRoute: AppAuthedSidebarOrdersNewRoute,
  AppAuthedSidebarOrdersQuickRoute: AppAuthedSidebarOrdersQuickRoute,
  AppAuthedSidebarPackagingWarehouseStatsRoute:
    AppAuthedSidebarPackagingWarehouseStatsRoute,
  AppAuthedSidebarProductsProductIdRoute:
    AppAuthedSidebarProductsProductIdRoute,
  AppAuthedSidebarProductsCategoriesRoute:
    AppAuthedSidebarProductsCategoriesRoute,
  AppAuthedSidebarProductsCertificationBadgesRoute:
    AppAuthedSidebarProductsCertificationBadgesRoute,
  AppAuthedSidebarProductsKiotvietMappingRoute:
    AppAuthedSidebarProductsKiotvietMappingRoute,
  AppAuthedSidebarProductsNewRoute: AppAuthedSidebarProductsNewRoute,
  AppAuthedSidebarProductsOnlinePricesRoute:
    AppAuthedSidebarProductsOnlinePricesRoute,
  AppAuthedSidebarReportsCareLogsRoute: AppAuthedSidebarReportsCareLogsRoute,
  AppAuthedSidebarReportsCashbookRoute: AppAuthedSidebarReportsCashbookRoute,
  AppAuthedSidebarReportsDebtsRoute: AppAuthedSidebarReportsDebtsRoute,
  AppAuthedSidebarReportsDeliveryRoute: AppAuthedSidebarReportsDeliveryRoute,
  AppAuthedSidebarReportsExpensesRoute: AppAuthedSidebarReportsExpensesRoute,
  AppAuthedSidebarReportsGeographyRoute: AppAuthedSidebarReportsGeographyRoute,
  AppAuthedSidebarReportsGrowersRoute: AppAuthedSidebarReportsGrowersRoute,
  AppAuthedSidebarReportsInventoryRoute: AppAuthedSidebarReportsInventoryRoute,
  AppAuthedSidebarReportsPositionsRoute: AppAuthedSidebarReportsPositionsRoute,
  AppAuthedSidebarReportsRevenueRoute: AppAuthedSidebarReportsRevenueRoute,
  AppAuthedSidebarReportsSalesRoute: AppAuthedSidebarReportsSalesRoute,
  AppAuthedSidebarReportsScentingStockRoute:
    AppAuthedSidebarReportsScentingStockRoute,
  AppAuthedSidebarReportsSortingStockRoute:
    AppAuthedSidebarReportsSortingStockRoute,
  AppAuthedSidebarReportsStaffRoute: AppAuthedSidebarReportsStaffRoute,
  AppAuthedSidebarReportsStockOutRoute: AppAuthedSidebarReportsStockOutRoute,
  AppAuthedSidebarReportsWebsiteRoute: AppAuthedSidebarReportsWebsiteRoute,
  AppAuthedSidebarReportsYieldLossRoute: AppAuthedSidebarReportsYieldLossRoute,
  AppAuthedSidebarReportsZaloMiniAppRoute:
    AppAuthedSidebarReportsZaloMiniAppRoute,
  AppAuthedSidebarScentingWarehouseGradesRoute:
    AppAuthedSidebarScentingWarehouseGradesRoute,
  AppAuthedSidebarScentingWarehouseStatsRoute:
    AppAuthedSidebarScentingWarehouseStatsRoute,
  AppAuthedSidebarSettingsFaceRecognitionRoute:
    AppAuthedSidebarSettingsFaceRecognitionRoute,
  AppAuthedSidebarSettingsInvoiceRoute: AppAuthedSidebarSettingsInvoiceRoute,
  AppAuthedSidebarSettingsLotSizesRoute: AppAuthedSidebarSettingsLotSizesRoute,
  AppAuthedSidebarSettingsNotificationsRoute:
    AppAuthedSidebarSettingsNotificationsRoute,
  AppAuthedSidebarSettingsPrintingRoute: AppAuthedSidebarSettingsPrintingRoute,
  AppAuthedSidebarSettingsProductionStationVoiceRoute:
    AppAuthedSidebarSettingsProductionStationVoiceRoute,
  AppAuthedSidebarSettingsSidebarLayoutRoute:
    AppAuthedSidebarSettingsSidebarLayoutRoute,
  AppAuthedSidebarSettingsSlaRoute: AppAuthedSidebarSettingsSlaRoute,
  AppAuthedSidebarSettingsStationVoiceRoute:
    AppAuthedSidebarSettingsStationVoiceRoute,
  AppAuthedSidebarSettingsWarehouseStationVoiceRoute:
    AppAuthedSidebarSettingsWarehouseStationVoiceRoute,
  AppAuthedSidebarSettingsZaloRoute:
    AppAuthedSidebarSettingsZaloRouteWithChildren,
  AppAuthedSidebarSortingWarehouseStatsRoute:
    AppAuthedSidebarSortingWarehouseStatsRoute,
  AppAuthedSidebarSortingWarehouseTeaGradesRoute:
    AppAuthedSidebarSortingWarehouseTeaGradesRoute,
  AppAuthedSidebarStocktakeIdRoute: AppAuthedSidebarStocktakeIdRoute,
  AppAuthedSidebarStocktakeNewRoute: AppAuthedSidebarStocktakeNewRoute,
  AppAuthedSidebarTeaPurchasesIdRoute: AppAuthedSidebarTeaPurchasesIdRoute,
  AppAuthedSidebarTeaPurchasesProcessingRoute:
    AppAuthedSidebarTeaPurchasesProcessingRoute,
  AppAuthedSidebarVehiclesVehicleIdRoute:
    AppAuthedSidebarVehiclesVehicleIdRoute,
  AppAuthedSidebarWarehousePositionsIdRoute:
    AppAuthedSidebarWarehousePositionsIdRoute,
  AppAuthedSidebarWarehousePositionsNewRoute:
    AppAuthedSidebarWarehousePositionsNewRoute,
  AppAuthedSidebarWarehouseSalesDashboardRoute:
    AppAuthedSidebarWarehouseSalesDashboardRoute,
  AppAuthedSidebarWarehouseSalesDefectsRoute:
    AppAuthedSidebarWarehouseSalesDefectsRoute,
  AppAuthedSidebarWarehouseSalesStatsRoute:
    AppAuthedSidebarWarehouseSalesStatsRoute,
  AppAuthedSidebarWorkActivitiesBoardRoute:
    AppAuthedSidebarWorkActivitiesBoardRoute,
  AppAuthedSidebarWorkActivitiesCalendarRoute:
    AppAuthedSidebarWorkActivitiesCalendarRoute,
  AppAuthedSidebarWorkActivitiesGuestsRoute:
    AppAuthedSidebarWorkActivitiesGuestsRoute,
  AppAuthedSidebarAccountingIndexRoute: AppAuthedSidebarAccountingIndexRoute,
  AppAuthedSidebarAgriculturalMaterialsIndexRoute:
    AppAuthedSidebarAgriculturalMaterialsIndexRoute,
  AppAuthedSidebarApiKeysIndexRoute: AppAuthedSidebarApiKeysIndexRoute,
  AppAuthedSidebarContractDeliveriesIndexRoute:
    AppAuthedSidebarContractDeliveriesIndexRoute,
  AppAuthedSidebarCustomersIndexRoute: AppAuthedSidebarCustomersIndexRoute,
  AppAuthedSidebarDeliveryTripsIndexRoute:
    AppAuthedSidebarDeliveryTripsIndexRoute,
  AppAuthedSidebarDriedTeaPurchasesIndexRoute:
    AppAuthedSidebarDriedTeaPurchasesIndexRoute,
  AppAuthedSidebarOrdersIndexRoute: AppAuthedSidebarOrdersIndexRoute,
  AppAuthedSidebarPackagingIndexRoute: AppAuthedSidebarPackagingIndexRoute,
  AppAuthedSidebarProductsIndexRoute: AppAuthedSidebarProductsIndexRoute,
  AppAuthedSidebarReportsIndexRoute: AppAuthedSidebarReportsIndexRoute,
  AppAuthedSidebarSmartlabIndexRoute: AppAuthedSidebarSmartlabIndexRoute,
  AppAuthedSidebarStocktakeIndexRoute: AppAuthedSidebarStocktakeIndexRoute,
  AppAuthedSidebarTeaPurchasesIndexRoute:
    AppAuthedSidebarTeaPurchasesIndexRoute,
  AppAuthedSidebarUsersIndexRoute: AppAuthedSidebarUsersIndexRoute,
  AppAuthedSidebarVehiclesIndexRoute: AppAuthedSidebarVehiclesIndexRoute,
  AppAuthedSidebarWarehousePositionsIndexRoute:
    AppAuthedSidebarWarehousePositionsIndexRoute,
  AppAuthedSidebarAccountingReportsDailyRoute:
    AppAuthedSidebarAccountingReportsDailyRoute,
  AppAuthedSidebarAgriculturalMaterialsLotsIdRoute:
    AppAuthedSidebarAgriculturalMaterialsLotsIdRoute,
  AppAuthedSidebarAgriculturalMaterialsStockInNotesIdRoute:
    AppAuthedSidebarAgriculturalMaterialsStockInNotesIdRoute,
  AppAuthedSidebarAgriculturalMaterialsStockInNotesNewRoute:
    AppAuthedSidebarAgriculturalMaterialsStockInNotesNewRoute,
  AppAuthedSidebarAgriculturalMaterialsStockOutNotesIdRoute:
    AppAuthedSidebarAgriculturalMaterialsStockOutNotesIdRoute,
  AppAuthedSidebarAgriculturalMaterialsStockOutNotesNewRoute:
    AppAuthedSidebarAgriculturalMaterialsStockOutNotesNewRoute,
  AppAuthedSidebarCustomersGroupsGroupIdRoute:
    AppAuthedSidebarCustomersGroupsGroupIdRoute,
  AppAuthedSidebarPackagingWarehouseLotsIdRoute:
    AppAuthedSidebarPackagingWarehouseLotsIdRoute,
  AppAuthedSidebarPackagingWarehouseStockInNotesIdRoute:
    AppAuthedSidebarPackagingWarehouseStockInNotesIdRoute,
  AppAuthedSidebarPackagingWarehouseStockInNotesNewRoute:
    AppAuthedSidebarPackagingWarehouseStockInNotesNewRoute,
  AppAuthedSidebarPackagingWarehouseStockOutNotesIdRoute:
    AppAuthedSidebarPackagingWarehouseStockOutNotesIdRoute,
  AppAuthedSidebarPackagingWarehouseStockOutNotesNewRoute:
    AppAuthedSidebarPackagingWarehouseStockOutNotesNewRoute,
  AppAuthedSidebarPackagingWarehouseWithdrawalNotesIdRoute:
    AppAuthedSidebarPackagingWarehouseWithdrawalNotesIdRoute,
  AppAuthedSidebarPackagingWarehouseWithdrawalNotesNewRoute:
    AppAuthedSidebarPackagingWarehouseWithdrawalNotesNewRoute,
  AppAuthedSidebarSalesWarehouseLotsIdRoute:
    AppAuthedSidebarSalesWarehouseLotsIdRoute,
  AppAuthedSidebarSalesWarehouseStockInNotesIdRoute:
    AppAuthedSidebarSalesWarehouseStockInNotesIdRoute,
  AppAuthedSidebarSalesWarehouseStockInNotesNewRoute:
    AppAuthedSidebarSalesWarehouseStockInNotesNewRoute,
  AppAuthedSidebarSalesWarehouseStockInNotesQuickRoute:
    AppAuthedSidebarSalesWarehouseStockInNotesQuickRoute,
  AppAuthedSidebarSalesWarehouseStockOutNotesIdRoute:
    AppAuthedSidebarSalesWarehouseStockOutNotesIdRoute,
  AppAuthedSidebarSalesWarehouseStockOutNotesNewRoute:
    AppAuthedSidebarSalesWarehouseStockOutNotesNewRoute,
  AppAuthedSidebarSalesWarehouseTransferNotesIdRoute:
    AppAuthedSidebarSalesWarehouseTransferNotesIdRoute,
  AppAuthedSidebarSalesWarehouseTransferNotesNewRoute:
    AppAuthedSidebarSalesWarehouseTransferNotesNewRoute,
  AppAuthedSidebarScentingWarehouseLotsIdRoute:
    AppAuthedSidebarScentingWarehouseLotsIdRoute,
  AppAuthedSidebarScentingWarehouseStockInNotesIdRoute:
    AppAuthedSidebarScentingWarehouseStockInNotesIdRoute,
  AppAuthedSidebarScentingWarehouseStockInNotesNewRoute:
    AppAuthedSidebarScentingWarehouseStockInNotesNewRoute,
  AppAuthedSidebarScentingWarehouseStockOutNotesIdRoute:
    AppAuthedSidebarScentingWarehouseStockOutNotesIdRoute,
  AppAuthedSidebarScentingWarehouseStockOutNotesNewRoute:
    AppAuthedSidebarScentingWarehouseStockOutNotesNewRoute,
  AppAuthedSidebarScentingWarehouseWithdrawalNotesIdRoute:
    AppAuthedSidebarScentingWarehouseWithdrawalNotesIdRoute,
  AppAuthedSidebarScentingWarehouseWithdrawalNotesNewRoute:
    AppAuthedSidebarScentingWarehouseWithdrawalNotesNewRoute,
  AppAuthedSidebarSettingsRolesIdRoute: AppAuthedSidebarSettingsRolesIdRoute,
  AppAuthedSidebarSortingWarehouseLotsIdRoute:
    AppAuthedSidebarSortingWarehouseLotsIdRoute,
  AppAuthedSidebarSortingWarehouseStockInNotesIdRoute:
    AppAuthedSidebarSortingWarehouseStockInNotesIdRoute,
  AppAuthedSidebarSortingWarehouseStockInNotesNewRoute:
    AppAuthedSidebarSortingWarehouseStockInNotesNewRoute,
  AppAuthedSidebarSortingWarehouseStockOutNotesIdRoute:
    AppAuthedSidebarSortingWarehouseStockOutNotesIdRoute,
  AppAuthedSidebarSortingWarehouseStockOutNotesNewRoute:
    AppAuthedSidebarSortingWarehouseStockOutNotesNewRoute,
  AppAuthedSidebarSortingWarehouseWithdrawalNotesIdRoute:
    AppAuthedSidebarSortingWarehouseWithdrawalNotesIdRoute,
  AppAuthedSidebarSortingWarehouseWithdrawalNotesNewRoute:
    AppAuthedSidebarSortingWarehouseWithdrawalNotesNewRoute,
  AppAuthedSidebarAgriculturalMaterialsLotsIndexRoute:
    AppAuthedSidebarAgriculturalMaterialsLotsIndexRoute,
  AppAuthedSidebarAgriculturalMaterialsStockInNotesIndexRoute:
    AppAuthedSidebarAgriculturalMaterialsStockInNotesIndexRoute,
  AppAuthedSidebarAgriculturalMaterialsStockOutNotesIndexRoute:
    AppAuthedSidebarAgriculturalMaterialsStockOutNotesIndexRoute,
  AppAuthedSidebarCustomersGroupsIndexRoute:
    AppAuthedSidebarCustomersGroupsIndexRoute,
  AppAuthedSidebarOrganizationDepartmentsIndexRoute:
    AppAuthedSidebarOrganizationDepartmentsIndexRoute,
  AppAuthedSidebarOrganizationEmployeesIndexRoute:
    AppAuthedSidebarOrganizationEmployeesIndexRoute,
  AppAuthedSidebarPackagingWarehouseCountLogIndexRoute:
    AppAuthedSidebarPackagingWarehouseCountLogIndexRoute,
  AppAuthedSidebarPackagingWarehouseLotsIndexRoute:
    AppAuthedSidebarPackagingWarehouseLotsIndexRoute,
  AppAuthedSidebarPackagingWarehouseStockInNotesIndexRoute:
    AppAuthedSidebarPackagingWarehouseStockInNotesIndexRoute,
  AppAuthedSidebarPackagingWarehouseStockOutNotesIndexRoute:
    AppAuthedSidebarPackagingWarehouseStockOutNotesIndexRoute,
  AppAuthedSidebarPackagingWarehouseWithdrawalNotesIndexRoute:
    AppAuthedSidebarPackagingWarehouseWithdrawalNotesIndexRoute,
  AppAuthedSidebarSalesWarehouseBoxLogIndexRoute:
    AppAuthedSidebarSalesWarehouseBoxLogIndexRoute,
  AppAuthedSidebarSalesWarehouseLotsIndexRoute:
    AppAuthedSidebarSalesWarehouseLotsIndexRoute,
  AppAuthedSidebarSalesWarehouseOtherLogIndexRoute:
    AppAuthedSidebarSalesWarehouseOtherLogIndexRoute,
  AppAuthedSidebarSalesWarehousePackagingLogIndexRoute:
    AppAuthedSidebarSalesWarehousePackagingLogIndexRoute,
  AppAuthedSidebarSalesWarehouseStockInNotesIndexRoute:
    AppAuthedSidebarSalesWarehouseStockInNotesIndexRoute,
  AppAuthedSidebarSalesWarehouseStockOutNotesIndexRoute:
    AppAuthedSidebarSalesWarehouseStockOutNotesIndexRoute,
  AppAuthedSidebarSalesWarehouseTransferNotesIndexRoute:
    AppAuthedSidebarSalesWarehouseTransferNotesIndexRoute,
  AppAuthedSidebarScentingWarehouseLogIndexRoute:
    AppAuthedSidebarScentingWarehouseLogIndexRoute,
  AppAuthedSidebarScentingWarehouseLotsIndexRoute:
    AppAuthedSidebarScentingWarehouseLotsIndexRoute,
  AppAuthedSidebarScentingWarehouseStockInNotesIndexRoute:
    AppAuthedSidebarScentingWarehouseStockInNotesIndexRoute,
  AppAuthedSidebarScentingWarehouseStockOutNotesIndexRoute:
    AppAuthedSidebarScentingWarehouseStockOutNotesIndexRoute,
  AppAuthedSidebarScentingWarehouseWithdrawalNotesIndexRoute:
    AppAuthedSidebarScentingWarehouseWithdrawalNotesIndexRoute,
  AppAuthedSidebarSettingsRolesIndexRoute:
    AppAuthedSidebarSettingsRolesIndexRoute,
  AppAuthedSidebarSortingWarehouseLotsIndexRoute:
    AppAuthedSidebarSortingWarehouseLotsIndexRoute,
  AppAuthedSidebarSortingWarehouseStockInNotesIndexRoute:
    AppAuthedSidebarSortingWarehouseStockInNotesIndexRoute,
  AppAuthedSidebarSortingWarehouseStockOutNotesIndexRoute:
    AppAuthedSidebarSortingWarehouseStockOutNotesIndexRoute,
  AppAuthedSidebarSortingWarehouseWithdrawalNotesIndexRoute:
    AppAuthedSidebarSortingWarehouseWithdrawalNotesIndexRoute,
  AppAuthedSidebarAgriculturalMaterialsStockInNotesIdEditRoute:
    AppAuthedSidebarAgriculturalMaterialsStockInNotesIdEditRoute,
  AppAuthedSidebarAgriculturalMaterialsStockOutNotesIdEditRoute:
    AppAuthedSidebarAgriculturalMaterialsStockOutNotesIdEditRoute,
  AppAuthedSidebarPackagingWarehouseStockInNotesIdEditRoute:
    AppAuthedSidebarPackagingWarehouseStockInNotesIdEditRoute,
  AppAuthedSidebarPackagingWarehouseStockOutNotesIdEditRoute:
    AppAuthedSidebarPackagingWarehouseStockOutNotesIdEditRoute,
  AppAuthedSidebarSalesWarehouseStockInNotesIdEditRoute:
    AppAuthedSidebarSalesWarehouseStockInNotesIdEditRoute,
  AppAuthedSidebarSalesWarehouseStockOutNotesIdEditRoute:
    AppAuthedSidebarSalesWarehouseStockOutNotesIdEditRoute,
  AppAuthedSidebarSalesWarehouseTransferNotesIdEditRoute:
    AppAuthedSidebarSalesWarehouseTransferNotesIdEditRoute,
  AppAuthedSidebarScentingWarehouseStockInNotesIdEditRoute:
    AppAuthedSidebarScentingWarehouseStockInNotesIdEditRoute,
  AppAuthedSidebarScentingWarehouseStockOutNotesIdEditRoute:
    AppAuthedSidebarScentingWarehouseStockOutNotesIdEditRoute,
  AppAuthedSidebarSortingWarehouseStockInNotesIdEditRoute:
    AppAuthedSidebarSortingWarehouseStockInNotesIdEditRoute,
  AppAuthedSidebarSortingWarehouseStockOutNotesIdEditRoute:
    AppAuthedSidebarSortingWarehouseStockOutNotesIdEditRoute,
}

const AppAuthedSidebarRouteWithChildren =
  AppAuthedSidebarRoute._addFileChildren(AppAuthedSidebarRouteChildren)

interface AppAuthedSaleRouteChildren {
  AppAuthedSaleDisplayRoute: typeof AppAuthedSaleDisplayRoute
  AppAuthedSaleIndexRoute: typeof AppAuthedSaleIndexRoute
}

const AppAuthedSaleRouteChildren: AppAuthedSaleRouteChildren = {
  AppAuthedSaleDisplayRoute: AppAuthedSaleDisplayRoute,
  AppAuthedSaleIndexRoute: AppAuthedSaleIndexRoute,
}

const AppAuthedSaleRouteWithChildren = AppAuthedSaleRoute._addFileChildren(
  AppAuthedSaleRouteChildren,
)

interface AppAuthedRouteChildren {
  AppAuthedSidebarRoute: typeof AppAuthedSidebarRouteWithChildren
  AppAuthedCustomerDisplayRoute: typeof AppAuthedCustomerDisplayRoute
  AppAuthedSaleRoute: typeof AppAuthedSaleRouteWithChildren
  AppAuthedStationRoute: typeof AppAuthedStationRoute
  AppAuthedStationProductionRoute: typeof AppAuthedStationProductionRoute
  AppAuthedStationWarehouseRoute: typeof AppAuthedStationWarehouseRoute
  AppAuthedSupportTRefRoute: typeof AppAuthedSupportTRefRoute
}

const AppAuthedRouteChildren: AppAuthedRouteChildren = {
  AppAuthedSidebarRoute: AppAuthedSidebarRouteWithChildren,
  AppAuthedCustomerDisplayRoute: AppAuthedCustomerDisplayRoute,
  AppAuthedSaleRoute: AppAuthedSaleRouteWithChildren,
  AppAuthedStationRoute: AppAuthedStationRoute,
  AppAuthedStationProductionRoute: AppAuthedStationProductionRoute,
  AppAuthedStationWarehouseRoute: AppAuthedStationWarehouseRoute,
  AppAuthedSupportTRefRoute: AppAuthedSupportTRefRoute,
}

const AppAuthedRouteWithChildren = AppAuthedRoute._addFileChildren(
  AppAuthedRouteChildren,
)

interface AppRouteChildren {
  AppAuthedRoute: typeof AppAuthedRouteWithChildren
  AppSettingsZaloCallbackRoute: typeof AppSettingsZaloCallbackRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAuthedRoute: AppAuthedRouteWithChildren,
  AppSettingsZaloCallbackRoute: AppSettingsZaloCallbackRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  GrowerAreasIdRoute: GrowerAreasIdRoute,
  TraceCodeRoute: TraceCodeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
